/* eslint-disable no-unused-vars */

import { notification } from 'shared-ui/assets'
import { SpiritualAssesmentRequest } from './../../api'
import {
  soulReportExplore,
  palmRead,
  faceReadingExplore,
  torotReadingExplore
} from 'shared-ui/assets'
import { AI_TOOL_IDS } from '..'
import { Subscript } from 'lucide-react'
const RECAPTCHA_KEY = '6LfhW70rAAAAAGIbC46sBcU18KbY0UBmVOmZ5jzo'

let languageData

const createSafeObject = () =>
  new Proxy(
    {},
    {
      get(target, prop) {
        if (prop === Symbol.toPrimitive) return () => ''
        if (prop === 'toString') return () => ''
        if (prop === 'valueOf') return () => ''
        if (!(prop in target)) {
          target[prop] = createSafeObject()
        }
        return target[prop]
      }
    }
  )

export let ETERNAL_CONFIG = {}
export let SUPER_APP_CONFIG = {}
export let subscriptionMessages = {}
export let POPUP_MESSAGE = {}
export let FEEDBACK_TEXT = {}
export let REPORT_TEXT = {}
export let UPDATE_EMAIL_TEXT = {}
export let PROMO_SCREEN_TEXT = {}
export let PASSWORD_RESET = {}
export let UPDATE_PASSWORD_TEXT = {}
export let SUBSCRIPTION_CANCELLED_INFO = {}
export let CANCEL_SUBSCRIPTION_TEXT = {}
export let NOTIFICATION_TEXT = {}
export let PROFILE_CONSTANTS = {}
export let OTP_TEXT = {}
export let FOLLOWER_LIST_CONSTANTS = {}
export let DELETE_ACCOUNT_CONFIRM = {}
export let RESPONSE_STATUS = {}
export let DASHBOARD_TABS = {}
export let DASHBOARD_MESSAGES = {}
export let LOGIN_PAGE_INFO = {}
export let BACK_BUTTON_TITLE = {}
export let PLAN_VALIDITY = {}
export let HOW_IT_WORKS = {}
export let GenderOptions = []
export let VoiceGender = []
export let toolConfig = {}
export let DESCLAIMER_TEXT = {}
export let TEXT_TO_IMAGE_AND_VIDEO = {}
export let REWARD_LABELS = {}
export let VOICE_REMIX = {}
export let ACTION_GENERATION = {}
export let MOTION_CONTROL = {}
export let WORKSPACE_BOTTOM_SHEET = {}
export let LOGIN_PAGE_LABEL = {}
export let CONTACT_LABEL = {}
export let MUSIC_MODAL = {}
export let AUDIO_DRAWER_LABELS = {}
export let IMAGE_TO_VIDEO_COPY = {
  HINTS: [],
  DURATIONS: []
}

export const DRAFTS_EMPTY_STATE = {
  TITLE: 'No Drafts Yet',
  SUBTITLE: 'Start creating and your works-in-progress show up here.',
  CTA_BUTTON: 'Start Creating'
}

export const DEFAULT_FALLBACK_TRACK = {
  id: '9e7a70c5-72ad-4de9-a11d-656da497e085',
  title: 'Kadamizhiyil Kamaladalam',
  primary_artist: 'Suresh Peters, Suresh Peters, Mano, Swarnalatha, Kaithapram Damodaran Namboothiri, Kaithapram Damodaran Namboothiri',
  actors: 'Suresh Gopi, Dileep, Lal, Kavya Madhavan, Geetu Mohandas, Samyuktha Varma',
  album: 'Thenkasipattanam',
  genre: 'Soundtrack (Malayalam)',
  language: 'Malayalam',
  durationFormatted: '4:18',
  label: 'Sony Music Entertainment',
  playback_url: 'https://sony-media-dev.erosuniverse.com/assets/fbfa117b-72ad-43c2-bf89-d01f4b5f5211/A2/mp3/72520630.12206.mp3'
}

export const TAG_VARIANTS = {
  blue: 'bg-[#2B7FFF33] text-[#8EC5FF] border-[#2B7FFF4D]',
  purple: 'bg-[#8E51FF33] text-[#C4B4FF] border-[#8E51FF4D]',
  green: 'bg-[#00BC7D33] text-[#5EE9B5] border-[#00BC7D4D]',
  red: 'bg-[#FB2C3633] text-[#FFA2A2] border-[#FB2C364D]',
  yellow: 'bg-[#FFB80033] text-[#FFE082] border-[#FFB8004D]'
}

export let TEXT_TO_IMAGE_HELP_CENTER = {
  FIND_STEPS: [],
  CREATE_STEPS: [],
  ASPECT_RATIO_POINTS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let VOICE_CLONE_HELP_CENTER = {
  FIND_POINTS: [],
  OPTIONS: [],
  GENERATE_STEPS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let IMAGE_TO_VIDEO_HELP_CENTER = {
  FIND_POINTS: [],
  CREATE_STEPS: [],
  DESCRIPTION_IMPORTANCE_POINTS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let TALKING_AVATAR_HELP_CENTER = {
  FIND_POINTS: [],
  CREATE_STEPS: [],
  VOICE_GUIDELINES: [],
  TEXT_WITHOUT_VOICE_POINTS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let TEXT_TO_VIDEO_HELP_CENTER = {
  FIND_POINTS: [],
  CREATE_STEPS: [],
  STYLE_DURATION_POINTS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let COLORIZE_HELP_CENTER = {
  FIND_POINTS: [],
  CREATE_STEPS: [],
  PRESET_SELECT_POINTS: [],
  MODE_SELECT_POINTS: [],
  TIPS: [],
  HELP_POINTS: []
}
export let MOTION_CONTROL_HELP_CENTER = {
  MAIN_TITLE: '',
  FOR_BEST_RESULTS: '',
  TITLE: '',
  DESCRIPTION: '',
  CREATE_TITLE: '',
  CREATE_STEPS: [],
  REFERENCE_VIDEO_TITLE: '',
  REFERENCE_VIDEO_POINTS: [],
  CHARACTER_IMAGE_TITLE: '',
  CHARACTER_IMAGE_POINTS: [],
  UPLOAD_OWN_VIDEO_TITLE: '',
  UPLOAD_OWN_VIDEO_DESC: '',
  UPLOAD_OWN_VIDEO_POINTS: [],
  GENERATION_TIME_TITLE: '',
  GENERATION_TIME_DESC: '',
  GENERATION_TIME_POINTS: [],
  ORIGINAL_IMAGE_CHANGE_TITLE: '',
  ORIGINAL_IMAGE_CHANGE: '',
  TIPS_TITLE: '',
  TIPS: [],
  HELP_TITLE: '',
  HELP_POINTS: []
}
export let COOKIE_CONSENT = {}
export const CONSENT_CONFIG = {
  PAGE_TITLE: 'Consent & Permissions',
  PAGE_DESCRIPTION:
    'Review the apps, permissions, and data settings connected to your account.',
  TAB_MINI_APP_CONSENTS: 'Mini app consents',
  TAB_CONSENT_HISTORY: 'Consent history',
  SECTION_MINI_APP_TITLE: 'MINI APP CONSENTS',
  SECTION_MINI_APP_DESC:
    'Turn an app off if you no longer want to use it. Turning it back on shows its notice again.',
  LOADING_AVAILABLE_CONSENTS: 'Loading available consents...',
  NO_CONSENTS_AVAILABLE: 'No consents available.',
  FAILED_LOAD_AVAILABLE: 'Failed to load available consents.',
  RETRY: 'Retry',
  SECTION_HISTORY_TITLE: 'CONSENT HISTORY',
  LOADING_HISTORY: 'Loading consent history...',
  NO_HISTORY_AVAILABLE: 'No consent history records available.',
  FAILED_LOAD_HISTORY: 'Failed to load consent history.',
  KEEP_SCROLLING_HINT: 'Keep scrolling to enable Agree',
  REQUIRED: 'Required',
  OPTIONAL: 'Optional',
  AGREE_AND_CONTINUE: 'Agree and continue',
  WITHDRAW_CONSENT: 'Withdraw consent',
  WITHDRAWING: 'Withdrawing...',
  FAILED_WITHDRAW: 'Failed to withdraw consent. Please try again.',
  FAILED_SAVE_CONSENT: 'Failed to save consent. Please try again.',
  WELLNESS_FOOTER_NOTE:
    'Read the summary and tick the first box to continue. We store the time you agreed and the terms version, nothing else from this screen.',
  CREATE_FOOTER_NOTE: 'Withdraw consent or use your rights in Settings › Privacy & Permissions.'
}

export const CONSENT_STRINGS = CONSENT_CONFIG

export let BUY_CREDITS = {}
export let TEXT_TO_VIDEO = {}
export let GUIDED_TOUR_AND_QUICK_TIPS = {}
export let CREDITS_NOT_ENOUGH_ERROR = {
  NOT_ENOUGH_CREDITS: 'Not enough credits',
  NOT_ENOUGH_CREDITS_DESC: 'You don’t have enough credits for this action. Top up now to continue creating.',
  UPGRADE_CREDITS: 'Upgrade',
  TOP_UP_CREDITS: 'Top-Up Credits',
  INSUFFICIENT_CREDITS: 'insufficient credits'
}
export let PROCESSING_INDICATOR = {}
let PAGE_NAME = {}
export const STABLE_PAGE_NAME = {
  Suggestedforyou: 'Suggestedforyou',
  PopularMovies: 'PopularMovies',
  PopularCharacters: 'PopularCharacters'
}
let THEME_COPY = {}
let THEME_OPTIONS = {}
let IMAGE_ALT = {}
let NOTIFICATION_DISABLE_MESSAGES = {}
let VERIFY_SIGNUP_DATA = {}
let FOOTER_LINKS = {
  footerMsg: 'By continuing, you agree to our ',
  termsAndCondition: 'terms of service',
  privacyPolicy: 'privacy policy',
  cookiePolicy: 'cookie policy',
  refundPolicy: 'Refund policy',
  RECAPTCHA: 'This site is protected by reCAPTCHA and the Google ',
  GOOGLE: 'Google',
  TERMS: 'Privacy Policy and Terms of Service apply.'
}
let INVITE_MESSAGES = {}
export let FAQ_CONSTANTS = {}
let PUBLISH_PRIVATE_MESSAGE = {}
export let MODAL_INFO = {}
export let SETTINGS_LABELS = {}
export let MULTIPLE_OUTPUT_LABELS = {}
export let SETTINGS_SECTIONS = {}
export let FILTER_TEXT = {}
export let VoiceLanguage = []
export let TOAST_MSG = {}
export let CARD_DETAILS = {}
export let SUCCESS_MESSAGE = {}
export let PASSWORD_VALIDATION = {}
export let WORKSPACE_RENAME = {}
export let ACCOUNT_CREATION_SUCCESS = {}
export let SUPER_APP_FOOTER = []
export let SPLASH_SCREEN_TEXT = {}
let PAYMENT_PAGE_INFO = {}
let STATUS = {}
let QUEUE_NOTIFICATION = {}
export let EROS_LABEL = ''
export let NO_ACTIVE_PLAN = ''
export let HARDCODED_STRINGS = {}
export let NEW_SIDE_POPUP = {}
let HEADER = {}
let PAGE_LABELS = {}
let TAB_LABELS = {}
let TABS = []
let BUTTON_LABELS = {}
let SIDE_POPUP = {}
let BACK_TO_SIGN_IN = ''
let SPLASH_SESSION_KEY = 'showSplash'
let USER_UPLOAD = {}
let COMMON_MESSAGES = {}
let ALT_SPLASH_LOGO = 'Eros Universe Logo'
let SEARCH_COPY = {}
let MY_WALLET_INFO = {}
let SEARCH_TABS = {}
let SEARCH_TAB_LIST = []
let KEYWORDS = {}
let FALLBACK_DATA = {}
let DELETE_ACCOUNT_TEXT = {}
let BLOCKED_USER_TEXT ={}
let PICK_FROM_LIST = {}
let ERROR_MESSAGES = {}
let FOLLOW_DETAILS = {}
let SUBSCRIPTION_PLAN_INFO = {}
let SUBSCRIPTION_STATUS = {}
let SUBSCRIPTION_PLAN_TABLE_INFO = {}
let AYMENT_PAGE_INFO = {}
let PROFILE_PAGE = {}
let PUBLISH_BAR = {}
let REMIX_BOTTOMSHEET = {}
let REGISTER_PAGE_DATA = {}
let EDIT_PROFILE_PAGE = {}
let INVITE_STATUS_MESSAGES = {}
let VOICE_CLONE = {}
let TALKING_AVATAR = {}
let VOICE_REMIX_TOOLTIP = {}
let DASHBORD_CONTENT={}
export let CHAT_FEEDBACK_OPTIONS = []
export let ERROR_CODES = {}
export let MODERATION_PAGE = {}

export let APP_VERSION = 'v 2.1.1'

const VERSION_STORAGE_KEY = 'app_version'
const BUILD_NUMBER_STORAGE_KEY = 'app_build_number'

async function loadAppVersion() {
  if (typeof window === 'undefined') return
  try {
    const resp = await fetch('/version.json', { cache: 'no-store' })
    if (!resp || !resp.ok) return
    const data = await resp.json()
    const rawVersion = data?.version || data?.app_version || APP_VERSION
    if (!rawVersion) return
    const remoteVersion = String(rawVersion).replace(/^v\s*/i, '')
    const buildNumber = data?.build_number
    const versionWithBuild = buildNumber ? `${remoteVersion}(${buildNumber})` : remoteVersion
    localStorage.setItem(VERSION_STORAGE_KEY, versionWithBuild)
    if (buildNumber) {
      localStorage.setItem(BUILD_NUMBER_STORAGE_KEY, buildNumber)
    }
    APP_VERSION = `v ${versionWithBuild}`
  } catch (e) { }
}

if (typeof window !== 'undefined') {
  void loadAppVersion()
}

export const applyTranslations = (apiData, language) => {
  languageData = apiData?.data

  ETERNAL_CONFIG = {
    ...ETERNAL_CONFIG,
    EROS_UNIVERSE: languageData?.eros_universe || 'EROS Universe',
    ETERNAL_AI: languageData?.eternal_chat_title || 'Eternal AI',
    START_YOUR_ETERNAL_JOURNEY:
      languageData?.start_your_eternal_journey || 'Start Your Eternal Journey',
    WELCOME_TO: languageData?.welcome_to || 'Welcome to',
    BEGIN_JOURNEY: languageData?.begin_journey || 'Begin your journey',
    CONTINUE: languageData?.continue || 'Continue',
    BACK: languageData?.back || 'Back',
    SPLASH_SCREEN_TITLE:
      languageData?.eternal_landing_welcome_title || 'Founder’s Welcome',
    WELCOME_TO_ETERNAL:
      languageData?.eternal_landing_welcome || 'Welcome To Eternal Ai',
    ONBOARDING_DESC:
      languageData?.eternal_landing_sub_intro ||
      'Decode your aura. Track your vibe. Align with your cosmic path. ✨ You’ll unlock:',
    ONBOARDING_POINTS: [
      languageData?.vibe_score || 'Your Vibe Score (Vibe Unlocked)',
      languageData?.aura_mood || 'Aura Mood (Farm your Aura)',
      languageData?.star_map || 'Star Map (Sync with galaxy)',
      languageData?.flame_score || 'Flame Score (Inner Flame revealed)',
      languageData?.health_and_longevity_blueprint ||
      'Health & Longevity Blueprint'
    ],
    START_YOUR_JOUNRNEY:
      languageData?.start_your_soul_jounrney || 'Start your soul journey',
    CREATE_YOUR_SOUL_JOURNEY:
      languageData?.eternal_soul_profile_title || 'Create Your Soul Profile',
    GENDER: languageData?.gender || 'Gender',
    PLACE_OF_BIRTH:
      languageData?.eternal_soul_profile_place_of_birth || 'Place of birth',
    CURRENT_LOCATION: languageData?.current_location || 'Current Location',
    DATE_OF_BIRTH:
      languageData?.eternal_soul_profile_date_of_birth || 'Date of birth',
    TIME_OF_BIRTH:
      languageData?.eternal_soul_profile_time_of_birth || 'Time of birth',

    SPIRITUAL_DASHBOARD_HERO_TITLE:
      languageData?.superapp_home_eternal_title || 'Eternal',
    SPIRITUAL_DASHBOARD_WELCOME_BUTTON:
      languageData?.spiritual_dashboard_welcome_button ||
      'View Your Rasi Chart',
    SPIRITUAL_DASHBOARD_WELCOME_QUOTE:
      languageData?.spiritual_dashboard_welcome_quote ||
      'Your aura is a map, your spirit a compass — step into EternaL and unlock the blueprint of your infinite journey.',
    SPIRITUAL_DASHBOARD_WELCOME_MOBILE_QUOTE:
      languageData?.spiritual_dashboard_welcome_mobile_quote ||
      'Reset starts with one mindful minute',
    SPIRITUAL_DASHBOARD_WELCOME_GREETING: languageData?.welcome || 'Welcome',
    UPLOAD_FILE: languageData?.upload_file || 'Upload File'
  }

  MODERATION_PAGE = {
    REJECT_REASON_LABEL: languageData?.moderation_reject_reason_label || 'Reject Reason',
    REJECT_REASON_CONTENT: languageData?.moderation_reject_reason_content || 'Your content has been rejected due to inappropriate material.',
    COMMENT_LABEL: languageData?.moderation_comment_label || 'Enter your comment',
    SUBMIT_BTN: languageData?.submit || 'Submit',
    TITLE: languageData?.moderation_title || 'Your Content Has Been Rejected',
    APPEAL_SUCCESS: languageData?.moderation_appeal_success || 'Content moderation fields updated successfully',
    APPEAL_FAILED: languageData?.moderation_appeal_failed || 'Failed to update content moderation fields. Please try again.',
    LOAD_FAILED: languageData?.moderation_load_failed || 'Failed to load moderation content.',
    GO_BACK: languageData?.create_studio_go_back_button || 'Go Back',
    SUBMITTING: languageData?.discover_report_sheet_submitting || 'Submitting...',
    GENERATING : languageData?.queue_notification_widget_generating || 'Generating',
    COMMENT_PLACEHOLDER: languageData?.moderation_comment_placeholder || 'Type your appeal comment here...',
    TOOL_NAMES: {
      FACE_SWAP: languageData?.create_face_swap_screen || 'Face Swap',
      COLORISE: languageData?.colorise || 'Colorise',
      SCENE_SWAP: languageData?.scene_swap || 'Scene Swap',
      BACKGROUND_CHANGE: languageData?.scene_swap || 'Scene Swap',
      TEXT_TO_IMAGE: languageData?.ai_tool_text_to_image_title || 'Text to Image',
      TEXT_TO_VIDEO: languageData?.ai_tool_text_to_video_title || 'Text to Video',
      VOICE_REMIX: languageData?.ai_tool_voice_remix_title || 'Voice Remix',
      VOICE_CLONE: languageData?.voice_clone || 'Voice Clone',
      TALKING_AVATAR: languageData?.ai_tool_photo_avatar_talking_title || 'Talking Avatar',
      ACTION_GENERATION: languageData?.ai_tool_action_generation_title || 'Action Generation',
      IMAGE_TO_VIDEO: languageData?.ai_tool_image_to_video_with_camera_movement_title || 'Image to Video',
      MOTION_CONTROL: languageData?.motion_control_title || 'Motion Control'
    }
  }

  SUPER_APP_CONFIG = {
    UPLOADED_IMAGE: languageData?.uploaded_image || 'Uploaded Image',
    DRAG_DROP_FILE: languageData?.drag_drop_file || 'Drag and Drop files',
    OR: languageData?.welcome_to || 'Welcome to',
    BROWSE_FILE: languageData?.browse_file || 'Browse file',
    FROM_YOUR_COMPUTER: languageData?.from_your_computer || 'from your computer',
    SUPPORTED_FORMATS:
      languageData?.supported_formats || 'Supported format : XLS, XLSX',
    START_READING_FACE:
      languageData?.face_reading_start || 'Start Face Reading', // letters problem
    CLOSE: languageData?.close || 'close',
    CANCEL: languageData?.cancel || 'Cancel',
    UPLOAD: languageData?.palmistry_upload || 'Upload',
    UPLOAD_DESC:
      languageData?.face_reading_upload_hint || 'Tap to upload or take a photo',

    COPYRIGHT_MSG:
      languageData?.copyright_msg_eternal ||
      '© 2025 EROS Universe. All Rights Reserved',
    SpiritualAssesment_Question:
      languageData?.eternal_spiritual_assessment_greeting ||
      'Hey %, What do you want from Eternal AI?',
    SpritualExploreMorText:
      languageData?.eternal_spiritual_assessment_first_report ||
      'Your first Soul Reports are ready. From now on, your reports will live in the Spiritual Page.',
    TO_EXPLORE_MORE:
      languageData?.eternal_spiritual_assessment_explore_more ||
      'To Explore More',
    Continue_to_Spiritual_Journey:
      languageData?.eternal_spiritual_assessment_continue ||
      'Continue to Spiritual Journey',
    SpiritualAssesment_LastChatOptions: [
      {
        text:
          languageData?.spiritualassesment_lastchatoptions_1 ||
          'Explore Current Report',
        path: 'continue'
      },
      {
        text:
          languageData?.spiritualassesment_lastchatoptions_2 ||
          'See more reports',
        path: '/eternal/welcomeChat'
      },
      {
        text:
          languageData?.eternal_spiritual_assessment_continue ||
          'Continue to Spiritual Journey',
        path: '/eternal/ai-explore'
      }
    ],
    exploreScreenOptions: [
      {
        title:
          languageData?.eternal_spiritual_assessment_soul_reports ||
          'Soul Reports',
        subtitle:
          languageData?.explore_soul_reports_desc ||
          'A deep read of your inner blueprint the energies and patterns shaping you.',
        image: `${soulReportExplore}`
      },
      {
        title:
          languageData?.eternal_spiritual_assessment_palmistry || 'Palmistry',
        subtitle:
          languageData?.explore_palmistry_desc ||
          'Your hands reveal your natural tendencies and how you navigate life.',
        image: `${palmRead}`
      },
      {
        title: languageData?.face_reading_title || 'Face Reading',
        subtitle:
          languageData?.explore_face_reading_desc ||
          'Your features reflect your nature offering cues about personality and expression.',
        image: `${faceReadingExplore}`
      },
      {
        title: languageData?.tarot_reading_title || 'Tarot Reading',
        subtitle:
          languageData?.explore_tarot_reading_desc ||
          'Symbolic guidance that mirrors your inner state and brings clarity to the moment',
        image: `${torotReadingExplore}`
      }
    ],
    chatBot_Welcome_Title:
      languageData?.eternal_chat_intro || 'Hi, I’m Eternal AI',
    chatBot_Welcome_SubTitle:
      languageData?.eternal_chat_help || 'How can I help you today?',
    DISCOVER_MORE_INSIGHTS_TEXT:
      languageData?.discover_more_insights_text ||
      'Discover More insights into your Vibrational frequency and interact to get more deeper insights',
    CONTINUE_TO_CHAT: languageData?.continue_to_chat || 'Continue to Chat',

    HARMONY_YOUR_INFO:
      languageData?.harmony_index_your_information || 'Your Information',
    HARMONY_YOUR_NAME: languageData?.harmony_index_your_name || 'Your Name',
    HARMONY_PARTNER_INFO:
      languageData?.harmony_index_partner_information || 'Partner Information',
    HARMONY_ENTER_PARTNER_DETAILS:
      languageData?.enter_partner_details || 'Enter Partner’s Details',
    HARMONY_PARTNER_NAME: languageData?.partner_name || 'Partner`s Name',
    HARMONY_WHAT_ANALYZE:
      languageData?.harmony_index_what_we_analyze || 'What We’ll Analyze',
    HARMONY_ANALYZE_INPUT_TEXT: [
      languageData?.provides_personalized_relationship_insights ||
      'Provides personalized relationship insights',
      languageData?.identifies_relationship_strengths ||
      'Identifies relationship strengths.',
      languageData?.identifies_relationship_challenges ||
      'Identifies relationship Challenges',
      languageData?.suggest_growth_opportunities ||
      'Suggest growth opportunities'
    ],
    HARMONY_BUTTON:
      languageData?.harmony_index_analyze_compatibility ||
      'Analyze Compatibility',

    RELATIONSHIP_COMPATIBILITY:
      languageData?.harmony_index_relationship_compatibility ||
      'Relationship Compatibility',
    HARMONY_REL_STRENGTH:
      languageData?.harmony_index_relationship_strengths ||
      'Relationship Strengths',

    ENTER_YOUR_NAME:
      languageData?.tarot_reading_enter_name || 'Enter Your Name',
    START_YOUR_TAROT_READING:
      languageData?.tarot_reading_start || 'Start Your Tarot Reading',
    ENTER_YOUR_DETAILS:
      languageData?.enter_your_details || 'Enter Your Details',
    SPREAD_CARD:
      languageData?.tarot_reading_three_card_spread || 'Three-Card Spread',
    SELECT_CARDS: languageData?.select_cards || 'Select 3 cards from the deck',
    FLIP_CARDS: languageData?.flip_cards_to_reveal || 'Flip Cards to reveal',
    CARDS_DECK_TIP:
      languageData?.tarot_reading_instruction_select ||
      'When you’re ready, tap \\n & Select 3 cards from deck',
    THREE_CARDS_TIP:
      languageData?.tarot_reading_instruction_reveal ||
      'When you’re ready, \\n  tap to reveal the card',
    TIP:
      languageData?.tarot_reading_instruction_single_card_tap ||
      'Tap any card to reveal its detailed meaning and personal insights',
    REVEALINSTRUCTION:
      languageData?.tarot_reading_instruction_reveal ||
      'When you’re ready, \\n  tap to reveal the card',

    DETAILS: languageData?.superapp_userprofile_details || 'Details',
    UPLOAD_YOUR_PALM: languageData?.upload_your_palm || 'Upload Your Palm',
    DISCOVER_INSIGHTS:
      languageData?.discover_insights ||
      'Discover insights into your personality, relationship, and future with our AI-powered palm reading technology',
    UPLOAD_PALM_PHOTO: languageData?.upload_your_palm || 'Upload Your Palm',
    START_PALM_READING:
      languageData?.palmistry_start_reading || 'Start Palm Reading',
    PALM_PREVIEW: languageData?.palm_preview || 'Palm Preview',
    ANALYZE_PALM:
      languageData?.palmistry_loading_title || 'Analyzing your palm lines', // letters problem
    PLEASE_WAIT_OUR_AI_READING:
      languageData?.please_wait_our_ai_reading ||
      'Please wait while our AI generates your personalized reading.',
    IMAGE_ERROR: languageData?.image_error || 'Image error',
    UPLOAD_YOUR_FACE:
      languageData?.face_reading_upload_prompt || 'Upload Your Face',
    UPLOAD_FACE_PHOTO:
      languageData?.face_reading_upload_button || 'Upload Face Photo',
    START_FACE_READING:
      languageData?.face_reading_start || 'Start Face Reading',
    FACE_PREVIEW: languageData?.face_reading_preview || 'Face Preview',
    ANALYZE_FACE:
      languageData?.analyze_face_lines || 'Analyzing Your Face Lines',
    PALMISTRY_ANALYSIS:
      languageData?.palmistry_analysis || 'Palmistry Analysis',
    FACE_ANALYSIS: languageData?.face_analysis || 'Face Analysis',
    audio_access_msg:
      languageData?.eternal_spiritual_assessment_mic_permission ||
      'Enable microphone access in settings',
    RASHI_TITLE: languageData?.rashi_title || 'Rashi Chart',
    RASHI_RASHISUB: languageData?.rashi_rashisub || 'Individual Chart',
    RASHI_NAVATITLE: languageData?.rashi_navatitle || 'Navamsha Chart',
    RASHI_NAVASUB: languageData?.rashi_navasub || 'Life Partner Chart',
    REPORT: languageData?.post_report_title || 'Report',
    RECOMMENDATIONS: languageData?.recommendations || 'Recommandations',
    REPORT_FOOTER_BTN:
      languageData?.eternal_chat_back_to_spiritual || 'Back to Spiritual',
    VIBRATIONAL_CARD_PERCENT: '%',
    VIBRATIONAL_CARD_HZ: 'HZ',
    PRIVACY_POLICY: languageData?.privacy_policy || 'Privacy Policy',
    TERMS_AND_CONDITIONS:
      languageData?.terms_and_conditions || 'Terms & Conditions',
    REFOUND_POLICY: languageData?.refund_policy || 'Refund Policy',
    ETERNAL_REPORT:
      languageData?.superapp_userprofile_eternal_reports || 'Eternal Reports',
    GUIDELINES: languageData?.guidelines || 'Guidelines',
    Image_Upload_Guidelines:
      languageData?.eternal_spiritual_assessment_guidelines_text ||
      '<div class="image-upload-guidelines"><ul><li>Try to upload clear, well-lit photos without heavy blur or pixelation.</li><li>Only upload images you have the right to use.</li><li>Avoid uploading offensive, violent, or adult content (violates our community guidelines).</li></ul><p><strong>Recommended Image Specs</strong></p><ul><li><strong>Format:</strong> JPG or PNG</li><li><strong>Size:</strong> Up to 10 MB</li><li><strong>Resolution:</strong> At least 512 × 512 pixels for best results</li></ul></div>',
    GenderOptions: [
      {
        value: languageData?.avatar_gender_male || 'Male',
        label: languageData?.avatar_gender_male || 'Male'
      },
      {
        value: languageData?.avatar_gender_female || 'Female',
        label: languageData?.avatar_gender_female || 'Female'
      },
      {
        value: 'O',
        label: languageData?.profile_prefer_not_say || 'Prefer not to say'
      }
    ],
    HARMONY_FORM_DESCRIPTION:
      languageData?.harmony_index_relationship_description ||
      'Discover your spiritual and emotional compatibility with your partner using vedic astrology',
    INPUT_PLACEHOLDER: languageData?.input_placeholder || 'Enter a prompt here'
  }

  COOKIE_CONSENT = {
    BANNER_TITLE: languageData?.cookie_banner_title || 'About Cookies on this site',
    PRIVACY_POLICY_LINK: languageData?.cookie_privacy_policy_link || 'privacy policy',
    ACCEPT_ALL: languageData?.cookie_accept_all || 'Accept All',
    REJECT_NON_ESSENTIAL: languageData?.cookie_reject_non_essential || 'Reject Non-Essential',
    MANAGE_PREFERENCES: languageData?.cookie_manage_preferences || 'Manage Preferences',
    CONFIRM_MY_CHOICES: languageData?.cookie_confirm_choices || 'Confirm My Choices',
  }

  SUPER_APP_CONFIG = {
    ...SUPER_APP_CONFIG,
    TOP_CREATORS: languageData?.superapp_home_top_creators || 'Top Creators',
    MORE: languageData?.superapp_search_more || 'More',
    ADD_MUSIC: languageData?.ADD_MUSIC || 'Add Music',
    SELECTED_AVATAR_ALT: languageData?.selected_avatar_alt || 'Selected avatar',
    NO_AVATAR: languageData?.no_avatar || 'No Avatar',
    CHOOSE_AVATAR: languageData?.avatar_choose_avatar || 'Choose Avatar',
    SAVE: languageData?.save || 'Save',
    AVATAR_LOAD_ERROR:
      languageData?.avatar_load_error || 'Failed to load avatars',
    CHOOSE_COUNTRY: languageData?.profile_choose_country || 'Choose country',
    COUNTRY_DONE: languageData?.profile_done || 'Done',
    COUNTRY_INPUT_PLACEHOLDER:
      languageData?.country_input_placeholder || 'Search for country or code',
    CREATE_FACES_DETECTED:
      languageData?.create_faces_detected || 'Faces Detected',
    AUDIO_NOT_AVAILABLE:
      languageData?.audio_not_available || 'Audio is not available',
    CREATE_ORIGINAL_PHOTO:
      languageData?.create_original_photo || 'Original Photo',
    CREATE_REMOVE: languageData?.remove || 'Remove',
    CREATE_QUICK_TIP: languageData?.how_it_works_quick_tip || 'Quick Tip',
    CREATE_HOW_IT_WORKS:
      languageData?.how_it_works_click_here ||
      'Click here to know how it works.',
    CREATE_TYPE_BACKGROUND_IDEA:
      languageData?.create_type_background_idea ||
      'Type in your background idea',
    CREATE_BACKGROUND_PLACEHOLDER:
      languageData?.ai_tool_scene_swap_example ||
      'Example: sunset at the beach',
    CREATE_UPLOAD_IMAGE:
      languageData?.ai_tool_photo_avatar_talking_upload_photo ||
      'Upload an original photo',
    CREATE_UPLOAD_IMAGE_VIDEO:
      languageData?.face_swap_upload_original ||
      'Upload an original photo or video',
    CREATE_COLORIZE_CREDIT:
      languageData?.ai_tool_colorize_button || 'Colorize (% Credits)',
    CREATE_COLORIZE_CREDIT_SINGLE:
      languageData?.create_colorize_credit || 'Colorize (1 Credit)',
    CREATE_TURN_BW_CREDIT:
      languageData?.ai_tool_turn_bw_button || 'Turn B&W % Credit',
    CREATE_SWAP_CREDIT:
      languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)',
    CREATE_SWAP_CREDIT_SINGLE:
      languageData?.ai_tool_generate_credit || 'Generate (1 Credit)',
    CREATE_ENHANCE_CREDIT: languageData?.enhance_credit || 'Enhance (% Credit)',
    CREATE_GENERIC_ERROR:
      languageData?.create_generic_error ||
      'An error occurred. Please try again.',
    CREATE_LOGIN_REQUIRED:
      languageData?.create_login_required || 'Please login to upload',
    CREATE_UPLOAD_TEMPLATE_FAILED:
      languageData?.create_upload_template_failed ||
      'Failed to upload template. Please try again.',
    CREATE_UPLOAD_FILE_FAILED:
      languageData?.create_upload_file_failed ||
      'Failed to upload file. Please try again.',
    CREATE_FACE_SWAP_FAILED:
      languageData?.create_face_swap_failed || 'Face swap failed',
    CREATE_VIDEO_STATUS_ERROR:
      languageData?.create_video_status_error || 'Error checking video status',
    CREATE_IMAGE_STATUS_ERROR:
      languageData?.create_image_status_error || 'Error checking image status',
    CREATE_BACKGROUND_CHANGE_FAILED:
      languageData?.create_background_change_failed ||
      'Background change failed',
    CREATE_OUTPUT_URL_MISSING:
      languageData?.create_output_url_missing || 'Output image url not found.',
    CREATE_TITLE_REQUIRED:
      languageData?.create_title_required || 'Enter title to proceed.',
    CREATE_MULTI_AUDIO_RESTRICTION_MSG:
      languageData?.create_multi_audio_restriction_msg ||
      'This audio cannot be added while another audio track is already in use.',
    CREATE_GALLERY_IMAGE_FAILED:
      languageData?.create_gallery_image_failed ||
      'Failed to use gallery image.',
    CREATE_RESTART_SESSION:
      languageData?.create_restart_session ||
      'Restart your generation session to upload targets',
    CREATE_UPLOAD_IMAGE_REQUIRED:
      languageData?.create_upload_image_required ||
      'Please upload your image to begin face swap',
    CREATE_UPLOAD_TARGET_FAILED:
      languageData?.create_upload_target_failed ||
      'Failed to upload targets. Please try again.',
    CREATE_REGENERATE_FAILED:
      languageData?.create_regenerate_failed ||
      'Failed to regenerate background',
    CREATE_DETECT_IMAGE_FAILED:
      languageData?.create_detect_image_failed || 'Failed to detect image type',
    CREATE_COLORIZE_FAILED:
      languageData?.create_colorize_failed || 'Colorize operation failed',
    CREATE_FACE_SWAP_RETRY:
      languageData?.create_face_swap_retry ||
      'Failed to perform face swap, try again with a new session',
    CREATE_FACE_SWAP_TIPS_TITLE:
      languageData?.create_face_swap_tips_title || 'Tips:',
    CREATE_FACE_SWAP_TIPS_LIST: [
      languageData?.create_face_swap_tip_clear || 'Use clear face photos',
      languageData?.create_face_swap_tip_blur || 'Avoid blurry or dark images',
      languageData?.create_face_swap_tip_lighting ||
      'Better lighting = better results'
    ],
    CREATE_TARGET_ALT: languageData?.create_target_alt || 'Target',
    CREATE_UPLOADED_ALT: languageData?.create_uploaded_alt || 'Uploaded',
    CREATE_THUMBNAIL_ALT: languageData?.create_thumbnail_alt || 'thumbnail',
    CREATE_THUMBNAIL: languageData?.create_thumbnail || 'Thumbnail',
    CREATE_THUMBNAIL_AUTO_FIRST_FRAME: languageData?.create_thumbnail_auto_first_frame || 'Auto - First frame',
    CREATE_THUMBNAIL_AUTO_SELECTED_CREATION: languageData?.create_thumbnail_auto_selected_creation || 'Auto - Selected creation',
    CREATE_THUMBNAIL_SELECTED_FRAME: languageData?.create_thumbnail_selected_frame || 'Selected frame',
    CREATE_THUMBNAIL_CUSTOM_UPLOADED: languageData?.create_thumbnail_custom_uploaded || 'Custom uploaded',
    CREATE_THUMBNAIL_UPLOAD_FROM_DEVICE: languageData?.create_thumbnail_upload_from_device || 'Upload from device',
    CREATE_OUR_COLLECTION:
      languageData?.create_our_collection || 'Our Collection',
    CREATE_BACK_BUTTON_ALT:
      languageData?.create_back_button_alt || 'Back Button',
    CREATE_SUGGESTED_FOR_YOU:
      languageData?.face_swap_suggested_for_you || 'Suggested for you',
    CREATE_MOVIES: languageData?.create_movies || 'Movies',
    CREATE_CHARACTERS: languageData?.create_characters || 'Characters',
    CREATE_VIDEOS: languageData?.superapp_userprofile_videos || 'Videos',
    CREATE_PHOTOS: languageData?.superapp_userprofile_photos || 'Photos',
    CREATE_SELECT: languageData?.face_swap_select || 'Select',
    CREATE_VIDEO_NOT_SUPPORTED:
      languageData?.create_video_not_supported ||
      'Your browser does not support the video tag.',
    CREATE_REGENERATE_IMAGE_FAILED:
      languageData?.create_regenerate_image_failed ||
      'Failed to regenerate image',
    CREATE_REGENERATE_VIDEO_FAILED:
      languageData?.create_regenerate_video_failed ||
      'Failed to regenerate video',
    CREATE_REGENERATE_NOT_SUPPORTED:
      languageData?.create_regenerate_not_supported ||
      'Regeneration is not supported for this type.',
    CREATE_DISCARD_TITLE:
      languageData?.create_discard_title || 'Discard Changes?',
    CREATE_DISCARD_MESSAGE:
      languageData?.create_discard_message ||
      'Are you sure you want to discard your changes? This action cannot be undone.',
    CREATE_DISCARD_SUCCESS:
      languageData?.create_discard_success || 'Creation Discarded',
    CREATE_DISCARD_FAILED:
      languageData?.create_discard_failed || 'Failed to Discard Creation',
    CREATE_CANCEL: languageData?.cancel || 'Cancel',
    CREATE_CONTINUE_EDIT_SUITE: languageData?.continue_to_edit_suite || 'Continue to Edit Suite',
    CREATE_DISCARD: languageData?.ai_tool_discard || 'Discard',
    CREATE_EDIT: languageData?.ai_tool_edit || 'Edit',
    CREATE_EDITING: languageData?.create_editing || 'Editing...',
    CREATE_PUBLISH_UPDATE_SUCCESS:
      languageData?.create_publish_update_success ||
      'Content details updated Successfully!',
    CREATE_PUBLISH_UPDATE_FAILED:
      languageData?.create_publish_update_failed || 'Failed to Publish Image',
    CREATE_NO_CONTENT_FOUND:
      languageData?.create_no_content_found || 'No Content Found',
    CREATE_TITLE_PLACEHOLDER:
      languageData?.ai_tool_title_caption || 'Title/Caption',
    CREATE_TAGS_PLACEHOLDER:
      languageData?.create_tags_placeholder ||
      'Hashtags (Optional, comma separated)',
    CREATE_STATUS_LABEL: languageData?.create_status_label || 'Status:',
    CREATE_STATUS_PUBLIC: languageData?.create_status_public || 'Public',
    CREATE_ALT_FACE_SWAP_OUTPUT:
      languageData?.create_alt_face_swap_output || 'Face Swap Output',
    CREATE_ALT_REWIND: languageData?.create_alt_rewind || 'Rewind',
    CREATE_ALT_FORWARD: languageData?.create_alt_forward || 'Forward',
    CHATGPT_SCREEN_QUICK_TIP_TITLE:
      languageData?.how_it_works_quick_tip || 'Quick Tip',
    CHATGPT_SCREEN_QUICK_TIP_DESCRIPTION:
      languageData?.chatgpt_screen_quick_tip_description ||
      'Get help and learn how to use the chat feature. Click on workspaces to organize your conversations.',
    CHATGPT_SCREEN_CREATE_WORKSPACE_FAILED:
      languageData?.chatgpt_screen_create_workspace_failed ||
      'Failed to create workspace',
    CHATGPT_SCREEN_DELETE_CONVERSATION_FAILED:
      languageData?.chatgpt_screen_delete_conversation_failed ||
      'Failed to delete conversation',
    CHATGPT_SCREEN_GENERIC_ERROR:
      languageData?.play_error_title || 'Something went wrong',
    CHATGPT_SCREEN_DELETING:
      languageData?.chatgpt_screen_deleting || 'Deleting...',
    CHATGPT_SCREEN_COPY_TITLE:
      languageData?.chatgpt_screen_copy_title || 'Copy',
    CHATGPT_SCREEN_LIKE_TITLE:
      languageData?.chatgpt_screen_like_title || 'Like',
    CHATGPT_SCREEN_DISLIKE_TITLE:
      languageData?.chatgpt_screen_dislike_title || 'Dislike',
    CHATGPT_SCREEN_REGENERATE_TITLE:
      languageData?.chatgpt_screen_regenerate_title || 'Regenerate',
    CHATGPT_SCREEN_MORE_OPTIONS_TITLE:
      languageData?.chatgpt_screen_more_options_title || 'More options',
    CHATGPT_SCREEN_ALT_WORKSPACES:
      languageData?.ai_tool_text_to_llm_workspaces || 'Workspaces',
    CHATGPT_SCREEN_ALT_HELP_ICON:
      languageData?.chatgpt_screen_alt_help_icon || 'helpIcon',
    CHATGPT_SCREEN_ALT_SEND: languageData?.chatgpt_screen_alt_send || 'send',
    CHATGPT_SCREEN_ALT_LAUNCH:
      languageData?.chatgpt_screen_alt_launch || 'launch',
    CHATGPT_SCREEN_ALT_AI_RESPONSE_IMAGE:
      languageData?.chatgpt_screen_alt_ai_response_image || 'AI response',
    CHATGPT_SCREEN_ALT_MORE_ICON: languageData?.superapp_search_more || 'More',
    CHATGPT_SCREEN_ALT_RENAME:
      languageData?.ai_tool_text_to_llm_rename || 'Rename',
    CHATGPT_SCREEN_SELECTED_TOOL_NAME:
      languageData?.chatgpt_screen_selected_tool_name || 'ErosGPT',
    CHAT_FEEDBACK_OPTIONS: [
      {
        id: 1,
        label:
          languageData?.chat_feedback_dont_like_output ||
          "Don't like the output"
      },
      {
        id: 2,
        label:
          languageData?.chat_feedback_didnt_follow_instructions ||
          "Didn't follow instructions"
      },
      {
        id: 3,
        label: languageData?.chat_feedback_very_slow || 'Very slow'
      },
      {
        id: 4,
        label:
          languageData?.chat_feedback_others || 'Others (please specify below)'
      }
    ],
    CREATE_CONTENT_PENDING_REVIEW: languageData?.create_content_pending_review || 'Content is pending manual review. Please try again later.',
    CREATE_VALIDATE_CONTENT_FAILED: languageData?.create_validate_content_failed || 'Failed to validate content. Please try again.',
    CREATE_EXPORT_ASSET_FAILED: languageData?.create_export_asset_failed || 'Failed to export the edited asset',
    CREATE_UPLOAD_ASSET_FAILED: languageData?.create_upload_asset_failed || 'Failed to upload the edited asset.',
    CREATE_DRAFT_TITLE_PREFIX: languageData?.create_draft_title_prefix || 'Draft ',
    CREATE_DRAFT_SAVED_SUCCESS: languageData?.create_draft_saved_success || 'Draft saved successfully!',
    CREATE_DRAFT_SAVED_FAILED: languageData?.create_draft_saved_failed || 'Failed to save draft',
    CREATE_REVIEW_PUBLISH_LABEL: languageData?.create_review_publish_label || 'Review & Publish',
    CREATE_AUDIO_PANEL_LABEL: languageData?.create_audio_panel_label || 'Audio',
    CREATE_LOAD_MEDIA_FAILED: languageData?.create_load_media_failed || 'Failed to load media. Please check your network or try again.',
    CREATE_REVIEW_TITLE: languageData?.create_review_title || 'Review',
    CREATE_DRAFT_SAVED: languageData?.create_draft_saved || 'Draft Saved',
    CREATE_SAVING: languageData?.create_saving || 'Saving...',
    CREATE_SAVE_DRAFT: languageData?.create_save_draft || 'Save Draft',
    CREATE_DOWNLOAD: languageData?.create_download || 'Download',
    CREATE_EDIT_CREATION: languageData?.create_edit_creation || 'Edit Creation',
    CREATE_DONE: languageData?.create_done || 'Done',
    CREATE_PUBLISH: languageData?.create_publish || 'Publish',
    CREATE_DISCLAIMER: languageData?.create_disclaimer || 'Disclaimer: This image is AI-generated for creative use only. The tool owners do not claim rights over the original voices or likenesses used.',
    CREATE_LICENSED_CONTENT_TITLE: languageData?.create_licensed_content_title || 'Licensed Content Detected',
    CREATE_LICENSED_CONTENT_DESC: languageData?.create_licensed_content_desc || "The audio used in this video can't be included in downloads because of copyrights rules. Your video will be download successfully, but without sound.",
    CREATE_CONTINUE_DOWNLOAD: languageData?.create_continue_download || 'Continue Download',
    CREATE_CHECKING_SAFETY: languageData?.create_checking_safety || 'Checking safety guidelines...',
    CREATE_CHOOSE_DIFFERENT_TRACK: languageData?.create_choose_different_track || 'Choose a different track',
    CREATE_REPLACE_TRACK: languageData?.create_replace_track || 'Replace Track',
    CREATE_USE_THIS: languageData?.create_use_this || 'Use this',
    CREATE_TAP_TRACK_TO_SELECT: languageData?.create_tap_track_to_select || 'Tap a track to select',
    CREATE_MUSIC_REJECTION_DEFAULT: languageData?.music_rejection_default || "The selected music can't be used for this post due to licensing restrictions. Replace it to continue publishing.",
    CREATE_MUSIC_REJECTION_REASONS: {
      TERRITORY_BLOCKED: languageData?.territory_blocked || 'This track is not licensed for publishing in your region.',
      SONY_NOT_LICENSED: languageData?.sony_not_licensed || 'This track is not in our approved catalogue. Please select a different track.',
      UNLICENSED_LABEL: languageData?.unlicensed_label || 'This track belongs to a label without a platform licence.',
      OVER_60_SECONDS: languageData?.over_60_seconds || 'Licensed tracks can only be used for up to 60 seconds. Please trim your audio.',
      STANDALONE_AUDIO: languageData?.standalone_audio || 'Audio-only content with licensed music is not permitted. Please add a video track.',
      USER_UPLOADED_SONY: languageData?.user_uploaded_sony || 'The audio in your upload is a Sony Music track. Please use a track from the music library.',
      AI_RESTRICTED: languageData?.ai_restricted || 'This track cannot be used with AI tools. Please select a different track.'
    },
    CREATE_ACTION_GENERATION_QUICK_TIP_DESCRIPTION:
      languageData?.create_action_generation_quick_tip_description ||
      'Describe what you want, pick aspect ratio, then Generate.',
    CREATE_ACTION_GENERATION_SELECT_ACTION_ALERT:
      languageData?.create_action_generation_select_action_alert ||
      'Please select an action before generating!',
    CREATE_ACTION_GENERATION_UPLOAD_FIRST_IMAGE_ALERT:
      languageData?.create_action_generation_upload_first_image_alert ||
      'Please upload at least the first image!',
    CREATE_ACTION_GENERATION_GENERATING:
      languageData?.create_action_generation_generating || 'Generating...',
    CREATE_ACTION_GENERATION_GENERATE_CREDIT:
      languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)',
    CREATE_ACTION_GENERATION_STATUS_CHECK_FAILED:
      languageData?.create_action_generation_status_check_failed ||
      'Failed to check generation status',
    CREATE_ACTION_GENERATION_IMAGE_GENERATION_FAILED:
      languageData?.create_action_generation_image_generation_failed ||
      'Image generation failed',
    CREATE_ACTION_GENERATION_ALT_INFO_ICON:
      languageData?.create_action_generation_alt_info_icon || 'info',
    CREATE_COLOR_MODE_ENHANCE_ERROR_TITLE: languageData?.error || 'Error',
    CREATE_COLOR_MODE_ENHANCE_ALT_SOURCE_IMAGE:
      languageData?.create_color_mode_enhance_alt_source_image || 'Source',
    CREATE_SELECTBG_STATUS_CHECK_ERROR:
      languageData?.create_selectbg_status_check_error ||
      'Error checking background status',
    CREATE_SELECTSOURCE_CHOOSE_SOURCE_TITLE:
      languageData?.create_selectsource_choose_source_title || 'Choose source',
    CREATE_SELECTSOURCE_CHOOSE_ORIGINAL_PHOTO_TITLE:
      languageData?.face_swap_choose_original_photo || 'Choose original photo',
    CREATE_STUDIO_HEADER_TITLE:
      languageData?.create_face_swap_screen || 'Face Swap',
    CREATE_STUDIO_NO_TEMPLATE_TITLE:
      languageData?.create_studio_no_template_title || 'No template selected',
    CREATE_STUDIO_NO_TEMPLATE_DESC:
      languageData?.create_studio_no_template_desc ||
      'Please select a template to continue with face swap',
    CREATE_STUDIO_GO_BACK_BUTTON:
      languageData?.create_studio_go_back_button || 'Go Back',
    CREATE_STUDIO_UPLOAD_PHOTOS:
      languageData?.superapp_userprofile_photos || 'Photos',
    CREATE_STUDIO_UPLOAD_CAMERA:
      languageData?.create_studio_upload_camera || 'Camera',
    CREATE_STUDIO_UPLOAD_FILES:
      languageData?.create_studio_upload_files || 'Files',
    CREATE_STUDIO_SWAP_CREDIT:
      languageData?.face_swap_swap_value_credit || 'Swap(1 Credits)',
    CREATE_STUDIO_SWAP_CREDIT_SINGLE:
      languageData?.swap_one_credit || 'Swap(1 Credits)',
    CREATE_STUDIO_GUIDELINES_TITLE: languageData?.guidelines || 'Guidelines',
    CREATE_STUDIO_GUIDELINES_POINT_1:
      languageData?.create_studio_guidelines_point_1 ||
      'Try to upload clear, well-lit photos without heavy blur or pixelation.',
    CREATE_STUDIO_GUIDELINES_POINT_2:
      languageData?.create_studio_guidelines_point_2 ||
      'Only upload images you have the right to use.',
    CREATE_STUDIO_GUIDELINES_POINT_3:
      languageData?.create_studio_guidelines_point_3 ||
      'Avoid uploading offensive, violent, or adult content (violates our community guidelines)',
    CREATE_STUDIO_GUIDELINES_RECOMMENDED_SPECS_TITLE:
      languageData?.create_studio_guidelines_recommended_specs_title ||
      'Recommended Image Specs',
    CREATE_STUDIO_GUIDELINES_SPEC_FORMAT:
      languageData?.create_studio_guidelines_spec_format ||
      'Format: JPG or PNG',
    CREATE_STUDIO_GUIDELINES_SPEC_SIZE:
      languageData?.create_studio_guidelines_spec_size || 'Size: Up to 10 MB',
    CREATE_STUDIO_GUIDELINES_SPEC_RESOLUTION:
      languageData?.create_studio_guidelines_spec_resolution ||
      'Resolution: At least 512 x 512 pixels for best results',
    CREATE_ASPECT_RATIO_TITLE:
      languageData?.ai_tool_text_to_image_aspect || 'Image aspect ratio',
    CREATE_ASPECT_RATIO_DESCRIPTION:
      languageData?.ai_tool_text_to_image_aspect_desc ||
      'Set the aspect ratio to define the overall shape and presentation of your image.',
    CREATE_INDEX_UPLOAD_NOTE:
      languageData?.face_swap_select_from_collection ||
      'or select one from our collection',
    CREATE_CONTENT_DETAILS_ALT_LIKE:
      languageData?.create_content_details_alt_like || 'like',
    CREATE_CONTENT_DETAILS_ALT_COMMENT:
      languageData?.create_content_details_alt_comment || 'comment',
    CREATE_CONTENT_DETAILS_ALT_SHARE: languageData?.share || 'Share',
    SHARE_COPIED_SUCCESS:languageData?.copied_to_clipboard ||'Link copied to clipboard!',
    SHARE_COPIED_FAIL:languageData?.share_copied_fail||'Sharing not supported. Please copy the link manually.',
    CREATE_CONTENT_DETAILS_ALT_PROFILE:
      languageData?.create_content_details_alt_profile || 'Profile',
    CREATE_CONTENT_DETAILS_ALT_REMIX: languageData?.remix || 'Remix',
    CREATE_CONTENT_DETAILS_LIKES_TITLE:
      languageData?.superapp_notifications_likes || 'Likes',
    CREATE_CONTENT_DETAILS_COMMENTS_TITLE:
      languageData?.superapp_notifications_comments || 'Comments',
    CREATE_CONTENT_DETAILS_MY_CREATIONS_TITLE:
      languageData?.profile_my_creations || 'My Creations',
    CREATE_CONTENT_DETAILS_SEARCH_LIKES_PLACEHOLDER:
      languageData?.create_content_details_search_likes_placeholder ||
      'Search likes',
    CREATE_CONTENT_DETAILS_SEARCH_COMMENTS_PLACEHOLDER:
      languageData?.create_content_details_search_comments_placeholder ||
      'Search comments',
    CREATE_CONTENT_DETAILS_EDIT_BUTTON: languageData?.ai_tool_edit || 'Edit',
    CREATE_CONTENT_DETAILS_PUBLISH_BUTTON:
      languageData?.ai_tool_publish || 'Publish',
    CREATE_CONTENT_DETAILS_CONTENT_NOT_FOUND:
      languageData?.create_content_details_content_not_found ||
      'Content not found',
    CREATE_CONTENT_DETAILS_OUTPUT_URL_MISSING:
      languageData?.create_content_details_output_url_missing ||
      'Output file url not found.',
    CREATE_CONTENT_DETAILS_PUBLISH_SUCCESS:
      languageData?.create_content_details_publish_success ||
      'Content published successfully!',
    CREATE_CONTENT_DETAILS_PUBLISH_FAILED:
      languageData?.create_content_details_publish_failed ||
      'Failed to Publish Content',
    CREATE_CONTENT_DETAILS_UPDATE_FAILED:
      languageData?.create_content_details_update_failed ||
      'Failed to update content',
    DISCOVER_INDEX_TIME_JUST_NOW:
      languageData?.discover_index_time_just_now || 'Just now',
    DISCOVER_INDEX_ALT_USER: languageData?.discover_index_alt_user || 'User',
    DISCOVER_INDEX_FOLLOW:
      languageData?.superapp_userprofile_follow || 'Follow',
    DISCOVER_INDEX_FOLLOWING:
      languageData?.superapp_userprofile_following || 'Following',
    DISCOVER_INDEX_LIKES_TITLE:
      languageData?.superapp_notifications_likes || 'Likes',
    DISCOVER_INDEX_COMMENTS_TITLE:
      languageData?.superapp_notifications_comments || 'Comments',
    DISCOVER_INDEX_NO_LIKES_YET:
      languageData?.discover_index_no_likes_yet || 'No likes yet',
    DISCOVER_INDEX_FAILED_TO_POST_COMMENT:
      languageData?.discover_index_failed_to_post_comment ||
      'Failed to post comment',
    DISCOVER_INDEX_ERROR_LOADING_DISCOVER:
      languageData?.discover_index_error_loading_discover ||
      'Error loading Discover feed',
    DISCOVER_REPORT_SHEET_REASON_LABEL:
      languageData?.post_report_subtitle || 'Reason for report',
    DISCOVER_REPORT_SHEET_NO_REASONS:
      languageData?.discover_report_sheet_no_reasons || 'No reasons available',
    DISCOVER_REPORT_SHEET_ADDITIONAL_INFO_PLACEHOLDER:
      languageData?.post_report_tell_us_more_optional_text ||
      'Tell us more (optional)',
    DISCOVER_REPORT_SHEET_SUBMIT: languageData?.submit || 'Submit',
    DISCOVER_REPORT_SHEET_SUBMITTING:
      languageData?.discover_report_sheet_submitting || 'Submitting...',
    EXPLORE_GALLERY_LOAD_ERROR:
      languageData?.explore_gallery_load_error || 'Failed to load gallery.',
    GENDER_TITLE: languageData?.profile_choose_gender || 'Choose gender',
    LOGIN_FORGOT_PWD_TITLE: languageData?.login_forgot || 'Forgot password?',
    LOGIN_FORGOT_PWD_DESCRIPTION:
      languageData?.reset_info_text ||
      'We’ll send a one-time password (OTP) to your registered email address /mobile number to verify your identity and help you reset your password.',
    LOGIN_FORGOT_PWD_SEND_OTP: languageData?.reset_send_otp || 'Send OTP',
    LOGIN_FORGOT_PWD_OTP_FAILED:
      languageData?.login_forgot_pwd_otp_failed ||
      'Failed to send OTP. Please try again.',
    LOGIN_FORGOT_PWD_NEED_HELP:
      languageData?.login_forgot_pwd_need_help || 'Need help?',
    LOGIN_FORGOT_PWD_CONTACT_SUPPORT:
      languageData?.login_forgot_pwd_contact_support || 'Contact support',
    LOGIN_LINK_SENT_TITLE:
      languageData?.login_link_sent_title || 'Reset link sent!',
    LOGIN_LINK_SENT_DESCRIPTION:
      languageData?.login_link_sent_description ||
      'We’ve emailed you instructions. Check your inbox (and spam folder) for the reset email.',
    LOGIN_LINK_SENT_RESEND_BUTTON:
      languageData?.login_link_sent_resend_button || 'Send reset link again',
    LOGIN_LINK_SENT_IMAGE_ALT:
      languageData?.login_link_sent_image_alt || 'Email Sent Successfully',
    LOGIN_FAILED_TITLE: languageData?.login_failed_title || 'Login failed',
    LOGIN_RECAPTCHA_LOADING:
      languageData?.login_recaptcha_loading || 'Loading Recaptcha...',
    LOGIN_NEW_PWD_TITLE: languageData?.login_new_pwd_title || 'OTP Verified',
    LOGIN_NEW_PWD_ENTER_PASSWORD:
      languageData?.reset_enter_password || 'Enter new password',
    LOGIN_NEW_PWD_DESCRIPTION:
      languageData?.login_new_pwd_description ||
      'Your email has been verified.\nNow, set a new password to complete the\nreset process.',
    LOGIN_NEW_PWD_DESCRIPTION_Mobile:
      languageData?.LOGIN_NEW_PWD_DESCRIPTION_Mobile ||
      'Your mobile number has been verified.\nNow, set a new password to complete the\nreset process.',
    LOGIN_NEW_PWD_INVALID_RULES:
      languageData?.login_new_pwd_invalid_rules ||
      'Password must be at least 8 characters with uppercase, lowercase, number and special character',
    LOGIN_NEW_PWD_MIN_LENGTH:
      languageData?.login_new_pwd_min_length ||
      'Password must be at least 8 characters long',
    LOGIN_NEW_PWD_EMAIL_MISSING:
      languageData?.login_new_pwd_email_missing ||
      'Email information not found. Please try the forgot password process again.',
    LOGIN_NEW_PWD_RESET_FAILED:
      languageData?.login_new_pwd_reset_failed ||
      'Failed to reset password. Please try again.',
    LOGIN_NEW_PWD_RESET_BUTTON:
      languageData?.reset_password_button || 'Reset Password',
    LOGIN_NEW_PWD_RESETTING:
      languageData?.login_new_pwd_resetting || 'Resetting...',
    LOGIN_PWD_SUCCESS_GO_TO_SIGN_IN:
      languageData?.reset_go_signin || 'Go to sign in',
    LOGIN_PWD_SUCCESS_REGISTRATION_FAILED:
      languageData?.login_pwd_success_registration_failed ||
      'Registration failed',
    LOGIN_REGISTER_NAME_LABEL: languageData?.name || 'Name',
    LOGIN_REGISTER_PASSWORD_LABEL: languageData?.login_password || 'Password',
    LOGIN_REGISTER_DATE_OF_BIRTH_LABEL:
      languageData?.signup_dob || 'Date of birth',
    LOGIN_REGISTER_CHOOSE_AVATAR_TITLE:
      languageData?.avatar_choose_avatar || 'Choose Avatar',
    LOGIN_REGISTER_MISSING_CONTACT_ERROR:
      languageData?.login_register_missing_contact_error ||
      'Please enter email or mobile number.',
    LOGIN_REGISTER_CAPTCHA_FAILED_ERROR:
      languageData?.login_register_captcha_failed_error ||
      'Captcha verification failed.',
    LOGIN_REGISTER_GENERIC_FAILURE:
      languageData?.login_register_generic_failure ||
      'Please fill all required fields to complete registration.',
    LOGIN_REGISTER_VERIFICATION_SENT_PREFIX:
      languageData?.login_register_verification_sent_prefix ||
      'Verification code will be sent to',
    LOGIN_REGISTER_USE_AVATAR:
      languageData?.avatar_use_avatar || 'Use an avatar',
    UPLOAD_PIC: languageData?.edit_profile_upload_pic || 'Upload photo',
    LOGIN_RESET_PWD_TITLE:
      languageData?.login_reset_pwd_title || 'Reset your password',
    LOGIN_RESET_PWD_DESCRIPTION:
      languageData?.login_reset_pwd_description ||
      'Enter a new password for your account below to regain access.',
    LOGIN_RESET_PWD_SAVE_CONTINUE:
      languageData?.login_reset_pwd_save_continue || 'Save & continue',
    LOGIN_VERIFY_EMAIL_TITLE:
      languageData?.login_verify_email_title || 'Verify your email address',
    LOGIN_VERIFY_EMAIL_DESCRIPTION:
      languageData?.login_verify_email_description ||
      'We’ve sent a link to your inbox — check your spam folder if it’s not there.\n\nUntil you verify, you won’t be able to create, like, or comment, but you can still browse and explore all the amazing creations.',
    LOGIN_VERIFY_EMAIL_RESEND_LINK:
      languageData?.login_verify_email_resend_link ||
      'Send verification link again',
    LOGIN_VERIFY_SIGNUP_VERIFY:
      languageData?.reset_verify_continue || 'Verify & Continue',
    LOGIN_VERIFY_SIGNUP_RESEND: languageData?.reset_resend_otp || 'Resend OTP',
    LOGIN_VERIFY_SIGNUP_SKIP:
      languageData?.signup_skip_for_now || 'Skip for now',
    FILTER_NOTIFICATION_TITLE:
      languageData?.superapp_notifications_filter || 'Filter Notifications',
    NOTIFICATION_INDEX_SECTION_TODAY:
      languageData?.superapp_notifications_today || 'Today',
    NOTIFICATION_INDEX_SECTION_YESTERDAY:
      languageData?.superapp_notifications_yesterday || 'Yesterday',
    NOTIFICATION_INDEX_SECTION_LAST_7_DAYS:
      languageData?.superapp_notifications_last7days || 'Last 7 Days',
    NOTIFICATION_INDEX_SECTION_EARLIER:
      languageData?.notification_index_section_earlier || 'Earlier',
    NOTIFICATION_INDEX_SECTION_OLDER:
      languageData?.notification_index_section_older || 'Older',
    NOTIFICATION_INDEX_EMPTY_STATE:
      languageData?.empty_notification_message ||
      'No notifications at the moment',
    NOTIFICATION_INDEX_DEFAULT_TITLE:
      languageData?.notification_title || 'Notification',
    PLAYER_INIT_CLICK_TO_PLAY:
      languageData?.player_init_click_to_play || 'Click to play video',
    POPULAR_TOOLS_TITLE:
      languageData?.create_popular_tools_heading || 'Popular Tools',
    PROFILE_EDIT_TITLE: languageData?.edit || 'Edit Profile',
    PROFILE_EDIT_ADD_EMAIL_TITLE:
      languageData?.profile_edit_add_email_title || 'Add Email Address',
    PROFILE_EDIT_ABOUT_ME_LABEL: languageData?.profile_about || 'About Me',
    PROFILE_EDIT_DOB_LABEL:
      languageData?.profile_edit_dob_label || 'Date of Birth',
    PROFILE_EDIT_COUNTRY_PLACEHOLDER:
      languageData?.profile_country || 'Country',
    PROFILE_EDIT_EMAIL_LABEL: languageData?.login_email || 'Email',
    PROFILE_GUEST_USER_CREATE_ACCOUNT:
      languageData?.login_create_account || 'Create new account',
    PROFILE_GUEST_USER_EXISTING_USER_SIGN_IN:
      languageData?.promo_existing_user || 'Existing user? Sign in',
    PROFILE_INDEX_LATEST_CREATIONS:
      languageData?.superapp_userprofile_latest_creations || 'Latest Creations',
    PROFILE_INDEX_MY_DASHBOARD:
      languageData?.ai_tool_my_dashboard || 'My Dashboard',
    PROFILE_INDEX_GENERIC_ERROR:
      languageData?.profile_index_generic_error ||
      'Some issue happened. Try Again Later...',
    REPORT_ATTACHMENT_HELPER_TEXT:
      languageData?.feedback_upload_hint ||
      'Attach a photo or video for reference (optional).',
    SAVED_TITLE: languageData?.superapp_userprofile_saved || 'Saved',
    SAVED_LOAD_ERROR:
      languageData?.saved_load_error || 'Failed to load saved content.',
    SAVED_FOUND: languageData?.saved_found || 'found',
    SAVED_NO: languageData?.saved_no || 'No',
    SEARCH_SCREEN_RECENT_SEARCHES_TITLE:
      languageData?.search_screen_recent_searches_title || 'Recent Searches',
    SEARCH_SCREEN_POSTS_TITLE: languageData?.superapp_search_posts || 'Posts',
    SEARCH_SCREEN_PLAYLISTS_TITLE:
      languageData?.superapp_search_playlists || 'Playlists',
    SEARCH_SCREEN_NO_RECENT_SEARCHES:
      languageData?.search_screen_no_recent_searches ||
      'No recent searches. Start typing to search!',
    SEARCH_SCREEN_NO_DATA:
      languageData?.search_screen_no_data || 'data not available.',
    SEARCH_SCREEN_CLEAR_RECENT_SEARCHES:
      languageData?.search_screen_clear_recent_searches ||
      'Clear All Recent Searches',
    SETTINGS_INDEX_TITLE: languageData?.settings_index_title || 'Settings',
    SETTINGS_INDEX_LOGOUT_MODAL_TITLE: languageData?.logout_title || 'Log Out',
    SETTINGS_INDEX_LOGOUT_MODAL_DESCRIPTION:
      languageData?.logout_confirmation ||
      'Are you sure you want to log out from your account?',
    SETTINGS_INDEX_LOADING:
      languageData?.settings_index_loading || 'Loading settings...',
    SETTINGS_INDEX_ERROR:
      languageData?.settings_index_error || 'Failed to load settings',
    SUBSCRIPTION_PLAN_WEB_SUBSCRIPTION_CANCELLED_ALT:
      languageData?.subscription_plan_web_subscription_cancelled_alt ||
      'Subscription Cancelled',
    SUBSCRIPTION_PLAN_WEB_RENEWAL_DATE_LABEL:
      languageData?.subscription_plan_web_renewal_date_label || 'Renewal Date',
    SUBSCRIPTION_PLAN_WEB_VALID_UNTIL_LABEL:
      languageData?.valid_until || 'Valid Until',
    SUBSCRIPTION_PLAN_WEB_TRANSACTIONS_TITLE:
      languageData?.subscription_plan_web_transactions_title || 'Transactions',
    SUBSCRIPTION_PLAN_WEB_NO_TRANSACTIONS:
      languageData?.subscription_plan_web_no_transactions || 'No Transactions',
    SUBSCRIPTION_PLAN_WEB_NO_TRANSACTIONS_DESCRIPTION:
      languageData?.no_transactions || 'No transactions yet. Once you subscribe, your payment history will appear here.',
    SUBSCRIPTION_WEB_CREDITS_SUFFIX:
      languageData?.superapp_userprofile_credits || 'Credits',
    SUBSCRIPTION_WEB_SAVING_LABEL:
      languageData?.subscription_web_saving_label || 'Saving',
    SUBSCRIPTION_WEB_HIDE_BREAKUP:
      languageData?.subscription_web_hide_breakup || 'Hide breakup',
    SUBSCRIPTION_WEB_VIEW_BREAKUP: languageData?.view_breakup || 'View breakup',
    SUBSCRIPTION_WEB_PROMO_DISCOUNT_LABEL:
      languageData?.subscription_web_promo_discount_label || 'Promo Discount',
    SUBSCRIPTION_WEB_DISCOUNT_APPLIED_LABEL:
      languageData?.subscription_web_discount_applied_label ||
      'Discount Applied',
    SUBSCRIPTION_WEB_NET_PAYABLE_AMOUNT_LABEL:
      languageData?.net_payable || 'Net Payable Amount',
    SUBSCRIPTION_CARD_DETAILS_PAGE_TITLE:
      languageData?.subscription_card_details_page_title || 'Payment Details',
    SUBSCRIPTION_CARD_DETAILS_PAGE_SUBTITLE:
      languageData?.subscription_card_details_page_subtitle ||
      'Enter your card details below',
    SUBSCRIPTION_CARD_DETAILS_NAME_ON_CARD_LABEL:
      languageData?.subscription_card_details_name_on_card_label ||
      'Name on card',
    SUBSCRIPTION_CARD_DETAILS_PROCESSING_BUTTON:
      languageData?.subscription_card_details_processing_button ||
      'Processing...',
    SUBSCRIPTION_CARD_DETAILS_PAY_NOW_BUTTON:
      languageData?.subscription_card_details_pay_now_button || 'Pay Now',
    SUBSCRIPTION_CARD_DETAILS_SECURE_TITLE:
      languageData?.subscription_card_details_secure_title ||
      '100% Secure Data Encryption',
    SUBSCRIPTION_CARD_DETAILS_SECURE_SUBTITLE:
      languageData?.subscription_card_details_secure_subtitle ||
      'We guarantee security for every transaction.',
    SUBSCRIPTION_COMPARISON_TABLE_NO_PLANS_AVAILABLE:
      languageData?.subscription_comparison_table_no_plans_available ||
      'No plans available for comparison.',
    SUBSCRIPTION_COMPARISON_TABLE_PLAN_HEADER:
      languageData?.subscription_comparison_table_plan_header || 'Plan',
    SUBSCRIPTION_DDD_PAYMENT_FAILED_ALERT_PREFIX:
      languageData?.subscription_ddd_payment_failed_alert_prefix ||
      'Payment failed: ',
    SUBSCRIPTION_DDD_PAYMENT_FAILED_ALERT:
      languageData?.subscription_ddd_payment_failed_alert || 'Payment Failed!',
    SUBSCRIPTION_INDEX_BENEFITS_TITLE_PREFIX:
      languageData?.subscription_index_benefits_title_prefix ||
      "Here's what you'll get with",
    SUBSCRIPTION_INDEX_TOP_UP_PLANS_LABEL:
      languageData?.subscription_index_top_up_plans_label || 'Top-Up Plans',
    SUBSCRIPTION_TOPUP_DESCRIPTION:
      languageData?.subscription_topup_description || 'Adds extra credits to your current plan.',
    SUBSCRIPTION_PAYMENT_UPI_PLACEHOLDER:
      languageData?.subscription_payment_upi_placeholder || 'Enter UPI Id',
    SUBSCRIPTION_PAYMENT_UPI_VERIFY_LABEL:
      languageData?.subscription_payment_upi_verify_label || 'Verify',
    SUBSCRIPTION_PAYMENT_SUCCESS_TITLE:
      languageData?.subscription_payment_success_title || 'Payment Success !',
    SUBSCRIPTION_PAYMENT_SUCCESS_BUTTON_LABEL:
      languageData?.subscription_payment_success_button_label ||
      'Go Back to Home',
    SUBSCRIPTION_UPDATE_PROME_INVALID_CODE_FALLBACK:
      languageData?.subscription_update_prome_invalid_code_fallback ||
      'The code is not valid. Please try again in a while',
    SUBSCRIPTION_CONFIRM_PLAN_UPGRADE:
      languageData?.confirm_plan_upgrade || 'Confirm Plan Upgrade',
    SUBSCRIPTION_NEW_PLAN:
      languageData?.new_plan || 'New Plan',
      SUBSCRIPTION_CURRENT_PLAN:
      languageData?.current_plan_text || 'Current Plan',
      SUBSCRIPTION_CANCEL_UPGRADE:
      languageData?.cancel_upgrade || 'Cancel Upgrade',
      SUBSCRIPTION_UPGRADE_NOW:
      languageData?.upgrade_now || 'Upgrade Now',
      SUBSCRIPTION_CREDIT_AVAILABLE:
      languageData?.credit_available || 'Credit Available: % Credits',
      SUBSCRIPTION_CREDITS_REMAINING:
      languageData?.credits_remaining || 'Credits Remaining',

      SUBSCRIPTION_WHAT_HAPPENS:
      languageData?.what_happens || 'What Happens',
      SUBSCRIPTION_CANCELLATION_ACKNOWLEDGEMENT:
      languageData?.subscription_cancellation_acknowledgement || 'I understand that my current subscription will be cancelled immediately and no refund will be issued.',
      SUBSCRIPTION_POINT1:languageData?.plan_upgrade_immediately||"Your plan will be upgraded immediately",

SUBSCRIPTION_POINT2:languageData?.remaining_credits_retained||"Remaining credits from your current month's allocation will be retained.",
SUBSCRIPTION_POINT3:languageData?.new_plan_credits_added||"New plan credits will be added immediately.",
SUBSCRIPTION_POINT4:languageData?.current_plan_cancelled||"Your current plan will be permanently cancelled.",
SUBSCRIPTION_POINT5:languageData?.no_refund_for_current_plan||"No refund will be issued for the current plan.",
SUBSCRIPTION_POINT6:languageData?.you_will_be_charged||"You will be charged ₹ % today.",
    SUBSCRIPTION_UPGRADE_MONTHLY:languageData?.monthly_plan_upgrade_description || "You are about to upgrade your subscription plan.Your upgrade will take effect immediately.Any unused credits from your current plan will be carried forward and added to the credits provided by your new plan.Your current subscription will be replaced by the new subscription.You will be charged ₹ % today.By proceeding, you agree to the immediate activation of the new plan and the cancellation of your current plan.",
    SUBSCRIPTION_UPGRADE_ANNUAL:languageData?.annual_plan_upgrade_description || "You are about to upgrade your annual subscription plan.Your upgrade will take effect immediately.Any unused credits from your current month's allocation will remain available until the end of the current monthly cycle.Credits included with your upgraded annual plan will be added immediately.Your existing annual subscription will be permanently cancelled and replaced with the upgraded annual plan.No refund, credit adjustment, or transfer of the remaining value of your current annual subscription will be provided.You will be charged the full amount of the upgraded annual plan today.By proceeding, you acknowledge and agree to these terms.",
    BUY_NOW: languageData?.buy_now || 'Buy Now',
    CURRENT_PLAN: languageData?.current_plan || 'Current Plan',
    UPGRADE_TO: languageData?.upgrade_to || 'Upgrade to',
    YOU_ARE_ON_A_HIGHER_PLAN: languageData?.you_are_on_a_higher_plan || 'You are on a higher plan',
    SUBSCRIBE_TO: languageData?.subscribe_to || 'Subscribe to',
    SUPER_APP_HOME_GPT_PLACEHOLDER:
      languageData?.superapp_home_ai_quote || 'Ask. Imagine. Create.',
    SUPER_APP_HOME_GPT_MODEL_LABEL:
      languageData?.superapp_home_gpt_label || 'ErosGPT',
    VOICE_CLONNING_AUDIO_DETAILS_SELECT_LABEL:
      languageData?.ai_voice_select || 'Choose one',
    VOICE_CLONNING_VOICE_LIBRARY_SELECTED_ALT:
      languageData?.profile_selected || 'Selected',
    VOICE_CLONNING_VOICE_LIBRARY_UPLOAD_CLIP_BUTTON:
      languageData?.ai_voice_upload || 'Upload Clip',
    VOICE_CLONNING_VOICE_LIBRARY_RECORD_NOW_BUTTON:
      languageData?.ai_voice_record || 'Record Now',
    WAITLIST_LANDING_INVITE_ACCESS_TITLE:
      languageData?.invite_welcome || 'Welcome to the future',
    WAITLIST_LANDING_INVITE_ACCESS_SUBTITLE_LINE_1:
      languageData?.waitlist_landing_invite_access_subtitle_line_1 ||
      'Discover the tools shaping what’s next.',
    WAITLIST_LANDING_INVITE_ACCESS_SUBTITLE_LINE_2:
      languageData?.waitlist_landing_invite_access_subtitle_line_2 ||
      'Unlock access with your code.',
    WAITLIST_LANDING_INVITE_ACCESS_INVITE_CODE_PLACEHOLDER:
      languageData?.invite_enter_code || 'Enter your invite code',
    WAITLIST_LANDING_INVITE_ACCESS_UNLOCKING_BUTTON:
      languageData?.waitlist_landing_invite_access_unlocking_button ||
      'Unlocking...',
    WAITLIST_LANDING_INVITE_ACCESS_UNLOCK_BUTTON:
      languageData?.invite_unlock_access || 'Unlock Access',
    WAITLIST_LANDING_INVITE_ACCESS_NO_CODE_TEXT:
      languageData?.waitlist_landing_invite_access_no_code_text ||
      'Don’t have a code?',
    WAITLIST_LANDING_INVITE_ACCESS_JOIN_WAITLIST_BUTTON:
      languageData?.waitlist_join || 'Join the Waitlist',
    WAITLIST_LANDING_INVITE_ACCESS_JOIN_CHOOSE_LANG:
      languageData?.waitlist_landing_invite_access_join_choose_lang ||
      'Choose Language',
    WAITLIST_LANDING_INVITE_ACCESS_JOIN_CHOOSE_LANG_DESC:
      languageData?.choose_language_description ||
      'Choose your preferred language for the app experience',
    WAITLIST_LANDING_LANDING_FAQ_TITLE:
      languageData?.waitlist_landing_landing_faq_title ||
      'Frequently Asked Questions',
    WAITLIST_LANDING_LANDING_FAQ_SUBTITLE:
      languageData?.waitlist_landing_landing_faq_subtitle ||
      'Find answers to the most common queries below',
    WAITLIST_WAITLIST_INVITE_TITLE:
      languageData?.invite_friends_title || 'Invite Your Friends',
    WAITLIST_WAITLIST_INVITE_SUBTITLE:
      languageData?.waitlist_waitlist_invite_subtitle ||
      'Every signup moves you closer to the top of the queue for waitlist.',
    WAITLIST_WAITLIST_INVITE_ADD_MORE:
      languageData?.waitlist_waitlist_invite_add_more || 'Add More',
    WAITLIST_WAITLIST_INVITE_SENDING_BUTTON:
      languageData?.waitlist_waitlist_invite_sending_button || 'Sending...',
    WAITLIST_WAITLIST_INVITE_SEND_INVITES_BUTTON:
      languageData?.invite_send || 'Send Invites',
    WAITLIST_WAITLIST_LOGIN_TITLE:
      languageData?.waitlist_join || 'Join the Waitlist',
    WAITLIST_WAITLIST_LOGIN_SUBTITLE_LINE_1:
      languageData?.waitlist_waitlist_login_subtitle_line_1 ||
      'The next batch of access coming soon.',
    WAITLIST_WAITLIST_LOGIN_SUBTITLE_LINE_2:
      languageData?.waitlist_waitlist_login_subtitle_line_2 ||
      'Join the waitlist to be notified instantly.',
    WAITLIST_WAITLIST_LOGIN_EMAIL_HELPER:
      languageData?.signup_otp_verification ||
      'OTP will be sent here for verification',
    WAITLIST_WAITLIST_LOGIN_NAME_OPTIONAL:
      languageData?.signup_optional || 'Optional',
    WAITLIST_WAITLIST_LOGIN_LOADING_BUTTON:
      languageData?.waitlist_waitlist_login_loading_button || 'Loading...',
    WAITLIST_WAITLIST_LOGIN_PRIMARY_BUTTON:
      languageData?.waitlist_secure_spot || 'Secure My Spot',
    WAITLIST_WAITLIST_LOGIN_ALREADY_HEADER:
      languageData?.waitlist_already || 'Already on the Waitlist',
    WAITLIST_WAITLIST_LOGIN_ALREADY_MESSAGE_LINE_1:
      languageData?.waitlist_waitlist_login_already_message_line_1 || 'You’re ',
    WAITLIST_WAITLIST_LOGIN_ALREADY_MESSAGE_LINE_2:
      languageData?.waitlist_waitlist_login_already_message_line_2 ||
      'in the queue, with this email address. We’ll notify you when it is ready.',
    WAITLIST_WAITLIST_OTP_SUCCESS_IN_THE_QUEUE:
      languageData?.waitlist_waitlist_otp_success_in_the_queue ||
      'in the queue',
    WAITLIST_WAITLIST_OTP_SUCCESS_TITLE_NO_QUEUE:
      languageData?.waitlist_waitlist_otp_success_title_no_queue ||
      "You're in the queue",
    WAITLIST_WAITLIST_OTP_SUCCESS_SUBTITLE_LINE_1:
      languageData?.waitlist_waitlist_otp_success_subtitle_line_1 ||
      'You’ve secured your spot for EROS Universe.',
    WAITLIST_WAITLIST_OTP_SUCCESS_SUBTITLE_LINE_2:
      languageData?.waitlist_waitlist_otp_success_subtitle_line_2 ||
      'The app everyone wants to try.',
    WAITLIST_WAITLIST_OTP_SUCCESS_SUBTITLE_MOVE_UP_LINE_1:
      languageData?.waitlist_waitlist_otp_success_subtitle_move_up_line_1 ||
      'Want to move up? Invite your friends—every',
    WAITLIST_WAITLIST_OTP_SUCCESS_SUBTITLE_MOVE_UP_LINE_2:
      languageData?.waitlist_waitlist_otp_success_subtitle_move_up_line_2 ||
      'signup moves you closer to the top.',
    WAITLIST_WAITLIST_OTP_SUCCESS_PRIMARY_BUTTON:
      languageData?.waitlist_waitlist_otp_success_primary_button ||
      'Share & Jump Ahead',
    WAITLISTOTP_WAITLIST_OTP_SUBTITLE:
      languageData?.otp_sent_email_confirm_waitlist ||
      'We’ve sent a one-time password (OTP) to your email address. Please check your inbox and enter the OTP to confirm your spot on the waitlist.',
    WAITLISTOTP_WAITLIST_OTP_SUBTITLE_MOBILE:
      languageData?.otp_sent_mobile_confirm_waitlist ||
      'We’ve sent a one-time password (OTP) to your mobile. Please check your inbox and enter the OTP to confirm your spot on the waitlist.',
    WAITLISTOTP_WAITLIST_OTP_VALIDITY_INFO:
      languageData?.reset_otp_validity || 'OTP is valid for only 10 minutes.',
    WAITLISTOTP_WAITLIST_OTP_VERIFY_FAILED_FALLBACK:
      languageData?.waitlistotp_waitlist_otp_verify_failed_fallback ||
      'Verification failed',
    WAITLIST_WELCOME_TITLE:
      languageData?.invite_first || 'You’re Among the First',
    WAITLIST_WELCOME_SUBTITLE_LINE_1:
      languageData?.waitlist_welcome_subtitle_line_1 ||
      'You’ve unlocked early access.',
    WAITLIST_WELCOME_SUBTITLE_LINE_2:
      languageData?.waitlist_welcome_subtitle_line_2 ||
      'Get ready to experience what’s next.',
    WAITLIST_WELCOME_PRIMARY_BUTTON: languageData?.landing_explore || 'Explore',
    WALLET_MY_WALLET_WEB_COINS_LABEL:
      languageData?.superapp_userprofile_coins || 'Rewards',
    WALLET_MY_WALLET_WEB_ENTER_VALUE_PLACEHOLDER:
      languageData?.wallet_my_wallet_web_enter_value_placeholder ||
      'Enter Value',
    WALLET_MY_WALLET_WEB_AVAILABLE_COINS_PREFIX:
      languageData?.wallet_my_wallet_web_available_coins_prefix ||
      'Available Rewards:',
    WALLET_MY_WALLET_WEB_CONVERSION_RATIO_SUFFIX:
      languageData?.wallet_my_wallet_web_conversion_ratio_suffix ||
      'Rewards = 1 Credit',
    WALLET_WEB_REWARDS_LOADING:
      languageData?.wallet_web_rewards_loading || 'Loading rewards...',
    WALLET_WEB_REWARD_SELECT_COINS_SUFFIX:
      languageData?.wallet_web_reward_select_coins_suffix || 'rewards',
    WALLET_WEB_TRANSACTION_BACK_TO_WALLET:
      languageData?.wallet_web_transaction_back_to_wallet || 'Back to Wallet',
    WALLET_WEB_TRANSACTION_DATE_RANGE_LABEL:
      languageData?.wallet_web_transaction_date_range_label || 'Date Range',
    WALLET_WEB_TRANSACTION_CLEAR_FILTER:
      languageData?.wallet_web_transaction_clear_filter || 'Clear Filter',
    WALLET_WEB_TRANSACTION_ACTIVITY_SINGULAR:
      languageData?.wallet_web_transaction_activity_singular || 'activity',
    WALLET_WEB_TRANSACTION_ACTIVITY_PLURAL:
      languageData?.wallet_web_transaction_activity_plural || 'activities',
    WALLET_WEB_TRANSACTION_NO_TITLE:
      languageData?.wallet_web_transaction_no_title || 'No Title',
    WALLET_MY_WALLET_CONVERT_SUCCESS:
      languageData?.wallet_my_wallet_convert_success ||
      'rewards successfully exchanged for',
    WALLET_MY_WALLET_CONVERT_FAILED:
      languageData?.wallet_my_wallet_convert_failed ||
      'Reward conversion failed.',
    WALLET_MY_WALLET_INVALID_CONVERSION:
      languageData?.wallet_my_wallet_invalid_conversion ||
      'Invalid conversion amount. Please check your input.',
    WALLET_MY_WALLET_QUICK_LINKS:
      languageData?.wallet_my_wallet_quick_links || 'Quick Links',
    DESCRIBE_WHAT_YOU_WANT:
      languageData?.describe_what_you_want || 'Describe what you want',
    BACKGROUND_MUSIC: languageData?.BACKGROUND_MUSIC || 'Background Music',
    ASK_ANYTHING: languageData?.ai_tool_text_to_llm || 'Ask anything',
    ORIGINAL: languageData?.face_swap_original || 'Original',
    ORIGINAL_VIDEO: languageData?.original_video || 'Original Video',
    SELECT_DATE:
      languageData?.eternal_soul_profile_select_date || 'Select Date',
    UPLOAD_YOUT_SONG:
      languageData?.ai_tool_voice_remix_upload || 'Upload an original song',
    OOPS_SOMETHING_WENT_WRONG:
      languageData?.error_title || 'Oops! Something went wrong.',
    DONT_WORRY:
      languageData?.error_message_generic ||
      'Don’t worry—it’s not you. Please try again',
    DISCOUNT: languageData?.discount || 'Discount',
    MODE: languageData?.mode || 'Mode',
    OR: languageData?.or || 'or',
    NOISE_REDUCTION:
      languageData?.ai_tool_voice_remix_noise_reduction || 'Noise Reduction',
    EXPRESSION_INTENSITY:
      languageData?.ai_tool_voice_remix_expression_intensity ||
      'Expression Intensity',
    VIBRATION_DEPTH:
      languageData?.ai_tool_voice_remix_vibration_depth || 'Vibration Depth',
    GUEST_RESTRICTED_FEATURE:
      languageData?.guest_restricted_feature || 'Restricted Feature',
    GUEST_FEATURE_REQUIREMENT:
      languageData?.guest_feature_requirement ||
      'This feature requires an account. Please create an account or sign in to continue.',
    RECENT : languageData?.recent || 'Recent',
    EROS_ID_CONNECTED_HEADER: languageData?.your_eros_id_is_connected || 'Your Eros ID Is Connected',
    EROS_ID_CONNECTED_DESCRIPTION: languageData?.eros_id_linked_to_account || 'Your Eros ID is now linked to your account. Your wallet balance, earned rewards, transaction history, and active plans are all tied to one verified identity',
    UPLOADING_TIME: languageData?.uploading_time || 'Uploading... % seconds remaining',
    MB_OF: languageData?.mb_of || 'MB of',
    MB: languageData?.mb || 'MB',
  }

  ERROR_CODES = (errCode = '0000') => {
    return (
      languageData?.[errCode] ||
      JSON.stringify({
        title: languageData?.error_title || "Oops! Something went wrong.",
        message: languageData?.error_message_generic || "Don’t worry—it’s not you. Please try again",
      })
    );
  };

  USER_UPLOAD = {
    LABEL: languageData?.user_upload_label || 'Select one from our collection'
  }

  MUSIC_MODAL = {
    DOWNLOUD_WITHOUT_AUDIO:
      languageData?.download_without_audio || 'Download without audio?',
    CONFIRMATION_MESSAGE:
      languageData?.music_modal_confirmation_message ||
      'The audio used in this video can’t be included in downloads because of copyright rules. Your video will download successfully, but without sound.',
    AUDIO_NOT_AVAILABLE:
      languageData?.audio_not_available || 'Audio is not available'
  }

  AUDIO_DRAWER_LABELS = {
    AUDIO_USED: languageData?.audio_drawer_audio_used || 'Audio used',
    SAVE_TO_LIBRARY: languageData?.audio_drawer_save_to_library || 'Save to Library',
    SAVED: languageData?.audio_drawer_saved || 'Saved',
    DRAWER_HELP_TEXT: languageData?.audio_drawer_help_text || 'Use this track by creating a new post with AI tools.',
    EROS_EXCLUSIVE: languageData?.audio_drawer_eros_exclusive || 'Eros Exclusive',
    ARTIST: languageData?.audio_drawer_artist || 'Artist',
    FROM_FILM: languageData?.audio_drawer_from_film || 'From the film',
    ALBUM: languageData?.audio_drawer_album || 'Album',
    GENRE: languageData?.audio_drawer_genre || 'Genre',
    LANGUAGE: languageData?.audio_drawer_language || 'Language',
    DURATION: languageData?.audio_drawer_duration || 'Duration',
    LABEL: languageData?.audio_drawer_label || 'Label',
    TRACK: languageData?.audio_drawer_track || 'Track'
  }

  GUIDED_TOUR_AND_QUICK_TIPS = {
    ...GUIDED_TOUR_AND_QUICK_TIPS,
    FACE_SWAP: {
      TIP_ONE: {
        TITLE: 'Face Swap',
        CONTENT:
          languageData?.face_swap_tooltip_intro ||
          'Replace faces in photos or videos using AI in just a few steps.'
      },
      TIP_TWO: {
        TITLE: 'Choose Original Media (Collection)',
        CONTENT:
          languageData?.face_swap_tooltip_choose_collection ||
          'Choose a ready-made movie or character scene to swap your face into.'
      },
      TIP_THREE: {
        TITLE: 'Upload Your Own Media',
        CONTENT:
          languageData?.face_swap_tooltip_upload_media ||
          'Upload your own photo or video to perform a custom face swap.'
      },
      TIP_FOUR: {
        TITLE: 'Preview Area (Right Panel)',
        CONTENT:
          languageData?.face_swap_tooltip_preview_area ||
          'This is where you’ll preview the face swap result before downloading or sharing.'
      },
      TIP_FIVE: {
        TITLE: 'Suggested Content Rows',
        CONTENT:
          languageData?.face_swap_tooltip_suggested_content ||
          'Explore trending and recommended scenes for quick face swaps.'
      },
      TIP_SIX: {
        TITLE: 'Credit Usage & Action',
        CONTENT:
          languageData?.face_swap_tooltip_credit_usage ||
          'Tap here to generate your face swap. 1 credit will be used per swap.'
      }
    },
    COLORIZE: {
      TIP_ONE: {
        TITLE: 'Colorize',
        CONTENT:
          languageData?.colorize_tooltip_intro ||
          'Bring old or black & white photos back to life with AI.'
      },
      TIP_TWO: {
        TITLE: 'Upload Photo',
        CONTENT:
          languageData?.colorize_tooltip_upload ||
          'Upload a photo to colorize, enhance, or restyle.'
      },
      TIP_THREE: {
        TITLE: 'Mode Selector',
        CONTENT:
          languageData?.colorize_tooltip_mode_selector ||
          'Choose how AI should treat your photo — automatic or manual control.'
      },
      TIP_FOUR: {
        TITLE: 'Presets',
        CONTENT:
          languageData?.colorize_tooltip_presets ||
          'Apply instant color styles with one tap.'
      },
      TIP_FIVE: {
        TITLE: 'Describe What You Want',
        CONTENT:
          languageData?.colorize_tooltip_prompt_input ||
          'Add instructions like mood or tone to refine the result.'
      },
      TIP_SIX: {
        TITLE: 'Prompt Hints',
        CONTENT:
          languageData?.colorize_tooltip_hints ||
          'Tap a hint to instantly improve the color look.'
      },
      TIP_SEVEN: {
        TITLE: 'Generate & Credits',
        CONTENT:
          languageData?.colorize_tooltip_generate ||
          'Generate your colorized image. 1 credit will be used.'
      }
    },
    SCENE_SWAP: {
      TIP_ONE: {
        TITLE: 'Scene Swap',
        CONTENT:
          languageData?.scene_swap_tooltip_intro ||
          'Change the background of a photo using AI — no editing needed.'
      },
      TIP_TWO: {
        TITLE: 'Choose Original Photo (Collection)',
        CONTENT:
          languageData?.scene_swap_tooltip_choose_collection ||
          'Pick a ready-made photo to quickly try different backgrounds.'
      },
      TIP_THREE: {
        TITLE: 'Upload Your Own Photo',
        CONTENT:
          languageData?.scene_swap_tooltip_upload ||
          'Upload your own photo to replace its background.'
      },
      TIP_FOUR: {
        TITLE: 'Describe the New Scene',
        CONTENT:
          languageData?.scene_swap_tooltip_describe_scene ||
          'Describe the background you want. Example: sunset at the beach, neon city, snowy mountains'
      },
      TIP_FIVE: {
        TITLE: 'Before / After Preview',
        CONTENT:
          languageData?.scene_swap_tooltip_preview ||
          'Preview how AI blends your subject into the new scene.'
      },
      TIP_SIX: {
        TITLE: 'Suggested Backgrounds',
        CONTENT:
          languageData?.scene_swap_tooltip_suggested ||
          'Try popular characters and scenes for instant inspiration.'
      },
      TIP_SEVEN: {
        TITLE: 'Enhance Action & Credits',
        CONTENT:
          languageData?.scene_swap_tooltip_action ||
          'Generate your new scene. 1 credit will be used per enhancement.'
      }
    },
    TEXT_TO_IMAGE: {
      TIP_ONE: {
        TITLE: 'Text to Image',
        CONTENT:
          languageData?.text_to_image_tooltip_intro ||
          'Turn your ideas into stunning visuals using AI.'
      },
      TIP_TWO: {
        TITLE: 'Describe What You Want to Create',
        CONTENT:
          languageData?.text_to_image_tooltip_prompt ||
          'Describe the image you want. Add details like style, mood, and setting for better results.'
      },
      TIP_THREE: {
        TITLE: 'Prompt Hints',
        CONTENT:
          languageData?.text_to_image_tooltip_prompt_hints ||
          'Tap a hint to instantly shape the style and mood of your image.'
      },
      TIP_FOUR: {
        TITLE: 'Choose Image Aspect Ratio',
        CONTENT:
          languageData?.text_to_image_tooltip_aspect_ratio ||
          'Select an image size based on where you’ll use it — feed, story, or landscape.'
      },
      TIP_FIVE: {
        TITLE: 'Aspect Ratio Options',
        CONTENT:
          languageData?.text_to_image_tooltip_ratio_options ||
          'Different ratios work best for different platforms like Instagram, reels, or wallpapers.'
      },
      TIP_SIX: {
        TITLE: 'Preview Area',
        CONTENT:
          languageData?.text_to_image_tooltip_preview ||
          'Preview how your text turns into an image before downloading or sharing.'
      },
      TIP_SEVEN: {
        TITLE: 'Generate & Credits',
        CONTENT:
          languageData?.text_to_image_tooltip_generate ||
          'Generate your image. 1 credit will be used per image.'
      }
    },
    TEXT_TO_VIDEO: {
      TIP_ONE: {
        TITLE: 'Text to Video',
        CONTENT:
          languageData?.text_to_video_tooltip_intro ||
          'Turn your ideas into short AI-generated videos.'
      },
      TIP_TWO: {
        TITLE: 'Describe Your Video',
        CONTENT:
          languageData?.text_to_video_tooltip_prompt ||
          'Describe the scene, action, and mood of your video. More detail creates better motion.'
      },
      TIP_THREE: {
        TITLE: 'Prompt Style Hints',
        CONTENT:
          languageData?.text_to_video_tooltip_prompt_hints ||
          'Use these to quickly set the tone and style of your video.'
      },
      TIP_FOUR: {
        TITLE: 'Choose Video Style',
        CONTENT:
          languageData?.text_to_video_tooltip_style ||
          'Pick a visual style that matches the story you want to tell.'
      },
      TIP_FIVE: {
        TITLE: 'Set Video Duration',
        CONTENT:
          languageData?.text_to_video_tooltip_duration ||
          'Choose how long your video should be. Shorter videos generate faster.'
      },
      TIP_SIX: {
        TITLE: 'Preview Area',
        CONTENT:
          languageData?.text_to_video_tooltip_preview ||
          'Preview the look and motion of your AI-generated video.'
      },
      TIP_SEVEN: {
        TITLE: 'Play Preview',
        CONTENT:
          languageData?.text_to_video_tooltip_play_preview ||
          "Tap to preview the generated video once it's ready."
      },
      TIP_EIGHT: {
        TITLE: 'Generate Video & Credits',
        CONTENT:
          languageData?.image_to_video_tooltip_generate ||
          'Generate your video. 1 credit will be used per video.'
      }
    },
    VOICE_REMIX: {
      TIP_ONE: {
        TITLE: languageData?.ai_tool_voice_remix_title || 'Voice Remix',
        CONTENT:
          languageData?.voice_remix_tooltip_intro ||
          'Transform any song to sound like a different singer using AI.'
      },
      TIP_TWO: {
        TITLE: 'Upload Original Song',
        CONTENT:
          languageData?.voice_remix_tooltip_upload_song ||
          'Upload a song you own the rights to. Clear vocals give the best remix results.'
      },
      TIP_THREE: {
        TITLE: 'Select Singer',
        CONTENT:
          languageData?.voice_remix_tooltip_select_singer ||
          'Choose the voice style you want your song to be remixed into.'
      },
      TIP_FOUR: {
        TITLE: 'Expression Intensity',
        CONTENT:
          languageData?.voice_remix_tooltip_expression_intensity ||
          'Control how expressive the vocals feel — subtle or dramatic.'
      },
      TIP_FIVE: {
        TITLE: 'Vibration Depth',
        CONTENT:
          languageData?.voice_remix_tooltip_vibration_depth ||
          'Adjust vibrato to make the singing smoother or more powerful.'
      },
      TIP_SIX: {
        TITLE: 'Noise Reduction',
        CONTENT:
          languageData?.voice_remix_tooltip_noise_reduction ||
          'Reduce background noise to keep the vocals clean and focused.'
      },
      TIP_SEVEN: {
        TITLE: 'Advanced Voice Controls',
        CONTENT:
          languageData?.voice_remix_tooltip_advanced_controls ||
          'Fine-tune pitch accuracy or preserve the original vocal character.'
      },
      TIP_EIGHT: {
        TITLE: 'Generate Remix',
        CONTENT:
          languageData?.voice_remix_tooltip_generate ||
          'Generate your remixed song. 1 credit will be used per remix.'
      }
    },
    VOICE_CLONE: {
      TIP_ONE: {
        TITLE: 'Voice Cloning',
        CONTENT:
          languageData?.voice_cloning_tooltip_intro ||
          'Create realistic voiceovers using AI and your own voice.'
      },
      TIP_TWO: {
        TITLE: 'Choose a Voice',
        CONTENT:
          languageData?.voice_cloning_tooltip_choose_voice ||
          'Select an existing voice or create a new one from your recordings.'
      },
      TIP_THREE: {
        TITLE: 'Upload or Record Voice',
        CONTENT:
          languageData?.voice_cloning_tooltip_upload_record ||
          'Upload a song or record at least 10 seconds of clear audio to create a voice.'
      },
      TIP_FOUR: {
        TITLE: 'Remove Background Noise',
        CONTENT:
          languageData?.voice_cloning_tooltip_noise_removal ||
          'Enable this to clean your audio for better voice accuracy.'
      },
      TIP_FIVE: {
        TITLE: 'Voice Library',
        CONTENT:
          languageData?.voice_cloning_tooltip_voice_library ||
          'Access your saved voices or choose from ready-made voice presets.'
      },
      TIP_SIX: {
        TITLE: 'Enter What the Voice Should Say',
        CONTENT:
          languageData?.voice_cloning_tooltip_text_input ||
          'Type what you want the voice to speak. Supports expressive, natural-sounding speech.'
      },
      TIP_SEVEN: {
        TITLE: 'Style Hints',
        CONTENT:
          languageData?.voice_cloning_tooltip_style_hints ||
          'Use style hints to guide the tone and emotion of the voice.'
      },
      TIP_EIGHT: {
        TITLE: 'Generate & Credits',
        CONTENT:
          languageData?.voice_cloning_tooltip_generate ||
          'Generate your voiceover. 1 credit is used per generation.'
      }
    },
    TALKING_AVATAR: {
      TIP_ONE: {
        TITLE: 'Talking Avatar',
        CONTENT:
          languageData?.talking_avatar_tooltip_intro ||
          'Turn a photo into a lifelike talking video using AI.'
      },
      TIP_TWO: {
        TITLE: 'Upload Avatar Image',
        CONTENT:
          languageData?.talking_avatar_tooltip_upload_image ||
          'Upload a clear front-facing photo. Well-lit faces give the best results.'
      },
      TIP_THREE: {
        TITLE: 'Upload or Record Voice',
        CONTENT:
          languageData?.talking_avatar_tooltip_upload_voice ||
          'Upload an audio clip or record your voice for the avatar to speak.'
      },
      TIP_FOUR: {
        TITLE: 'Action Prompt',
        CONTENT:
          languageData?.talking_avatar_tooltip_action_prompt ||
          'Describe how the avatar should behave while talking. Example: smile, nod while speaking'
      },
      TIP_FIVE: {
        TITLE: 'Expression Hints',
        CONTENT:
          languageData?.talking_avatar_tooltip_expression_hints ||
          'Use these to quickly add natural expressions and gestures.'
      },
      TIP_SIX: {
        TITLE: 'Before / After Preview',
        CONTENT:
          languageData?.talking_avatar_tooltip_preview ||
          'See how your photo transforms into a talking avatar.'
      },
      TIP_SEVEN: {
        TITLE: 'Lip Sync & Motion Preview',
        CONTENT:
          languageData?.talking_avatar_tooltip_lip_sync ||
          'AI syncs lips, facial movements, and expressions to the voice.'
      },
      TIP_EIGHT: {
        TITLE: 'Generate Avatar & Credits',
        CONTENT:
          languageData?.talking_avatar_tooltip_generate ||
          'Generate your talking avatar. 1 credit will be used per video.'
      }
    },
    ACTION_GENERATION: {
      TIP_ONE: {
        TITLE: 'Action Generation',
        CONTENT:
          languageData?.action_generation_tooltip_intro ||
          'Turn a still image into a short action video using AI.'
      },
      TIP_TWO: {
        TITLE: 'Choose an Action',
        CONTENT:
          languageData?.action_generation_tooltip_choose_action ||
          'Choose the action you want the person to perform — solo or interactive.'
      },
      TIP_THREE: {
        TITLE: 'Action Types',
        CONTENT:
          languageData?.action_generation_tooltip_action_types ||
          'Some actions need one person, while others require two people in the image.'
      },
      TIP_FOUR: {
        TITLE: 'Upload Image',
        CONTENT:
          languageData?.action_generation_tooltip_upload_image ||
          'Upload a clear image. AI will detect people automatically to generate the action.'
      },
      TIP_FIVE: {
        TITLE: 'Subject Detection Preview',
        CONTENT:
          languageData?.action_generation_tooltip_subject_detection ||
          'AI identifies people in the image and applies the selected action.'
      },
      TIP_SIX: {
        TITLE: 'From Still to Motion Preview',
        CONTENT:
          languageData?.action_generation_tooltip_motion_preview ||
          'See how your image transforms from a still photo into motion.'
      },
      TIP_SEVEN: {
        TITLE: 'Generate Action & Credits',
        CONTENT:
          languageData?.action_generation_tooltip_generate ||
          'Generate your action video. 1 credit will be used per action.'
      }
    },
    IMAGE_TO_VIDEO: {
      TIP_ONE: {
        TITLE: 'Image to Video',
        CONTENT:
          languageData?.image_to_video_tooltip_intro ||
          'Add motion and depth to a still image using AI.'
      },
      TIP_TWO: {
        TITLE: 'Upload Image',
        CONTENT:
          languageData?.image_to_video_tooltip_upload_image ||
          'Upload a clear image. AI will add cinematic motion automatically.'
      },
      TIP_THREE: {
        TITLE: 'Describe the Motion',
        CONTENT:
          languageData?.image_to_video_tooltip_describe_motion ||
          'Describe how the camera should move or what should animate in the scene.'
      },
      TIP_FOUR: {
        TITLE: 'Motion Hints',
        CONTENT:
          languageData?.image_to_video_tooltip_motion_hints ||
          'Use these to quickly guide camera movement and perspective.'
      },
      TIP_FIVE: {
        TITLE: 'Set Video Duration',
        CONTENT:
          languageData?.image_to_video_tooltip_duration ||
          'Choose how long the motion video should be.'
      },
      TIP_SIX: {
        TITLE: 'Preview Area',
        CONTENT:
          languageData?.image_to_video_tooltip_preview ||
          'Preview how your image transforms into a cinematic video.'
      },
      TIP_SEVEN: {
        TITLE: 'Generate Video & Credits',
        CONTENT:
          languageData?.image_to_video_tooltip_generate ||
          'Generate your video. 1 credit will be used per video.'
      }
    },
    MOTION_CONTROL: {
      TIP_ONE: {
        TITLE: 'Motion Control',
        CONTENT:
          languageData?.motion_control_tour_intro ||
          'Make Me a Dancer\nTransfer real movement to your character using AI.\nBring still images to life in seconds.'
      },
      TIP_TWO: {
        TITLE: 'Select Action Video',
        CONTENT:
          languageData?.motion_control_tour_select_motion ||
          'Choose a motion from our ready-made collection.\nYour character will mimic this exact movement.'
      },
      TIP_THREE: {
        TITLE: 'Upload Action Video',
        CONTENT:
          languageData?.motion_control_tour_upload_video ||
          'Upload your own action video to transfer custom motion.\nClear full-body videos give the best results.'
      },
      TIP_FOUR: {
        TITLE: 'Upload Character Image',
        CONTENT:
          languageData?.motion_control_tour_upload_character ||
          'Upload the image that will perform the motion.\nFull-body, front-facing images work best.'
      },
      TIP_FIVE: {
        TITLE: 'Trending Motions',
        CONTENT:
          languageData?.motion_control_tour_trending ||
          'Explore popular motion clips used by other creators.\nQuick way to create high-impact results.'
      },
      TIP_SIX: {
        TITLE: 'Movie Inspired Moves',
        CONTENT:
          languageData?.motion_control_tour_movie ||
          'Cinematic action sequences inspired by iconic performance styles.\nPerfect for dramatic or hero-style animations.'
      },
      TIP_SEVEN: {
        TITLE: 'Generate',
        CONTENT:
          languageData?.motion_control_tour_generate ||
          'Click Generate to transfer motion to your character.\nEach animation uses 1 credit.'
      }
    },
    CTA_BUTTONS: {
      CTA_STEP: languageData?.cta_step || 'Step',
      CTA_OF: languageData?.cta_of || 'of',
      CTA_GOT_IT: languageData?.cta_got_it || 'Got it',
      CTA_SKIP_TOUR: languageData?.cta_skip_tour || 'Skip Tour',
      CTA_PREV: languageData?.cta_prev || 'Prev',
      CTA_NEXT: languageData?.cta_next || 'Next'
    }
  }

  VOICE_REMIX_TOOLTIP = {
    SUBTLE: languageData?.ai_tool_voice_remix_expression_subtle || 'Subtle',
    FULL: languageData?.full || 'Full',
    LOW: languageData?.ai_tool_voice_remix_vibration_low || 'Low',
    HIGH: languageData?.high || 'High',
    EXPRESSION_INTENSITY: {
      EXPRESSION_INTENSITY_DESCRIPTION:
        languageData?.expression_intensity_description ||
        'How much the AI voice sounds like Rafi.',
      EXPRESSION_INTENSITY_LOW:
        languageData?.expression_intensity_low ||
        'Low: Sounds more like the original recording',
      EXPRESSION_INTENSITY_HIGH:
        languageData?.expression_intensity_high ||
        `High: Sounds more like Rafi's voice`
    },
    VIBRATION_DEPTH: {
      VIBRATION_DEPTH_DESCRIPTION:
        languageData?.vibration_depth_description ||
        'How much the voice naturally shakes or wavers (vibrato).',
      VIBRATION_DEPTH_LOW:
        languageData?.vibration_depth_low || 'Low: Smooth and steady voice',
      VIBRATION_DEPTH_HIGH:
        languageData?.vibration_depth_high ||
        'High: More natural voice shaking and movement'
    },
    NOISE_REDUCTION: {
      NOISE_REDUCTION_DESCRIPTION:
        languageData?.noise_reduction_description ||
        'Removes background sounds and static from your audio.',
      NOISE_REDUCTION_LOW:
        languageData?.noise_reduction_low ||
        'Low: Keeps most background sounds',
      NOISE_REDUCTION_HIGH:
        languageData?.noise_reduction_high ||
        'High: Removes more background noise for cleaner audio'
    },
    PITCH_CORRECTION: {
      PITCH_CORRECTION_DESCRIPTION:
        languageData?.pitch_correction_description ||
        'Fixes off-key notes automatically.',
      PITCH_CORRECTION_OFF:
        languageData?.pitch_correction_off ||
        'Off: Keeps all the original notes as they are',
      PITCH_CORRECTION_ON:
        languageData?.pitch_correction_on ||
        'On: Corrects wrong notes to sound more in tune'
    }
  }

  CREDITS_NOT_ENOUGH_ERROR = {
    ...CREDITS_NOT_ENOUGH_ERROR,
    NOT_ENOUGH_CREDITS:
      languageData?.error_not_enough_credits || 'Not enough credits',
    NOT_ENOUGH_CREDITS_DESC:
      languageData?.error_not_enough_credits_desc ||
      'You don’t have enough credits for this action. Top up now to continue creating.',
    UPGRADE_CREDITS: languageData?.action_upgrade || 'Upgrade',
    TOP_UP_CREDITS: languageData?.action_top_up_credits || 'Top-Up Credits',
    INSUFFICIENT_CREDITS:
      languageData?.error_insufficient_credits?.toLowerCase() ||
      'insufficient credits'
  }

  BUY_CREDITS = {
    ...BUY_CREDITS,
    LEFT_CREDITS: languageData?.left_credits || 'Credits left.',
    CREDITS_BUY: languageData?.buy_credits || 'Buy Credits'
  }

  TEXT_TO_VIDEO = {
    ...TEXT_TO_VIDEO,
    GENERATE_VIDEO: languageData?.generate_video || 'Generating Video...',
    GENERATE_VIDEO_CREDIT:
      languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)'
  }

  HEADER = {
    ...HEADER,
    superAppHeader:
      languageData?.landing_superapp || 'Let’s do something amazing!',
    homeHeader: languageData?.create_homepage_create_now || 'Create now',
    homeSubHeader:
      languageData?.create_homepage_get_started_with || 'Get started with',
    subscriptionHeader:
      languageData?.subscription_header || 'Unlock the Power of AI',
    subscriptionSubHeader:
      languageData?.subscription_sub_header || 'Subscribe for premium access'
  }

  PAGE_LABELS = {
    loggedOutLabel: languageData?.logout_success_title || 'You’ve Logged Out',
    loggedOutSubLabel:
      languageData?.logout_success_message ||
      'You have successfully signed out of your account. We hope to see you again soon!',
    paymentActivationLabel:
      languageData?.payment_activation_label ||
      '3 Months Free Subscription Unlocked !',
    paymentActivationSubLabel:
      languageData?.payment_activation_sub_label ||
      'Your promo code was successfully applied. You can start enjoying premium features now.',
    checkShare: languageData?.check_share || 'Check out this content!',
    deleteAccountTitle: languageData?.delete_account_dialog_title || 'Delete Account?',
    deleteAccountDescription:
      languageData?.delete_account_dialog_message ||
      'This will permanently delete your account,creation and saved data. This action cannot be undone.',
    delete:languageData?.delete_account_dialog_confirm || 'Delete',
  }

  TAB_LABELS = {
    PHOTO: languageData?.tab_photo_face_swap || 'Photo Face Swap',
    MULTIPLE: languageData?.tab_multiple_face_swap || 'Multiple Face Swap',
    VIDEO: languageData?.tab_video_face_swap || 'Video Face Swap'
  }

  TABS = [
    {
      label: languageData?.tab_photo_face_swap || 'Photo Face Swap',
      active: true,
      path: '/single-face-swap'
    },
    {
      label: languageData?.tab_multiple_face_swap || 'Multiple Face Swap',
      active: false,
      path: '/double-face-swap'
    },
    {
      label: languageData?.tab_video_face_swap || 'Video Face Swap',
      active: false,
      path: '/video-face-swap'
    }
  ]

  subscriptionMessages = {
    NOT_SUBSCRIBED: {
      HEADER:
        languageData?.subscription_not_subscribed_header || 'Subscribe again',
      MESSAGE:
        languageData?.subscription_not_subscribed_message ||
        'We’d love to have you back—unlock faster results, unlimited exports, and priority support again.'
    },
    NEWLY_CREATED_USER: {
      HEADER: languageData?.subscription_new_user_header || 'Subscribe now',
      MESSAGE:
        languageData?.no_active_plan_message ||
        'You don’t have an active plan. Subscribe now to unlock faster results, unlimited exports, and priority support.'
    }
  }

  BUTTON_LABELS = {
    chnage: languageData?.chnage || 'Change',
    exploreGuest: languageData?.promo_explore_guest || 'Explore as guest',
    signInAgain: languageData?.logout_signin_again || 'Sign in again',
    activateNow: languageData?.activate_now || 'Activate Now',
    mayBeLater: languageData?.maybe_later || 'Maybe later',
    cancel: languageData?.cancel || 'Cancel',
    OK: languageData?.common_ok || 'OK',
    retry: languageData?.retry || 'Retry',
    logout: languageData?.logout_title || 'Log Out',
    continue: languageData?.continue || 'Continue',
    apply: languageData?.apply || 'Apply',
    remove: languageData?.remove || 'Remove',
    continueToPay: languageData?.continue_to_pay || 'Continue to Pay',
    signIn: languageData?.sign_in || 'Sign in',
    signInLoader: languageData?.signing_in || 'Signing in...',
    signUp: languageData?.signup_button || 'Sign up',
    signUpLoader: 'Signing up...',
    forgotPassword: languageData?.login_forgot || 'Forgot password?',
    createNewAccount:
      languageData?.signup_create_account || 'Create new account',
    buyCredits: languageData?.buy_credits || 'Buy Credits',
    earnCoin: languageData?.earn_more_title || 'Earn More Rewards',
    convert: languageData?.convert || 'Convert',
    viewDetails: languageData?.view_details || 'View Details',
    viewPlans: languageData?.view_plans || 'View Plans',
    compareBenefits: languageData?.compare_benefits || 'Compare Benefits',
    seeTopUpPlans: languageData?.see_top_up_plans || 'See Top Up Plans',
    goToDashboard: languageData?.go_to_dashboard || 'Go to Dashboard',
    keepSubscription:
      languageData?.keep_my_subscription || 'Keep My Subscription',
    confirmCancellation:
      languageData?.confirm_cancellation || 'Confirm Cancellation',
    select: languageData?.ai_voice_select || 'Select',
    selected: languageData?.profile_selected || 'Selected',
    moreDetails: languageData?.more_details || 'More Details',
    redeem: languageData?.redeem || 'Redeem',
    clickToCopy: languageData?.click_to_copy || 'Click to copy',
    claimThisOffer: languageData?.claim_this_offer || 'Claim this offer',
    english: languageData?.language_english || 'English',
    hindi: languageData?.language_hindi || 'Hindi',
    CONTINUE_DOWNLOAD: languageData?.continue_download || 'Continue Download',
    SUBSCRIBE: languageData?.Subscribe || 'Subscribe'
  }

  SIDE_POPUP = {
    SEARCH: 'Search',
    NOTIFICATIONS: 'Notifications',
    MORE: 'More'
  }

  NEW_SIDE_POPUP = {
    SEARCH: languageData?.search || 'Search',
    NOTIFICATIONS: languageData?.create_notifications_title || 'Notifications',
    MORE: languageData?.superapp_search_more || 'More'
  }

  BACK_TO_SIGN_IN = languageData?.reset_back_signin || 'Back to sign in'

  COMMON_MESSAGES = {
    Loading: `${languageData?.play_loading || 'Loading'}...`,
    NoData: languageData?.no_images_found || 'No images found.'
  }

  SEARCH_COPY = {
    placeholder:
      languageData?.search_placeholder ||
      'Search creators, tools, music, hashtags...',
    recentTitle: languageData?.create_search_recent || 'Recent searches',
    noRecent: languageData?.create_search_no_recent || 'No recent searches.',
    noResults:
      languageData?.no_results_found_for_search ||
      'No results found for your search.',
    noHashtags:
      languageData?.no_hashtags_found_for_search ||
      'No hashtags found for your search',
    noCreator:
      languageData?.search_no_creators || 'No creators found for your search',
    noPlaylist:
      languageData?.no_playlists_found || 'No playlists found for your search',
    failedToLoad:
      languageData?.search_failed_to_load || 'Failed to load results.',
    section: {
      tools: languageData?.superapp_search_tools || 'Tools',
      creators: languageData?.superapp_search_creators || 'Creators',
      hashtags: languageData?.superapp_search_hashtags || 'Hashtags',
      posts: languageData?.superapp_search_posts || 'Posts'
    },
    clearAll: languageData?.search_screen_clear_all || 'Clear All'
  }

  MY_WALLET_INFO = {
    CREDITS: languageData?.superapp_userprofile_credits || 'Credits',
    EXCHANGE_CENTER: languageData?.exchange_center || 'Exchange Center',
    EXCHANGE_CENTER_SUB_LABEL:
      languageData?.switch_rewards_to_credits ||
      'Easily switch your rewards into credits',
    EROS_UNIVERSE: languageData?.eros_universe_coins || 'EROS Universe Rewards',
    CREADIT_EXPIRE: languageData?.credit_expire || 'Your plan expires on '
  }

  SEARCH_TABS = {
    TOP_RESULTS: languageData?.create_search_top_results || 'Top Results',
    CREATOR: languageData?.superapp_search_creators || 'Creators',
    HASHTAG: languageData?.superapp_search_hashtags || 'Hashtags',
    PLAYLIST: languageData?.superapp_search_playlists || 'Playlists'
  }

  // Ordered list for rendering search tabs in UI
  SEARCH_TAB_LIST = [
    SEARCH_TABS.TOP_RESULTS,
    SEARCH_TABS.CREATOR,
    SEARCH_TABS.HASHTAG,
    SEARCH_TABS.PLAYLIST
  ]

  KEYWORDS = {
    SUGGESTED: languageData?.suggested || 'suggested',
    MOVIES: languageData?.movies || 'movies',
    CHARACTERS: languageData?.characters || 'characters',
    POPULAR: languageData?.popular || 'popular',
    SUGGESTED_FOR_YOU:
      languageData?.face_swap_suggested_for_you || 'Suggested for you',
    NoAITOOLFOUND: languageData?.no_ai_tools_found || 'No AI tools found',
    BACKTOSEARCH: languageData?.back_to_search || 'Back to Search',
    CREATORS: languageData?.results_in_creators || 'Results in Creators',
    HASHTAGS: languageData?.results_in_hashtags || 'Results in Hashtags',
    PLAYLISTS: languageData?.results_in_playlists || 'Results in Playlists',
    POSTS: languageData?.results_in_posts || 'Results in Posts',
    NO_RESULT: languageData?.no_result || 'No results'
  }
  POPUP_MESSAGE = {
    DISCOVER_FOLLOW_ERROR:
      languageData?.discover_follow_error ||
      'Please log in to follow creators.',
    DISCOVER_UPDATE_FAILED_CURRENT:
      languageData?.discover_update_failed_current ||
      'Unable to update follow status right now.',
    DISCOVER_UPDATE_FAILED:
      languageData?.discover_update_failed || 'Failed to update follow status.',
    FEEDBACK_AND_SUPPORT:
      languageData?.ai_tool_feedback_thanks ||
      'Thanks! Your feedback helps us make things better.',
    FEEDBACK_FAILED:
      languageData?.feedback_failed || 'Failed to submit feedback'
  }

  FALLBACK_DATA = {
    DESCRIPTION:
      languageData?.fallback_face_swap_description ||
      'Face Swap. Your face into iconic scenes.',
    TITLE:
      languageData?.swap_edit_share_and_do_more ||
      'Swap, edit, share and do more',
    USER_NAME: languageData?.eros_universe || 'EROS Universe',
    TIME: languageData?.fallback_time || '1 hr ago'
  }

  FEEDBACK_TEXT = {
    TITLE: languageData?.feedback_support_title || 'Feedback & Support',
    DESCRIPTION:
      languageData?.feedback_support_desc ||
      'We’re here to help! Let us know if you’re facing an issue or have suggestions to improve your experience.',
    ATTACHMENT_TEXT:
      languageData?.feedback_upload_hint ||
      'Attach a photo or video for reference (optional).',
    DONE_BUTTON: languageData?.profile_done || 'Done',
    FEEDBACK_TYPE_TITLE:
      languageData?.feedback_choose_type || 'Choose feedback type'
  }

  REPORT_TEXT = {
    TITLE: languageData?.report_problem_title || 'Report a Problem',
    DESCRIPTION:
      languageData?.report_text_desc ||
      'Encountered an issue? Let us know so we can look into it and fix it as soon as possible.',
    ATTACHMENT_TEXT:
      languageData?.feedback_upload_hint ||
      'Attach a photo or video for reference (optional).',
    DONE_BUTTON: languageData?.profile_done || 'Done',
    ISSUE_OPTIONS: [
      'App not working',
      'Payment issue',
      'Content not loading',
      'Account problem',
      'Other'
    ],
    REPORTED_CONTENT_TITLE:languageData?.report_content_title||'Thank you for reporting',
    REPORTED_CONTENT_DESCRIPTION:languageData?.report_content_description||'This content has been hidden because you reported it. Our team will review it according to our community guidelines',
    SHOW_CONTENT:languageData?.report_show_content||'Show Content',
    REPORT_CONTENT_HIDDEN:languageData?.report_content_hidden || 'Content Hidden',
    REPORT_SUCCESS_MESSAGE:languageData?.report_success_message || 'Thank you for your report. Our team will review this content'
  }
  BLOCKED_USER_TEXT ={
    TITLE: languageData?.blocked_user_title || 'Blocked User',
    BLOCK_USER_DESCRIPTION:languageData?.block_user_description||'You will no longer see content from this user, and they will not be able to interact with you. You can unblock them at anytime.',
    BLOCK:languageData?.user_block || "Block",
    UNBLOCK:languageData?.user_unblock || "Unblock",
    UNBLOCK_USER_DESCRIPTION:languageData?.unblock_user_description || 'Are you sure you want to unblock the user?',
    USER_BLOCKED_SUCCESS:languageData?.user_blocked_success ||'User blocked successfully!',
    USER_UNBLOCKED_SUCCESS:languageData?.user_unblocked_success || 'User unblocked successfully!',
    USER_BLOCKED_ACCOUNT_DISPALY_TITLE:languageData?.blocked_user_account_display_title ||'You have blocked this account',
    USER_BLOCKED_ACCOUNT_DISPALY_DESCRIPTION:languageData?.blocked_user_account_display_description || 'Unblock this account to view their photos and videos. Once unblocked, you ll also be able to view their profile and content.',
    USER_NOT_FOUND:languageData?.user_not_found||'User not found',
    USER_UNBLOCKED_WARNING_TEXT:languageData?.user_unblocked_warning_text||'You can block them from their profile anytime.',
  },
  DELETE_ACCOUNT_TEXT = {
    TITLE: languageData?.delete_account_title || 'Delete your account',

    PROMPT:
      languageData?.delete_account_prompt ||
      'Are you sure you want to delete your account?', // problem

    BULLETS: [
      languageData?.delete_account_visibility ||
      'When you request account deletion, your profile will be immediately removed from public view. Other users will no longer be able to find your profile, view your content, or interact with you on Eros Universe.',

      languageData?.delete_account_content_hidden ||
      'All your generated and uploaded content, including videos, images, audio, posts, and associated metadata, will be hidden from the platform as soon as the deletion request is confirmed.',

      languageData?.delete_account_data_inaccessible ||
      'After deletion from the platform, the following data will no longer be accessible:\\n $%Profile information and personal details\\n $%Followers and following\\n $%Saved items and preferences\\n $%Comments, likes, and interactions\\n $%Activity history\\n $%All generated and uploaded content',

      languageData?.delete_account_grace_period ||
      'Your account will enter a 30-day deletion period. During this time, your data will be securely retained and you can cancel the request by logging in, which will fully restore your account. If you do not log in within 30 days, your account will be permanently deleted, and you will no longer be able to access it.',

      languageData?.delete_account_backend_retention ||
      'Your data may still be securely retained in backend systems for up to 90 days for compliance, recovery, and operational purposes, after which it may be archived and no longer recoverable.',

      languageData?.delete_account_restore_support ||
      'If you wish to restore your account after it has been deleted from the platform, you may contact support. Subject to data availability, your account (including profile, content, and activity) may be restored from backend systems.',

      languageData?.delete_account_subscription_notice ||
      'Deleting your account does not automatically cancel your subscriptions. If you have subscribed via Apple In-App Purchase, Google In-App Purchase, or third-party billing partners, you must cancel those subscriptions separately.',

      languageData?.delete_account_billing_responsibility ||
      'Your bank, app store, or payment partner may continue to charge you according to their billing cycle unless you cancel directly with them. Eros Universe is not responsible for charges incurred through third-party billing after account deletion.',

      languageData?.delete_account_logout_notice ||
      'Once your deletion request is confirmed, you will be logged out of your account on this device and may lose access to any active features or entitlements associated with your account.',

      languageData?.delete_account_legal_retention ||
      'Certain data may be retained as required by applicable laws, regulatory requirements, or legitimate business purposes.'
    ],

    CHECKBOX_LABEL:
      languageData?.delete_account_warning_repeat ||
      "If selected, I understand that my account will be scheduled for deletion, my profile and content will be removed from the platform, my data may be retained temporarily for compliance purposes, and my subscription may still incur charges from third-party providers.",

    BTN_DELETE:
      languageData?.delete_account_confirm || 'Yes, delete my account',

    BTN_DELETING: languageData?.chatgpt_screen_deleting || 'Deleting...',

    BTN_CANCEL: languageData?.delete_account_cancel || 'No, I want to stay back'
  }

 

  PICK_FROM_LIST = {
    LABEL: languageData?.gallery || 'Gallery',
    WEB_Title: languageData?.swap_with || 'Swap With',
    MWEB_TITLE: languageData?.pick_from_gallery || 'Pick from Gallery',
    CLOSE_BTN: languageData?.close || 'close',
    DONE_BTN: languageData?.profile_done || 'Done'
  }

  ERROR_MESSAGES = {
    ErrorText: languageData?.watch_view_error_data || 'Watch/view error data',
    VIDEO_SEEK_ERROR: languageData?.video_seek_error || 'Error during Seek',
    PLAY_PAUSE_ERROR:
      languageData?.play_pause_error || 'Error during play/pause',
    NOT_FOUND:
      languageData?.video_element_not_found || 'Video element Not Found',
    Login_Check: languageData?.login_to_continue || 'Please login to continue',
    Follow_Error: languageData?.follow_error || 'Failed to follow/unfollow',
    COMMENT_ERROR:
      languageData?.discover_index_failed_to_post_comment ||
      'Failed to post comment',
    LIKE_MESSAGE: languageData?.no_likes_yet || 'NO Likes Yet',
    PAYMENT_SERVER:
      languageData?.payment_server_failed || 'Payment failed on server',
    PAYMENT_FAILED: languageData?.payment_failed || 'PAYMENT_FAILED',
    FAILED_TO_SAVE:
      languageData?.failed_to_save_content || 'Failed to save content',
    LOGIN_TO_SAVE:
      languageData?.login_to_save_content || 'Please log in to save content',
    CONTENT_NOT_FOUND:
      languageData?.create_content_details_content_not_found ||
      'Content not found',
    MOBILE_VALIDATION_ERROR:
      languageData?.mobile_validation_error || 'Enter a valid phone number',
    EMAIL_VALIDATION_ERROR:
      languageData?.email_validation_error || 'Enter a valid email address',
    MOBILE_VALIDATION_ERROR_MSG:
      languageData?.mobile_validation_error_msg ||
      'Please enter a valid mobile number',
    EMAIL_VALIDATION_ERROR_MSG:
      languageData?.email_validation_error_msg ||
      'Please enter a valid email address',
    SOMETHING_WENT_WRONG:
      languageData?.something_went_wrong ||
      'Something went wrong.Please try again.',
    FAILED_TO_REMOVE_SAVES: 'Failed to remove from saves',
    FAILED_TO_UNFOLLOW: 'Failed to unfollow',
    FAILED_TO_FOLLOW: 'Failed to follow'
  }

  FOLLOW_DETAILS = {
    FOLLOWING: languageData?.superapp_userprofile_following || 'Following',
    FOLLOW: languageData?.superapp_userprofile_follow || 'Follow',
    IN_PROGRESS: `${languageData?.superapp_userprofile_following || 'Following'}...`,
    UNFOLLOWING: languageData?.superapp_userprofile_unfollowing || 'Unfollowing',
    UNFOLLOWING_IN_PROGRESS: `${languageData?.superapp_userprofile_unfollowing || 'Unfollowing'}...`
  }

  UPDATE_EMAIL_TEXT = {
    TITLE: languageData?.update_email_title || 'Update Email',
    DESCRIPTION:
      languageData?.update_linked_email_description ||
      "Update the email address linked to your account. We'll use this email for login, account updates, and important notifications.",
    CURRENT_PASSWORD_DESCRIPTION:
      languageData?.update_email_current_password_description ||
      'For your security, enter your current password to continue.',
    NEW_EMAIL_STEP_TITLE:
      languageData?.update_email_step_title || 'Enter New Email',
    NEW_EMAIL_DESCRIPTION:
      languageData?.update_email_new_email_description ||
      "Use an email address you can access. We'll send a verification code to confirm the update.",
    NEW_EMAIL_LABEL:
      languageData?.update_email_new_email_label || 'New Email Address',
    LABEL_EMAIL: languageData?.login_email || 'Email',
    ERROR_REQUIRED: languageData?.profile_required || 'Required',
    ERROR_INVALID:
      languageData?.email_validation_error || 'Enter a valid email address',
    ERROR_PLEASE_ENTER_VALID:
      languageData?.email_validation_error_msg ||
      'Please enter a valid email address',
    ERROR_INCORRECT_PASSWORD:
      languageData?.incorrect_password_error ||
      'Incorrect password. Please try again.',
    API_ERROR_FALLBACK:
      languageData?.update_email_api_error ||
      'Failed to send OTP to new email. Please try again.',
    OTP_VERIFY_ERROR_FALLBACK:
      languageData?.update_email_verify_error ||
      'Verification failed. Please try again.',
    BUTTON_CONTINUE: languageData?.continue || 'Continue',
    BUTTON_SENDING: languageData?.sending_otp || 'Sending OTP...',
    OTP_SUCCESS_MESSAGE:
      languageData?.otp_sent_new_email ||
      'OTP has been sent to your new email address for verification',
    OTP_DESCRIPTION:
      languageData?.update_email_otp_description ||
      "We've sent a One-Time Password (OTP) to your new email address. Please enter it below to verify your new email address.",
    OTP_VALIDITY:
      languageData?.update_email_otp_validity || 'OTP is valid for only 3 minutes.',
    OTP_BLOCKED: languageData?.otp_blocked || 'Blocked',
    OTP_RESENT_SUCCESS:
      languageData?.otp_resent_success || 'OTP resent successfully',
    ERROR_REGISTERED_EMAIL:
      languageData?.email_already_registered ||
      'Email should be different than registered email address.',
    ERROR_EMAIL_SPECIAL_SYMBOLS: languageData?.special_symmbol_error || 'Special symbols are not allowed before @',
    ERROR_TOO_MANY_ATTEMPTS: languageData?.too_many_attempts_error || 'Too many failed attempts. Please try again in %s min.',
    ERROR_RATE_LIMIT_24H: languageData?.rate_limit_24h_error || 'Max 3-5 requests per 24 hours to change identification methods reached.',
    SUCCESS_UPDATED: languageData?.email_update_success_msg || 'Your email address updated successfully.',
    VERIFY_OTP_TITLE: languageData?.otp_verify_otp_title || 'Verify OTP'
  }

  PROMO_SCREEN_TEXT = {
    HEADING: languageData?.promo_heading || 'Your first creations are on us',
    SUB_HEADING:
      languageData?.promo_sub_heading || 'Sign up now, no payment required.', // lines problem
    SUB_HEADING2:
      languageData?.promo_sub_heading_2 || 'Upgrade when you’re ready',
    ITEMS_LIST_TITLE:
      languageData?.guest_benefits_intro || 'Here’s what you’ll get',
    ITEMS: [
      languageData?.landing_page_benefit_1 ||
      '10 free credits to try premium tools',
      languageData?.guest_access_styles ||
      'Access exclusive AI styles & effects',
      languageData?.guest_save_manage || 'Save & manage creations anytime'
    ],
    APPLY_PROMO_HEADING: languageData?.promo_code_label || 'Have a promo code?'
  }

  SPLASH_SCREEN_TEXT = {
    TITLE: languageData?.splash_screen_title || 'Ready to create?',
    SUBTITLE: languageData?.splash_screen_subtitle || 'Unleash Your Creativity',
    ENTER_LABEL: languageData?.splash_screen_enter_label || 'ENTER'
  }

  PASSWORD_RESET = {
    TITLE:
      languageData?.password_reset_successful || 'Password reset successful',
    DESCRIPTION:
      languageData?.reset_success_info ||
      'You can now log in with your new password and get back to what you were doing.'
  }

  UPDATE_PASSWORD_TEXT = {
    TITLE: languageData?.update_password_title || 'Update Password',
    DESCRIPTION:
      languageData?.update_password_description ||
      'Update your password to keep your account secure. Make sure it’s something strong and easy for you to remember.',
    CHANGE_PASSWORD: languageData?.change_password_desc || 'Change the password linked to your account.',
    DESCRIPTION_AUTH:
      languageData?.enter_password_desc ||
      'For your security, enter your current password to continue.',

    TITLE_NEW: languageData?.create_new_password || 'Create New Password',
    DESCRIPTION_NEW:
      languageData?.password_hint_desc ||
      'Choose a strong password and something that is easy for you to remember.',

    LABEL_CURRENT_PASSWORD:
      languageData?.label_current_password || 'Current Password',
    LABEL_NEW_PASSWORD: languageData?.new_password_label || 'New Password',
    LABEL_RETYPE_PASSWORD:
      languageData?.retype_new_password || 'Retype New Password',

    PLACEHOLDER_CURRENT_PASSWORD:
      languageData?.label_current_password || 'Current Password',
    PLACEHOLDER_NEW_PASSWORD: languageData?.new_password_label || 'New Password',
    PLACEHOLDER_RETYPE_PASSWORD:
      languageData?.retype_new_password || 'Retype New Password',

    ERROR_REQUIRED: languageData?.profile_required || 'Required',
    ERROR_SAME_AS_OLD:
      languageData?.error_same_as_old_password ||
      'New password must be different from current password',
    ERROR_MISMATCH:
      languageData?.password_mismatch_error || 'The entered passwords do not match.',
    ERROR_USER_NOT_FOUND:
      languageData?.error_user_not_found ||
      'Cannot identify user. Please re-login and try again.',
    ERROR_API_DEFAULT:
      languageData?.update_password_failed ||
      'Failed to update password. Please try again.',
    ERROR_INCORRECT_CURRENT:
      languageData?.incorrect_current_password || 'Incorrect current password',

    SUCCESS_MESSAGE:
      languageData?.password_update_success || 'Your password updated successfully.',

    BUTTON_DONE: languageData?.profile_done || 'Done',
    BUTTON_UPDATING: languageData?.button_updating || 'Updating...',
    BUTTON_CONTINUE: languageData?.continue || 'Continue',
    FORGOT_PASSWORD: languageData?.login_forgot || 'Forgot Password',
    CONFIRM_NEW_PASSWORD: languageData?.confirm_new_password || 'Confirm New Password'
  }

  SUBSCRIPTION_PLAN_INFO = {
    SUBSCRIPTION_PLAN_ACTIVE:
      languageData?.subscription_plan_active ||
      'For 2× faster results, unlimited exports,and priority support.',
    SUBSCRIPTION_PLAN_CANCELLED:
      languageData?.subscription_plan_cancelled ||
      "We'd love to have you back—unlock faster results, unlimited exports, and priority support again.",
    SUB_CANCEELED: languageData?.cancel_subscription || 'Cancel Subscription',
    SUB_ACTIVE: languageData?.subscription_activate || 'Activtate',
    SUB_TRANSACTION:
      languageData?.subscription_plan_web_transactions_title || 'Transactions',
    SUB_MANAGE:
      languageData?.manage_payment_methods || 'Manage Payment Methods',
    PAYMENT_METHOD: languageData?.payment_method || 'Payment Method'
  }

  SUBSCRIPTION_STATUS = {
    ACTIVE: languageData?.active || 'Active',
    CANCELLED: languageData?.canceled || 'Cancelled',
    EXPIRED: languageData?.expired || 'Expired'
  }

  SUBSCRIPTION_PLAN_TABLE_INFO = {
    NAME_OF_PACK: languageData?.nameOfpack || 'Name of Pack',
    PRODUCT_TYPE: languageData?.productType || 'Product Type',
    DATE_PERIOD: languageData?.dataPeriod || 'Date / Period',
    PAYMENT_DETAILS: languageData?.paymentDetails || 'Payment Details',
    PRODUCT_TYPE_SUBSCRIPTION: languageData?.subscription || 'Subscription',
    PRODUCT_TYPE_TOP_UP: languageData?.top_up || 'Top Up',
    PAYMENT_BY: languageData?.payment_by || 'Payment By'
  }

  SUBSCRIPTION_CANCELLED_INFO = {
    BACK_HEADER: languageData?.cancel_subscription || 'Cancel Subscription',
    HEADER: languageData?.subscription_canceled || 'Subscription Canceled',
    // lines problem
    SUN_HEADER_FIRST:
      languageData?.sun_header_first ||
      'Your subscription has been successfully cancelled. You’ll continue to enjoy your Plus Plan benefits until 29 Aug 2025',
    SUB_HEADER_SECOND:
      languageData?.sub_header_second ||
      'No further charges will be made.You can re-subscribe anytime to regain premium features.'
  }

  CANCEL_SUBSCRIPTION_TEXT = {
    TITLE: languageData?.cancel_subscription || 'Cancel Subscription',
    HEADING: languageData?.sorry_to_see_you_go || 'We’re sorry to see you go!',
    PROMPT_PREFIX:
      languageData?.cancel_subscription_prompt_prefix ||
      'If you cancel now, you will still have access to your current plan and benefits until ',
    PROMPT_DATE: '29 Aug 2025',
    PROMPT:
      'We’re sorry to see you go! If you cancel now, you will still have access to your current plan and benefits until 29 Aug 2025',
    BULLETS: [
      languageData?.bullet_remaining_first ||
      'You can continue to use your remaining credits during this period.',
      languageData?.bullet_remaining_second_prefix ??
      'After',
      languageData?.bullet_remaining_second_suffix ??
      ', your subscription will not auto-renew, and your account will get converted to the Free Plan.',
      languageData?.bullet_remaining_third ??
      'Any unused credits will expire along with your plan.',
      languageData?.bullet_remaining_fourth ||
      'Access to premium features such as higher resolution output, watermark removal, and faster processing will end after this date.'
    ]
  }

  AYMENT_PAGE_INFO = {
    PAYMENT_WEB_HEADER:
      languageData?.payment_web_header || 'You are just one step away',
    PAYMENT_HEADER: languageData?.choose_payment || 'Choose payment method',
    PAYMENT_SUB_HEADER:
      languageData?.available_options ||
      'Following options are available in your country',
    PAYMENT_DISCLAMER:
      languageData?.auto_renew ||
      'Your subscription will be auto renewed after every billing period using the selected payment method.',
    PAYMENT_INFO:
      languageData?.payment_info ||
      'You will be charged a refundable amount of ₹1 to validate your card and ₹25 to validate your UPI. The ₹25 charge is a mandatory minimum transaction fee set by UPI, and the full amount will be refunded within 5-7 business days. Please fill in your card/UPI details. Your subscription price will be deducted only after the offer period ends.',
    PAY_BY_UPI: languageData?.pay_by_upi || 'Pay by UPI',
    PAY_BY_CARD: languageData?.pay_by_card || 'Pay by Card',
    PAY_BY_CARD_LABEL:
      languageData?.pay_by_card_label || 'Credit or Debit Card',
    PAY_BY_UPI_LABEL: 'UPI'
  }

  NOTIFICATION_TEXT = {
    Notifications:
      languageData?.superapp_notifications_title || 'Notifications',
    inAppAlerts: 'inAppAlerts',
    emails: 'emails'
  }

  PROFILE_PAGE = {
    FOLLOWER: languageData?.superapp_userprofile_followers || 'Followers',
    FOLLOWING: languageData?.superapp_userprofile_following || 'Following',
    CREATIONS: languageData?.superapp_userprofile_creations || 'Creations',
    COINS: languageData?.superapp_userprofile_coins || 'Rewards',
    CRADITS: languageData?.superapp_userprofile_credits || 'Credits',
    COINS_COUNT: '30',
    VIEW_DASHBOARD: languageData?.view_dashboard || 'View Dashboard',
    LATEST_CREATIONS:
      languageData?.superapp_userprofile_latest_creations || 'Latest Creations',
    RENEW: languageData?.renew_at || 'Renew at',
    RENEW_ON: languageData?.renews_on || 'Renews on',
    EXPIRED: languageData?.expired_at || 'Expired at',
    EDIT_PROFILE: languageData?.edit || 'Edit Profile',
    PAST_DUE: languageData?.past_due || 'Past due'
  }

  PROFILE_CONSTANTS = {
    TEXT: {
      FAILED_TO_LOAD:
        languageData?.profile_failed_to_load ||
        'Failed to load creator profile.',
      FOLLOWING_LOADING: `${languageData?.superapp_userprofile_following || 'Following'}...`,
      FOLLOWING: languageData?.superapp_userprofile_following || 'Following',
      FOLLOW: languageData?.superapp_userprofile_follow || 'Follow',
      EDIT_PROFILE: languageData?.edit || 'Edit Profile',
      LATEST_CREATIONS:
        languageData?.superapp_userprofile_latest_creations ||
        'Latest Creations',
      ABOUT_ACCOUNT:
        languageData?.profile_about_account || 'About this account',
      REPORT: languageData?.profile_report || 'Report',
      DATE_JOINED: languageData?.profile_date_joined || 'Date joined',
      ACCOUNT_BASED_IN:
        languageData?.profile_account_based || 'Account based in',
      WHAT_TO_REPORT:
        languageData?.profile_report_question || 'What do you want to report?',
      SUBMIT_REPORT: languageData?.submit_report_button || 'Submit Report',
      FOLLOWED_BY: languageData?.profile_followed_by || 'Followed by',
      DEFAULT_USERNAME: languageData?.discover_index_alt_user || 'User',
      AVATAR_ALT: languageData?.avatar_creator || 'AvatarCreator',
      AVATAR_DESKTOP_ALT: languageData?.avatar_alt || 'avatar',
      MORE_ARIA_LABEL: languageData?.superapp_search_more || 'More',
      CLOSE_ARIA_LABEL: languageData?.close || 'close'
    },

    REPORT: {
      CONFIDENTIAL_NOTE:
        languageData?.profile_report_confidential ||
        'This report is confidential. For urgent help, contact emergency services immediately.',
      TEXTAREA_ROWS: {
        MOBILE: 4,
        DESKTOP: 6
      }
    },

    STATS: {
      CREATIONS: languageData?.superapp_userprofile_creations || 'Creations',
      FOLLOWERS: languageData?.superapp_userprofile_followers || 'Followers',
      FOLLOWING: languageData?.superapp_userprofile_following || 'Following'
    }
  }

  OTP_TEXT = {
    title: {
      email: languageData?.otp_sent_to_new_email || 'OTP Sent to New Email',
      password: languageData?.otp_sent || 'OTP Sent',
      mobile: languageData?.otp_sent || 'OTP Sent'
    },
    description: {
      mobile:
        languageData?.otp_mobile_description ||
        `We've sent a one-time password (OTP) to your new mobile number. Please check your inbox and enter the OTP to verify and update your number.`,

      email:
        languageData?.otp_email_description ||
        `We've sent a one-time password (OTP) to your new email address. Please check your inbox and enter the OTP to verify and update your email.`,
      password:
        languageData?.reset_otp_instruction ||
        'We’ve sent a one-time password (OTP) to your email address. Please check your inbox and enter the OTP to continue resetting your password.',
      passwordMobile:
        languageData?.reset_otp_mobile_instruction ||
        'We’ve sent a one-time password (OTP) to your mobile number. Please check your inbox and enter the OTP to continue resetting your password.'
    },
    enterOtp: languageData?.signup_enter_otp || 'Enter OTP',
    enterNewPassword:
      languageData?.reset_enter_password || 'Enter new password',
    otpValidity:
      languageData?.reset_otp_validity || 'OTP is valid for only 30 minutes.',
    otpVerified: languageData?.login_new_pwd_title || 'OTP Verified',
    verify: {
      email: languageData?.verify_update_email || 'Verify & Update Email',
      password: languageData?.reset_verify_continue || 'Verify & Continue',
      verifying: languageData?.otp_verifying || 'Verifying...'
    },
    resendOtp: {
      default: languageData?.reset_resend_otp || 'Resend OTP',
      sending:
        languageData?.waitlist_waitlist_invite_sending_button || 'Sending...',
      resend_otp_in : languageData?.resend_otp_in || 'Resend OTP in'
    },
    emailLabel: `${languageData?.login_email || 'Email'} : `,
    errors: {
      incomplete:
        languageData?.otp_error_incomplete || 'Please enter the complete OTP.',
      invalid:
        languageData?.otp_error_invalid || 'Please enter a valid 4-digit OTP.',
      defaultOtp:
        languageData?.otp_error_default || 'Invalid OTP. Please try again.',
      resendFail:
        languageData?.otp_resend_failed ||
        'Failed to resend OTP. Please try again.'
    },
    success: {
      emailUpdate:
        languageData?.email_update_success || 'Email updated successfully!'
    },
    altTexts: {
      close: languageData?.close || 'close',
      otpSent: languageData?.otp_sent || 'OTP Sent'
    },
    otpVerifiedTitleOne:
      languageData?.otp_verified_title_one || 'Your email has been verified.',
    otpVerifiedTitleTwo:
      languageData?.otp_verified_title_two ||
      'Now, set a new password to complete the',
    otpVerifiedTitleThird:
      languageData?.otp_verified_title_three || 'reset process.',
    resetPassword: languageData?.reset_password_button || 'Reset Password',
    reSetting: languageData?.login_new_pwd_resetting || 'Resetting...',
    OK: languageData?.common_ok || 'OK',
    TOO_MANY_ATTEMPTS: languageData?.too_many_attempts || 'Too Many Attempts',
    INCORRECT_OTP_ATTEMPTS: languageData?.incorrect_otp_attempts || 'Too many incorrect OTP attempts. Please try again after %s minutes.'
  }

  FOLLOWER_LIST_CONSTANTS = {
    // Tab labels
    TABS: {
      MUTUAL: 'mutual',
      FOLLOWERS: 'followers',
      FOLLOWING: 'following',
      SUGGESTED: 'suggested'
    },

    // Tab display text (dynamic counts will be added)
    TAB_LABELS: {
      MUTUAL: languageData?.followers_tab_mutual || 'mutual',
      FOLLOWERS: languageData?.followers_tab_followers || 'followers', // need to understand problem
      FOLLOWING: languageData?.followers_tab_following || 'following',
      SUGGESTED: languageData?.followers_tab_suggested || 'Suggested'
    },

    // Static tab labels (fallback when no data)
    STATIC_TAB_LABELS: {
      MUTUAL: languageData?.followers_static_mutual || 'Mutual',
      FOLLOWERS: languageData?.followers_static_followers || 'Followers', // need to understand problem
      FOLLOWING: languageData?.followers_static_following || 'Following',
      SUGGESTED: languageData?.followers_tab_suggested || 'Suggested'
    },

    // Error and status messages
    MESSAGES: {
      FAILED_TO_LOAD:
        languageData?.followers_failed_to_load || 'Failed to load data',
      NO_DATA_FOUND: languageData?.followers_no_data_found || 'No data found',
      FAILED_TO_FOLLOW:
        languageData?.followers_failed_to_follow || 'Failed to follow',
      LOGIN_REQUIRED:
        languageData?.followers_login_required ||
        'You must be logged in to follow.',
      LOADING_INDICATOR: '...'
    },

    // Button text
    BUTTONS: {
      FOLLOW: languageData?.superapp_userprofile_follow || 'Follow',
      FOLLOWING: languageData?.superapp_userprofile_following || 'Following'
    },

    // Default values
    DEFAULTS: {
      INITIAL_TYPE: languageData?.superapp_userprofile_followers || 'Followers',
      COUNT_DEFAULT: 0
    }
  }

  PUBLISH_BAR = {
    PUBLISH: languageData?.ai_tool_publish || 'Publish',
    MAKE_PRIVATE: languageData?.ai_tool_make_private || 'Make Private',
    NOTE:
      languageData?.publish_bar_note || 'Note: By publishing, you agree to our', // lines problem
    TERMS_OF_USE: languageData?.publish_bar_terms || 'terms of use',
    DO_MORE: languageData?.ai_tool_do_more || 'Do More',
    PUBLISH_TO: languageData?.publish_bar_publish_to || 'Publish to:', // lines problem
    PUBLIC: languageData?.create_status_public || 'Public',
    PUBLISH_NOW: languageData?.ai_tool_publish_now || 'Publish Now', // word problem
    MAKING_PRIVATE: ' ...',
    PUBLISH_LOADING: languageData?.publish_bar_loading || 'Publishing...'
  }

  REMIX_BOTTOMSHEET = {
    TITLE: languageData?.remix_bottomsheet_title || 'Remix this video',
    DESCRIPTION:
      languageData?.remix_this_content_subtitle ||
      'This Bollywood video is available for reuse — spark your own creativity with it!',
    BUTTON: languageData?.remix || 'Remix'
  }
  DELETE_ACCOUNT_CONFIRM = {
    CONFIRM_DELETE_LABEL:
      languageData?.delete_account_success_title ||
      'Your Account Has Been Deleted',
    CONFIRM_DELETE_DESCRIPTION:
      languageData?.delete_account_success_message ||
      'We’re sorry to see you go. Your account and all associated data have been permanently removed.'
  }

  REGISTER_PAGE_DATA = {
    HEADER: languageData?.signup_create_account || 'Create new account',
    SUB_HEADER: languageData?.signup_get_started || 'Lets get started!',
    SUB_HEADER_SECOND:
      languageData?.signup_enter_details || 'Enter your details below',
    OTP_LABEL: 'Verification code will be sent here', // problem, line reverse
    OPTIONAL: languageData?.signup_optional || 'Optional'
  }
  RESPONSE_STATUS = {
    PROCESSING: languageData?.ai_voice_processing || 'Processing'
  }
  DASHBOARD_TABS = {
    PUBLISHED: languageData?.superapp_userprofile_published || 'Published',
    NOT_YET_PUBLISHED:
      languageData?.superapp_userprofile_not_yet_published ||
      'Not Yet Published',
    SAVED: languageData?.superapp_userprofile_saved || 'Saved',
    DRAFTS: languageData?.superapp_userprofile_drafts || 'My Drafts'
  }

  DASHBOARD_MESSAGES = {

    NO_VIDEOS_FOUND: languageData?.no_videos_found || 'No videos found.',
    NO_PHOTOS_FOUND: languageData?.no_photos_found || 'No photos found.',
    NO_AUDIOS_FOUND: languageData?.no_audios_found || 'No audios found.',
    NO_CREATION_AVAILABLE:
      languageData?.no_creations_available || 'No creations available',
    FAILED_TO_LOAD:
      languageData?.failed_to_load_dashboard_data ||
      'Failed to load dashboard data.',
    MY_DASHBOARD: languageData?.ai_tool_my_dashboard || 'My Dashboard',
    SELECT: languageData?.ai_voice_select || 'Select',
    SELECT_ALL: languageData?.select_all || 'Select All',
    UNSELECT_ALL: languageData?.unselect_all || 'Unselect All',
    UNSAVE: languageData?.unsave || 'Unsave',
    REMOVE: languageData?.delete || 'Delete',
    DELETING: languageData?.chatgpt_screen_deleting || 'Deleting...',
    SELECTED: languageData?.ai_voice_selected || 'Selected',
    DOWNLOAD: languageData?.download || 'Download',
    SHOWING_CREATIONS:
      languageData?.showing_creations || 'Showing %1$d creations',
    FILTERS_APPLIED: languageData?.filters_applied || '%1$d filters applied',
    CLEAR: languageData?.clear || 'Clear',
    NO_CONTENT_FOUND: languageData?.no_content_found || 'No content found',
    NO_SAVED_CONTENT:
      languageData?.no_saved_content || 'No saved content found',
    NO_PUBLISHED_CONTENT:
      languageData?.no_published_content || 'No published content available',
    NO_NOT_YET_PUBLISHED_CONTENT:
      languageData?.no_not_yet_published_content ||
      'No unpublished content available',
    SORT_AND_FILTER: languageData?.sort_and_filter || 'Sort & Filter',
    RESET: languageData?.reset || 'Reset',
    APPLY: languageData?.apply || 'Apply',
    DASHBOARD_RECENTLY_CREATED: languageData?.recently_created || 'Recently created',
    ALL: languageData?.avatar_gender_all || 'all',
    UNDER_REVIEW: languageData?.dashboard_under_review || 'Under review availability within 24-48 hours.'
  }

  LOGIN_PAGE_INFO = {
    LOGIN_SUB_HEADER: languageData?.login_welcome || 'Hi! Welcome back!',
    LOGIN_SUB_HEADER_SECOND:
      languageData?.login_subtitle || 'Let’s get something great done today.',
    LOGIN_RECAPTCHA: languageData?.login_recaptcha || 'This site is protected by reCAPTCHA.'
  }

  EDIT_PROFILE_PAGE = {
    GENDER: {
      MALE: languageData?.avatar_gender_male || 'Male',
      FEMALE: languageData?.avatar_gender_female || 'Female',
      PREFER_NOT_TO_SAY:
        languageData?.profile_prefer_not_say || 'Prefer not to say'
    },
    CHANGE_PIC:
      languageData?.profile_change_picture || 'Change profile picture',
    REMOVE: languageData?.profile_remove || 'Remove',
    UPLOAD_PIC: languageData?.edit_profile_upload_pic || 'Upload photo',
    USE_AVATAR: languageData?.avatar_use_avatar || 'Use an avatar',
    SAVE_CHANGES: languageData?.edit_profile_save_changes || 'Save Changes',
    SAVING: languageData?.subscription_web_saving_label || 'Saving...',
    REQUIRED: languageData?.profile_required || 'Required'
  }

  BACK_BUTTON_TITLE = {
    choosePlan: languageData?.choose_plan || 'Choose your plan',
    subscriptionPlan: languageData?.subscription_plan || 'Subscription Plan',
    compareBenefits: languageData?.compare_benefits || 'Compare benefits',
    payment: languageData?.payment || 'Payment',
    transaction:
      languageData?.subscription_plan_web_transactions_title || 'Transactions',
    subscriptionHistory:languageData?.settings_label_subscription_history || 'Subscription History'
  }

  PLAN_VALIDITY = {
    pay: languageData?.pay || 'Pay',
    monthly: languageData?.monthly || 'Monthly',
    yearly: languageData?.yearly || 'Yearly',
    topUp: languageData?.top_up || 'Top-Up'
  }

  HOW_IT_WORKS = {
    HOWITWORK: languageData?.how_it_works_title || 'How it Works',
    POINT_1_HEADING:
      languageData?.how_it_works_point_1_heading || 'Create your account',
    POINT_1_DESC: '',
    POINT_2_HEADING: languageData?.choose_plan || 'Choose your plan',
    POINT_3_HEADING:
      languageData?.how_it_works_point_3_heading || 'Pick a tool',
    POINT_3_DESC:
      languageData?.how_it_works_point_3_desc ||
      'Select one of the tool based on your need. tap on the tool for more details.',
    POINT_4_HEADING:
      languageData?.how_it_works_point_4_heading || 'Create & customize',
    POINT_4_DESC:
      languageData?.how_it_works_point_4_desc ||
      'Add your input (keyword, image, or voice), pick a style, and refine the results.',
    POINT_5_HEADING:
      languageData?.how_it_works_point_5_heading || 'Save & share',
    POINT_5_DESC:
      languageData?.how_it_works_point_5_desc ||
      'Download your creation or share it instantly.',
    HOW_TOOL_NAME_WORKS: languageData?.how_tool_name_works || 'How % works'
  }

  GenderOptions = [
    { value: 'M', label: languageData?.avatar_gender_male || 'Male' },
    { value: 'F', label: languageData?.avatar_gender_female || 'Female' },
    {
      value: 'O',
      label: languageData?.profile_prefer_not_say || 'Prefer not to say'
    }
  ]
  VoiceGender = [
    { value: 'male', label: languageData?.avatar_gender_male || 'Male' },
    { value: 'female', label: languageData?.avatar_gender_female || 'Female' }
  ]

  DESCLAIMER_TEXT = {
    backGroundChange:
      languageData?.disclaimer ||
      'Disclaimer: This image is AI-generated for creative use only. The tool owners do not claim rights over the original images or likenesses used.',
    coloriseChange:
      languageData?.disclaimer ||
      'Disclaimer: This image is AI-generated for creative use only. The tool owners do not claim rights over the original images or likenesses used.',
    imageFaceSwap:
      languageData?.disclaimer ||
      'Disclaimer: This image is AI-generated for creative use only. The tool owners do not claim rights over the original images or likenesses used.',
    videoFaceSwap:
      languageData?.video_face_swap_disclaimer ||
      'Disclaimer: This video is AI-generated for creative use only. The tool owners do not claim rights over the original images or likenesses used.',
    textToImage:
      languageData?.text_to_image_disclaimer ||
      'Disclaimer: This image is AI-generated from text prompt for creative use only. The tool owners do not claim rights over the generated content.',
    textToAudio:
      languageData?.ai_voice_disclaimer ||
      'Disclaimer: This voice clone is AI-generated for creative use only. The tool owners do not claim rights over the original voices or likenesses used.',
    actionGeneration:
      languageData?.ai_tool_action_generation_disclaimer ||
      'Disclaimer: This creation is AI-generated for creative use only. The tool owners do not claim rights over the original voices or likenesses used.',
    textToVideo:
      languageData?.ai_tool_text_to_video_disclaimer ||
      'Disclaimer: This video is AI-generated for creative use only. The tool owners do not claim rights over the original voices or likenesses used.'
  }

  INVITE_STATUS_MESSAGES = {
    DUPLICATES: {
      HEADER:
        languageData?.invite_duplicates_header || 'Duplicate Invites Found',
      MESSAGE:
        languageData?.invite_duplicates_message ||
        'Some of your friends have already been invited. You can skip them or update the list before sending again.'
    },
    SENT: {
      HEADER: languageData?.invite_sent_header || 'Invites Sent',
      MESSAGE:
        languageData?.invite_success ||
        'Your friends have been invited successfully.'
    },
    NOT_SENT: {
      HEADER: languageData?.invites_not_sent || 'Invites Not Sent',
      MESSAGE:
        languageData?.invite_not_sent_message ||
        'Something went wrong while sending your invites. Please try again later.'
    },
    ERROR_CODE: languageData?.error_code || 'Error Code'
  }

  TEXT_TO_IMAGE_AND_VIDEO = {
    TITLE: languageData?.ai_tool_text_to_image_title || 'Text to Image',
    HINTS: languageData?.ai_tool_text_to_video_hints || 'Hints:',
    PLACEHOLDER_1:
      languageData?.ai_tool_text_to_image_input_hint ||
      'Please enter what you want to create or view',
    PLACEHOLDER_2: languageData?.ai_voice_help || 'Help Center',
    PLACEHOLDER_3: languageData?.quick_start_text || 'for a quick start.',
    ASPECT_RATIO:
      languageData?.ai_tool_text_to_image_aspect || 'Image aspect ratio',
    TEXTAREA_TITLE:
      languageData?.ai_tool_text_to_video_question ||
      'What do you want to create?',
    TEXTAREA_LENGTH: 2500,
    T_T_IMAGE_TITLE_1:
      languageData?.ai_tool_text_to_image_tagline || 'Turn Words Into Art',
    T_T_IMAGE_TITLE_2:
      languageData?.text_to_image_title_2 ||
      'Create unique visuals from simple prompts.', // problem, next two lines in one line
    T_T_IMAGE_TITLE_3:
      languageData?.text_to_image_title_3 || 'Fast, easy, and limitless.',
    TITLE_VIDEO: languageData?.ai_tool_text_to_video_title || 'Text to Video',
    T_T_VIDEO_TITLE_1:
      languageData?.ai_tool_text_to_video_tagline || 'From Words to Motion',
    T_T_VIDEO_TITLE_2:
      languageData?.text_to_video_title_2 ||
      'Turn simple text prompts into stunning', // problem, next two lines in one line , need to add \n
    T_T_VIDEO_TITLE_3:
      languageData?.text_to_video_title_3 || 'AI-generated videos in seconds.',
    STYLE_PRESET:
      languageData?.ai_tool_text_to_video_style_preset || 'Style Preset',
    DURATION:
      languageData?.ai_tool_text_to_video_duration || 'Duration of video',
    REFERENCE_IMAGE: languageData?.reference_image || 'Reference Image',
    REFERENCE_IMAGE_DESC:
      languageData?.reference_image_desc ||
      'Optional - Use an image to guide the style or look.',
    OUTPUTS: languageData?.outputs || 'Outputs',
    NUMBER_OF_IMAGES: languageData?.number_of_images || 'Select the number of images to generate',
    DURATION: languageData?.duration || 'Duration',
    ASPECT_RATIO_TITLE: languageData?.aspect_ratio || 'Aspect Ratio',
    EACH_OUTPUT_USE: languageData?.each_output_use || 'Each output uses',
    CREDIT: languageData?.credit_text || 'credit',
    BASED_ON_SETTING: languageData?.based_on_setting || 'based on your current settings.'
  }

  IMAGE_TO_VIDEO_COPY = {
    TITLE:
      languageData?.ai_tool_image_to_video_with_camera_movement_title ||
      'Image to Video',
    HEADLINE:
      languageData?.ai_tool_image_to_video_with_camera_movement_tagline ||
      'From Still to Cinematic',
    DESCRIPTION_1:
      languageData?.image_to_video_description_1 ||
      'Add depth and movement to any image, creating', // need to break it, problem
    DESCRIPTION_2:
      languageData?.image_to_video_description_2 ||
      'lifelike video experiences.',
    PROMPT_LABEL:
      languageData?.ai_tool_image_to_video_with_camera_movement_prompt_label ||
      'What should happen in the video?',
    PROMPT_PLACEHOLDER_PARTS: {
      p1:
        languageData?.image_to_video_prompt_placeholder_1 ||
        'Please enter what should happen in the video or view', // need to breakit, problem
      p2: languageData?.ai_voice_help || 'Help Center',
      p3: languageData?.quick_start_text || 'for a quick start.'
    },
    MAX_PROMPT_LENGTH: 3000,
    HINTS: [
      {
        hint: languageData?.image_to_video_hint_pan || 'Pan camera',
        prompt:
          languageData?.image_to_video_prompt_pan ||
          'Pan camera slowly across the subject'
      },
      {
        hint: languageData?.image_to_video_hint_zoom || 'Zoom',
        prompt:
          languageData?.image_to_video_prompt_zoom ||
          'Start wide and slowly zoom toward the subject'
      },
      {
        hint: languageData?.image_to_video_hint_birds_eye || 'Birds eye view',
        prompt:
          languageData?.image_to_video_prompt_birds_eye ||
          'Tilt to a bird’s-eye angle of the scene'
      }
    ],
    DURATIONS: [
      { label: '5 secs', value: 5 },
      { label: '10 secs', value: 10 }
    ],
    UPLOAD_LABEL:
      languageData?.ai_tool_image_to_video_with_camera_movement_upload_photo ||
      'Upload an original photo',
    BUTTON_LABEL:
      languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)',
    DURATION_OF_VIDEO:
      languageData?.ai_tool_text_to_video_duration || 'Duration of video',
    IMAGE: language === 'hi' ? 'फोटो' : 'Image'
  }

  REWARD_LABELS = {
    rewardDetails: languageData?.superapp_userprofile_details || 'Details',
    rewardTerms: languageData?.t_and_c || 'T&C',
    rewardHowToRedeem: languageData?.how_to_redeem || 'How to Redeem',
    termsAndConditions:
      languageData?.terms_and_conditions || 'Terms & Conditions',
    howToRedeem: languageData?.how_to_redeem || 'How to Redeem',
    disclaimer:
      languageData?.offer_redemption_india_only_disclaimer ||
      'Disclaimer: This offer redemption is only available for India'
  }

  VOICE_REMIX = {
    TITLE: languageData?.ai_tool_voice_remix_title || 'Voice Remix',
    SUBTITLE_1:
      languageData?.ai_tool_voice_remix_tagline || 'Sing It Like Anyone',
    SUBTITLE_2:
      languageData?.ai_tool_voice_remix_desc ||
      'Transform any song into the timeless voice of listed singers with AI magic..', // problem extra words
    ORIGINAL_SONG: languageData?.voice_remix_original_song || 'Original Song', // problem extra words
    ORIGINAL_AUDIO: languageData?.ai_voice_selected_audio || 'Selected Audio',
    CONSENT:
      languageData?.ai_tool_voice_remix_rights_text ||
      'By uploading this song, you confirm that you own the rights to it or have permission to use it for remixing.',
    PITCH_CORRECTION:
      languageData?.ai_tool_voice_remix_pitch_correction || 'Pitch Correction',
    FORMAT_PRESERVATION:
      languageData?.ai_tool_voice_remix_format_preservation ||
      'Format Preservation',
    SELECT_SINGER:
      languageData?.ai_tool_voice_remix_select_singer || 'Select Singer',
    UPLOAD_SONG_TO_CONTINUE:
      languageData?.voice_remix_upload_song_to_continue ||
      'Upload a song to continue',
    CONFIRM_YOUR_RIGHTS: languageData?.ai_tool_voice_remix_confirm_rights || 'Confirm Your Rights',
    I_AGREE: languageData?.i_agree || 'I Agree'
  }

  PROCESSING_INDICATOR = {
    Description:
      languageData?.process_completion_time_hint ||
      'This process may take approximately 3–4 minutes to complete.',
    WORKING_ON_CREATION: languageData?.ai_tool_working_on_creation_heading || 'Working on Your Creation'
  }

  VOICE_CLONE = {
    HEADER: {
      TITLE: languageData?.ai_voice_title || 'Voice Cloning'
    },
    LANDING: {
      TITLE: languageData?.ai_voice_tagline || 'AI That Speaks for You',
      DESCRIPTION:
        languageData?.ai_voice_desc ||
        'Generate expressive, high-quality voiceovers from simple text input.'
    },
    REMOVE_BACKGROUND: {
      TITLE: languageData?.ai_voice_remove_noise || 'Remove background noise'
    },
    VOICE_SAY: {
      TITLE: languageData?.ai_voice_prompt || 'What should the voice say?'
    },
    VOICE: {
      TITLE: languageData?.ai_tool_photo_avatar_talking_voice || 'Voice',
      YOUR_VOICE: languageData?.ai_voice_your_voices || 'Your Voices',
      PRESET_VOICE: languageData?.ai_voice_presets || 'Preset Voices',
      EMPTY_VOICE: languageData?.ai_voice_no_saved || 'No voices saved yet.',
      RECORD: languageData?.voice_cloning_record_voice || 'Record Voice'
    },
    HINT: {
      TITLE_1:
        languageData?.voice_clone_prompt_placeholder ||
        'Please enter what the voice should say or view', // problem, all in one line
      TITLE_2: languageData?.quick_start_text || 'for a quick start.',
      HELP: languageData?.ai_voice_help || 'Help Center'
    },
    HINTS: languageData?.ai_voice_hints || 'Hints',
    VOICE_CLONE_TITLES: {
      EDIT_VOICE: languageData?.ai_voice_edit || 'Edit Voice',
      HELP: languageData?.ai_voice_help || 'Help Center',
      VOICE_LIBRARY: languageData?.ai_voice_library || 'Voice Library'
    },
    BUTTON: {
      EDIT: languageData?.ai_tool_edit || 'Edit',
      DELETE: languageData?.ai_tool_discard || 'Discard'
    },
    INPUT: {
      NAME: languageData?.name || 'Name',
      REQUIRED: languageData?.ai_voice_required || 'Required',
      DESCRIPTION: languageData?.ai_voice_description || 'Description'
    },
    STATUS: {
      GENERATING:
        languageData?.create_action_generation_generating || 'Generating...',
      GENERATE:
        languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)',
      UPDATING: languageData?.button_updating || 'Updating...',
      SAVE_CHANGES: languageData?.edit_profile_save_changes || 'Save Changes',
      STOP_RECORDING: languageData?.ai_voice_stop || 'Stop Recording',
      START_RECORDING: languageData?.ai_voice_start || 'Start Recording',
      COMPLETED: languageData?.voice_clone_status_completed || 'completed',
      FAILED: languageData?.voice_clone_status_failed || 'failed',
      ERROR: languageData?.error || 'Error',
      WENT_WRONG: languageData?.play_error_title || 'Something went wrong',
      NO_DATA: languageData?.voice_clone_status_no_data || 'No Data'
    },
    RECORD: {
      DESCRIPTION:
        languageData?.voice_clone_record_desc ||
        'Record at least 5 seconds of clear voice for best results'
    }
  }

  ACTION_GENERATION = {
    TITLE: languageData?.ai_tool_action_generation_title || 'Action Generation',
    ACTION_LABEL:
      languageData?.ai_tool_action_generation_choose_action || 'Choose Action',
    ACTION_UPLOAD_IMAGE:
      languageData?.ai_tool_action_generation_upload_image || 'Upload Image',
    ACTION_IMAGE_DESCRIPTION_FOR_TWO_IMAGES:
      languageData?.best_results_two_faces ||
      'Best results when two faces are provided',
    ACTION_IMAGE_DESCRIPTION_FOR_ONE_IMAGE:
      languageData?.best_results_two_faces ||
      'Best results when two faces are provided', // problem, saying to select two at the place of one
    FIRST_IMAGE:
      languageData?.ai_tool_action_generation_first_image || 'First Image',
    SECOND_IMAGE:
      languageData?.ai_tool_action_generation_second_image || 'Second Image',
    ACTION_GENERATION_TITLE_1:
      languageData?.ai_tool_action_generation_tagline || 'From Still to Motion',
    ACTION_GENERATION_TITLE_2:
      languageData?.action_generation_title_two ||
      'Turn any image into dynamic action using', // problem, next two lines in one
    ACTION_GENERATION_TITLE_3:
      languageData?.action_generation_title_three || 'AI-powered presets.',
    PROMOTIONAL_TITLE_1:
      languageData?.ai_tool_action_generation_tagline || 'From Still to Motion',
    PROMOTIONAL_TITLE_2:
      languageData?.action_generation_title_two ||
      'Turn any image into dynamic action using', // problem, next two lines in one
    PROMOTIONAL_TITLE_3:
      languageData?.action_generation_title_three || 'AI-powered presets.',
    REQUIRED_LABEL: languageData?.ai_voice_required || 'Required',
    OPTIONAL_LABEL: languageData?.signup_optional || 'Optional',
    FIRST_FRAME_TITLE: languageData?.first_frame || 'First Frame',
    LAST_FRAME_TITLE: languageData?.last_frame || 'Last Frame'
  }

  MOTION_CONTROL = {
    TITLE: languageData?.motion_control_title || 'Motion Control',
    HEADLINE:
      languageData?.motion_control_heading || 'Bring characters into motion',
    DESCRIPTION:
      languageData?.motion_control_description ||
      'Transfer dance, action, or gestures to your character in seconds.',
    ACTION_VIDEO_LABEL:
      languageData?.motion_control_action_video_to_mimic ||
      'Action video to mimic',
    CHARACTER_IMAGE_LABEL:
      languageData?.motion_control_character_image || 'Character Image',
    SELECT_FROM_COLLECTION:
      languageData?.user_upload_label || 'Select one from our collection',
    UPLOAD_ORIGINAL:
      languageData?.motion_control_upload_video || 'Upload an original video',
    PROMPT_PLACEHOLDER_1:
      languageData?.motion_control_prompt_placeholder_1 ||
      'Please enter the prompt or view',
    PROMPT_PLACEHOLDER_2: languageData?.ai_voice_help || 'Help Center',
    PROMPT_PLACEHOLDER_3:
      languageData?.quick_start_text || 'for a quick start.',
    BUTTON_LABEL:
      languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)',
    MAX_PROMPT_LENGTH: 2500,
    GENERATING:
      languageData?.create_action_generation_generating || 'Generating...',
    SELECT_IMAGE_ERROR:
      languageData?.motion_control_select_image_error ||
      'Please upload a character image.',
    GENERATE_FAILED:
      languageData?.motion_control_generate_failed ||
      'Failed to start generation.',
    PROCESS_VIDEO_ERROR:
      languageData?.motion_control_process_video_error ||
      'Could not process the uploaded video file.',
    SELECT_VIDEO_ERROR:
      languageData?.motion_control_select_video_error ||
      'Please select or upload an action video.'
  }

  WORKSPACE_BOTTOM_SHEET = {
    CREATE:
      languageData?.ai_tool_text_to_llm_create_new_workspace ||
      'Create New Workspace',
    EXISTING: languageData?.existing || 'Existing',
    NO_WORKSPACES: languageData?.no_workspace || 'No workspaces found',
    RENAME: languageData?.ai_tool_text_to_llm_rename || 'Rename',
    LOADING: languageData?.loading_workspace || 'Loading workspaces...', // check these teo loadings, problem
    LOADING:
      languageData?.loading_workspace_suggestion || 'Loading suggestions...',
    FAILD: languageData?.workspace_failed || 'Failed to load suggestions',
    CAMERA: languageData?.ai_tool_text_to_llm_use_camera || 'Use Camera',
    PHOTOS: languageData?.ai_tool_text_to_llm_add_photos || 'Add Photos',
    FILES: languageData?.ai_tool_text_to_llm_upload_files || 'Upload Files'
  }

  TALKING_AVATAR = {
    HEADER: {
      TITLE:
        languageData?.ai_tool_photo_avatar_talking_title || 'Talking Avatar'
    },
    IMAGE: {
      TITLE: language === 'hi' ? 'फोटो' : 'Image',
      REMOVE: languageData?.profile_remove || 'Remove'
    },
    LANDING: {
      TITLE:
        languageData?.ai_tool_photo_avatar_talking_tagline ||
        'Bring Photos to Life',
      DESCRIPTION:
        languageData?.ai_tool_photo_avatar_talking_desc ||
        'Turn any image and audio into a lifelike talking avatar with AI.'
    },
    UPLOAD: {
      TITLE:
        languageData?.ai_tool_photo_avatar_talking_upload_photo ||
        'Upload an original photo'
    },
    BUTTON_TITLE: {
      GENERATE:
        languageData?.ai_tool_scene_swap_generate || 'Generate (% Credits)'
    },
    VOICE: {
      TITLE: languageData?.ai_tool_photo_avatar_talking_voice || 'Voice'
    },
    PROMPT: {
      TITLE:
        languageData?.ai_tool_photo_avatar_talking_action_prompt ||
        'Action Prompt'
    },
    HINT: {
      TITLE_1:
        language === 'hi'
          ? 'कृपया टॉकिंग एवाटार के लिए क्रियाएं दर्ज करें या देखें'
          : 'Please enter the actions for the talking avatar or view', // all in one, problem
      TITLE_2: languageData?.quick_start_text || 'for a quick start.',
      HELP: languageData?.ai_voice_help || 'Help Center'
    },
    HINTS:
      languageData?.ai_tool_image_to_video_with_camera_movement_hints ||
      'Hints:'
  }

  LOGIN_PAGE_LABEL = {
    MOBILE_EMAIL_LABEL:
      languageData?.mobile_email_label || 'Mobile Number or Email',
    EMAIL_LABEL: languageData?.login_email || 'Email',
    MOBILE_LABEL: languageData?.mobile_number || 'Mobile Number'
  }

  CONTACT_LABEL = {
    MOBILE_NUMBER: languageData?.mobile_number || 'Mobile Number',
    OPTIONAL: `(${languageData?.signup_optional || 'Optional'})`,
    ADD_VERIFY: languageData?.add_and_verify || 'Add & Verify',
    EMAIL: languageData?.login_email || 'Email',
    RECOMMENDED: languageData?.recommended || '(Recommended)',
    ADD_EMAIL_DESCRIPTION:
      languageData?.enter_email_to_link_account ||
      "Enter your email address to link it with your account. A verification code will be sent to the address to confirm it's yours."
  }

  TEXT_TO_IMAGE_HELP_CENTER = {
    TITLE: languageData?.text_to_image_help_title || 'What is Text to Image?',
    DESCRIPTION:
      languageData?.text_to_image_help_description ||
      'Text to Image lets you create an image by typing what you want to see. The image is generated based on the description you enter.',

    FIND_TITLE:
      languageData?.text_to_image_help_find_title ||
      'Where can I find Text to Image?',
    FIND_STEPS: [
      languageData?.text_to_image_help_find_step_one ||
      'Go to the Image Section on the platform.',
      languageData?.text_to_image_help_find_step_two ||
      'Select the Text to Image option.'
    ],

    CREATE_TITLE:
      languageData?.text_to_image_help_create_title ||
      'How do I create an image using text?',
    CREATE_STEPS: [
      {
        text:
          languageData?.text_to_image_help_create_step_one ||
          'Enter a clear description of the image you want in the text box',
        examples: [
          languageData?.text_to_image_help_example_one ||
          'A sunset over the ocean with palm trees'
        ]
      },
      {
        text:
          languageData?.text_to_image_help_create_step_two ||
          'Select the image aspect ratio',
        examples: [
          languageData?.text_to_image_help_example_ratios ||
          'Square, Portrait, or Landscape'
        ]
      },
      {
        text:
          languageData?.text_to_image_help_create_step_three ||
          'Click on Generate'
      }
    ],

    CREATE_RESULT:
      languageData?.text_to_image_help_create_result ||
      'The system will create an image based on your text and selected aspect ratio.',

    ASPECT_RATIO_TITLE:
      languageData?.text_to_image_help_aspect_ratio_title ||
      'Why do I need to select an aspect ratio?',
    ASPECT_RATIO_POINTS: [
      languageData?.text_to_image_help_aspect_ratio_point_one ||
      'The aspect ratio defines the shape and size of the image.',
      languageData?.text_to_image_help_aspect_ratio_point_two ||
      'Choosing the right ratio helps generate an image that fits your purpose, such as social media posts or banners.'
    ],

    CHANGE_TITLE:
      languageData?.text_to_image_help_change_title ||
      'Can I change the text or aspect ratio?',
    CHANGE_DESCRIPTION:
      languageData?.text_to_image_help_change_description ||
      'Yes. You can edit the text or change the aspect ratio anytime before clicking Generate.',

    TIPS_TITLE:
      languageData?.text_to_image_help_tips_title || 'Tips for better images',
    TIPS: [
      languageData?.text_to_image_help_tip_one ||
      'Be clear and specific in your description.',
      languageData?.text_to_image_help_tip_two ||
      'Mention important details like colors, background, or style.',
      languageData?.text_to_image_help_tip_three ||
      'Choose the aspect ratio based on where you plan to use the image.'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.text_to_image_help_point_one ||
      'Try rephrasing your description.',
      languageData?.text_to_image_help_point_two ||
      'Select a different aspect ratio.',
      languageData?.text_to_image_help_point_three ||
      'Contact the ErosUniverse support team.'
    ],
    EXAMPLE: languageData?.text_to_image_help_example || 'Example'
  }

  VOICE_CLONE_HELP_CENTER = {
    TITLE: languageData?.voice_clone_help_title || 'What is Voice Cloning?',
    DESCRIPTION:
      languageData?.voice_clone_help_description ||
      'Voice Cloning lets you generate audio using a selected voice. The generated voice will sound similar to the chosen voice while speaking the text you enter.',

    FIND_TITLE:
      languageData?.voice_clone_help_find_title ||
      'Where can I find Voice Cloning?',
    FIND_POINTS: [
      languageData?.voice_clone_help_find_point_first ||
      'Go to the Voice Section on the platform.',
      languageData?.voice_clone_help_find_point_second ||
      'From here, you can select, upload, or record voices and generate audio.'
    ],

    OPTIONS_TITLE:
      languageData?.voice_clone_help_options_title ||
      'What voice options can I use?',
    OPTIONS_DESCRIPTION:
      languageData?.voice_clone_help_options_description ||
      'You can choose any one of the following:',
    OPTIONS: [
      languageData?.voice_clone_option_recorded ||
      'Your Recorded Voice – A voice you previously recorded',
      languageData?.voice_clone_option_provided ||
      'Provided Voices – Voices given by the ErosUniverse team',
      languageData?.voice_clone_option_upload ||
      'Upload Voice – Upload an external voice file',
      languageData?.voice_clone_option_record_new ||
      'Record New Voice – Record a fresh voice using your microphone'
    ],

    GENERATE_TITLE:
      languageData?.voice_clone_help_generate_title ||
      'How do I generate a voice?',
    GENERATE_STEPS: [
      languageData?.voice_clone_generate_step_select ||
      'Select a voice from the list',
      languageData?.voice_clone_generate_step_enter_text ||
      'Enter your text in the text box',
      languageData?.voice_clone_generate_step_generate || 'Click on Generate'
    ],

    GENERATE_RESULT:
      languageData?.voice_clone_help_generate_result ||
      'The system will create audio using the selected voice. The voice will sound similar to the selected voice while speaking your text.',

    CHANGE_TITLE:
      languageData?.voice_clone_help_change_title || 'Can I change the voice?',
    CHANGE_DESCRIPTION:
      languageData?.voice_clone_help_change_description ||
      'Yes. You can switch voices anytime before clicking Generate.',

    TIPS_TITLE:
      languageData?.voice_clone_help_tips_title || 'Tips for better results',
    TIPS: [
      languageData?.voice_clone_tip_clear_audio || 'Use clear voice recordings',
      languageData?.voice_clone_tip_no_noise ||
      'Avoid background noise while recording',
      languageData?.voice_clone_tip_simple_text || 'Enter clear and simple text'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.voice_clone_help_check_microphone ||
      'Check microphone access',
      languageData?.voice_clone_help_audio_clear ||
      'Make sure the audio file is clear',
      languageData?.voice_clone_help_contact_support ||
      'Contact the ErosUniverse support team'
    ]
  }

  IMAGE_TO_VIDEO_HELP_CENTER = {
    TITLE: languageData?.image_to_video_help_title || 'What is Image to Video?',
    DESCRIPTION:
      languageData?.image_to_video_help_description ||
      'Image to Video lets you turn a single photo into a video. You upload an image, describe how the video should look and move, and the system creates a video from it.',

    FIND_TITLE:
      languageData?.image_to_video_help_find_title ||
      'Where can I find Image to Video?',
    FIND_POINTS: [
      languageData?.image_to_video_help_find_point_first ||
      'Go to the Create Section on the platform.',
      languageData?.image_to_video_help_find_point_second ||
      'Select the Image to Video tool from the available options.'
    ],

    CREATE_TITLE:
      languageData?.image_to_video_help_create_title ||
      'How do I create a video from an image?',
    CREATE_STEPS: [
      languageData?.image_to_video_help_create_step_upload ||
      'Upload the original photo you want to convert into a video.',
      languageData?.image_to_video_help_create_step_description ||
      'Enter a description explaining the type of video, movement, and camera angles.',
      languageData?.image_to_video_help_create_step_example ||
      'Example: Smooth motion, Zoom in, Pan left, Cinematic view',
      languageData?.image_to_video_help_create_step_duration ||
      'Select the duration of the video.',
      languageData?.image_to_video_help_create_step_generate ||
      'Click on Generate.'
    ],

    CREATE_RESULT:
      languageData?.image_to_video_help_create_result ||
      'The system will create a video based on your image and description.',

    DESCRIPTION_IMPORTANCE_TITLE:
      languageData?.image_to_video_help_description_importance_title ||
      'Why is the description important?',
    DESCRIPTION_IMPORTANCE_POINTS: [
      languageData?.image_to_video_help_description_importance_point_flow ||
      'The description tells the system how the image should move and flow.',
      languageData?.image_to_video_help_description_importance_point_camera ||
      'Camera angles help define the visual style of the video.'
    ],

    CHANGE_TITLE:
      languageData?.image_to_video_help_change_title ||
      'Can I change the image or description?',
    CHANGE_DESCRIPTION:
      languageData?.image_to_video_help_change_description ||
      'Yes. You can change the image, description, or duration anytime before clicking Generate.',

    TIPS_TITLE:
      languageData?.image_to_video_help_tips_title || 'Tips for better results',
    TIPS: [
      languageData?.image_to_video_tip_clear_image ||
      'Upload a clear and high-quality image.',
      languageData?.image_to_video_tip_specific_motion ||
      'Be specific about movement and camera angles.',
      languageData?.image_to_video_tip_duration ||
      'Choose a suitable duration for smoother results.'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.image_to_video_help_rewrite_description ||
      'Try rewriting the description.',
      languageData?.image_to_video_help_upload_different_image ||
      'Upload a different image.',
      languageData?.image_to_video_help_change_duration ||
      'Change the duration.',
      languageData?.image_to_video_help_contact_support ||
      'Contact the ErosUniverse support team.'
    ]
  }

  COLORIZE_HELP_CENTER = {
    TITLE: languageData?.colorize_help_title || 'What is Colorize?',
    DESCRIPTION:
      languageData?.colorize_help_description ||
      'Colorize lets you add natural, realisxtic colors to black-and-white or faded photos using AI.It restores skin tones, clothing colors, and background details while preserving the original look of the image.',

    FIND_TITLE:
      languageData?.colorize_help_find_title || 'Where can I find Colorize?',
    FIND_POINTS: [
      languageData?.colorize_help_find_point_first ||
      'Go to the Image Section on the platform.',
      languageData?.colorize_help_find_point_second ||
      'Select the Colorize option.'
    ],

    CREATE_TITLE:
      languageData?.colorize_help_create_title || 'How do I colorize a photo?',
    CREATE_STEPS: [
      languageData?.colorize_help_create_upload ||
      'Upload a black-and-white or old photo',
      languageData?.colorize_help_create_choose_mode || 'Choose a Mode',
      languageData?.colorize_help_create_mode_auto || 'Auto',
      languageData?.colorize_help_create_mode_colorize || 'Colorize',
      languageData?.colorize_help_create_mode_bw || 'Black & White',
      languageData?.colorize_help_create_choose_preset || 'Select a Preset',
      languageData?.colorize_help_create_preset_examples ||
      'Natural, Vibrant, Warm, Cool, Cinematic, Retro, etc.',
      languageData?.colorize_help_create_optional_desc ||
      '(Optional) Describe what you want in the text box',
      languageData?.colorize_help_create_example ||
      'Example: “Natural skin tones with soft, warm lighting”',
      languageData?.colorize_help_create_generate || 'Click Generate',
      languageData?.colorize_help_create_result ||
      'The system will restore colors based on your selection and description.'
    ],

    PRESET_SELECT:
      languageData?.colorize_help_preset_select_title ||
      'Why should I choose a preset?',
    PRESET_SELECT_POINTS: [
      languageData?.colorize_help_preset_select_point_mood ||
      'Presets control the overall mood and color style of the image.',
      languageData?.colorize_help_preset_select_point_results ||
      'Choosing the right preset helps achieve results like natural portraits, cinematic looks, or vintage tones.'
    ],

    MODE_SELECT:
      languageData?.colorize_help_mode_select_title ||
      'Can I change the mode or preset?',
    MODE_SELECT_POINTS: [
      languageData?.colorize_help_mode_select_yes || 'Yes.',
      languageData?.colorize_help_mode_select_change_anytime ||
      'You can change the mode, preset, or description anytime before clicking Generate.'
    ],

    TIPS_TITLE:
      languageData?.colorize_help_tips_title || 'Tips for better results',
    TIPS: [
      languageData?.colorize_help_tip_clear_photo ||
      'Use clear photos for best results',
      languageData?.colorize_help_tip_natural_skin ||
      'Choose Natural for realistic skin tones',
      languageData?.colorize_help_tip_cinematic ||
      'Use Cinematic or Warm for emotional photos',
      languageData?.colorize_help_tip_simple_prompt ||
      'Avoid over-describing—simple prompts work best'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.colorize_help_issue_intro || 'If you face any issues:',
      languageData?.colorize_help_try_preset || 'Try a different preset',
      languageData?.colorize_help_rewrite_desc || 'Rewrite your description',
      languageData?.colorize_help_upload_better_image ||
      'Upload a higher-quality image',
      languageData?.colorize_help_contact_support ||
      'Contact the ErosUniverse support team.'
    ]
  }

  TALKING_AVATAR_HELP_CENTER = {
    TITLE: languageData?.talking_avatar_help_title || 'What is Talking Avatar?',
    DESCRIPTION:
      languageData?.talking_avatar_help_description ||
      'Talking Avatar lets you turn an image into a talking character. You upload a photo, add a voice, enter text, and the image will speak the text you provide.',

    FIND_TITLE:
      languageData?.talking_avatar_help_find_title ||
      'Where can I find Talking Avatar?',
    FIND_POINTS: [
      languageData?.talking_avatar_help_find_point_first ||
      'Go to the Avatar Section on the platform.',
      languageData?.talking_avatar_help_find_point_second ||
      'Select the Talking Avatar option.'
    ],

    CREATE_TITLE:
      languageData?.talking_avatar_help_create_title ||
      'How do I create a talking avatar?',
    CREATE_STEPS: [
      languageData?.talking_avatar_help_create_upload_image ||
      'Upload the image you want to make talk.',
      languageData?.talking_avatar_help_create_upload_voice ||
      'Upload a single clear voice file.',
      languageData?.talking_avatar_help_create_voice_quality ||
      'The voice should not have multiple speakers or distortion',
      languageData?.talking_avatar_help_create_record_voice ||
      'Or click Record Now to record your voice using the microphone',
      languageData?.talking_avatar_help_create_enter_text ||
      'Enter the text you want the image to speak.',
      languageData?.talking_avatar_help_create_generate || 'Click on Generate.'
    ],

    CREATE_RESULT:
      languageData?.talking_avatar_help_create_result ||
      'The system will create a talking avatar using the uploaded image and voice.',

    VOICE_GUIDELINES_TITLE:
      languageData?.talking_avatar_help_voice_guidelines_title ||
      'Voice guidelines',
    VOICE_GUIDELINES: [
      languageData?.talking_avatar_help_voice_single ||
      'Upload only one voice per generation.',
      languageData?.talking_avatar_help_voice_no_noise ||
      'Avoid background noise and distortion.',
      languageData?.talking_avatar_help_voice_clear ||
      'Use a clear and natural voice for best results.'
    ],

    TEXT_WITHOUT_VOICE_TITLE:
      languageData?.talking_avatar_help_text_without_voice_title ||
      'Can I use text without uploading a voice?',
    TEXT_WITHOUT_VOICE_POINTS: [
      languageData?.talking_avatar_help_text_without_voice_behavior ||
      'The avatar will speak using the uploaded or recorded voice.',
      languageData?.talking_avatar_help_text_without_voice_required ||
      'Make sure a voice is added before clicking Generate.'
    ],

    TIPS_TITLE:
      languageData?.talking_avatar_help_tips_title || 'Tips for best results',
    TIPS: [
      languageData?.talking_avatar_help_tip_clear_image ||
      'Use a clear, front-facing image.',
      languageData?.talking_avatar_help_tip_no_blur ||
      'Avoid blurry or low-quality photos.',
      languageData?.talking_avatar_help_tip_quiet_recording ||
      'Record voice in a quiet environment.',
      languageData?.talking_avatar_help_tip_simple_text ||
      'Enter clear and simple text.'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.talking_avatar_help_check_permissions ||
      'Check microphone permissions.',
      languageData?.talking_avatar_help_voice_file_clear ||
      'Ensure the voice file is clear.',
      languageData?.talking_avatar_help_try_different_input ||
      'Try uploading a different image or voice.',
      languageData?.talking_avatar_help_contact_support ||
      'Contact the ErosUniverse support team.'
    ]
  }

  TEXT_TO_VIDEO_HELP_CENTER = {
    TITLE: languageData?.text_to_video_help_title || 'What is Text to Video?',
    DESCRIPTION:
      languageData?.text_to_video_help_description ||
      'Text to Video lets you create a video by typing what you want to see. The video is generated based on your text, selected style, and chosen duration.',

    FIND_TITLE:
      languageData?.text_to_video_help_find_title ||
      'Where can I find Text to Video?',
    FIND_POINTS: [
      languageData?.text_to_video_help_find_point_first ||
      'Go to the Create Section on the platform.',
      languageData?.text_to_video_help_find_point_second ||
      'Select the Text to Video tool from the available options.'
    ],

    CREATE_TITLE:
      languageData?.text_to_video_help_create_title ||
      'How do I create a video using text?',
    CREATE_STEPS: [
      languageData?.text_to_video_help_create_enter_text ||
      'Enter the text describing the video you want to generate.',
      languageData?.text_to_video_help_create_select_style ||
      'Select a video style from the available options.',
      languageData?.text_to_video_help_create_choose_duration ||
      'Choose the duration of the video.',
      languageData?.text_to_video_help_create_generate || 'Click on Generate.'
    ],

    CREATE_RESULT:
      languageData?.text_to_video_help_create_result ||
      'The system will create a video based on your text and selected settings.',

    STYLE_DURATION_TITLE:
      languageData?.text_to_video_help_style_duration_title ||
      'Why do I need to select style and duration?',
    STYLE_DURATION_POINTS: [
      languageData?.text_to_video_help_style_define ||
      'The style defines the look and feel of the video.',
      languageData?.text_to_video_help_duration_control ||
      'The duration controls how long the video will be.'
    ],

    CHANGE_TITLE:
      languageData?.text_to_video_help_change_title ||
      'Can I change the text, style, or duration?',
    CHANGE_DESCRIPTION:
      languageData?.text_to_video_help_change_description ||
      'Yes. You can update the text, style, or duration anytime before clicking Generate.',

    TIPS_TITLE:
      languageData?.text_to_video_help_tips_title || 'Tips for better videos',
    TIPS: [
      languageData?.text_to_video_help_tip_clear_text ||
      'Use clear and detailed text.',
      languageData?.text_to_video_help_tip_match_style ||
      'Choose a style that matches your content.',
      languageData?.text_to_video_help_tip_duration_use_case ||
      'Select a suitable duration based on your use case.'
    ],

    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.text_to_video_help_rewrite_text ||
      'Try rewriting the text.',
      languageData?.text_to_video_help_change_style_duration ||
      'Change the style or duration.',
      languageData?.text_to_video_help_contact_support ||
      'Contact the ErosUniverse support team.'
    ]
  }

  MOTION_CONTROL_HELP_CENTER = {
    MAIN_TITLE: languageData?.motion_control_title || 'Motion Control',
    FOR_BEST_RESULTS: languageData?.for_best_results || 'For best results:',
    TITLE: languageData?.motion_control_help_title || 'What is Motion Control?',
    DESCRIPTION:
      languageData?.motion_control_help_description ||
      'Motion Control allows you to transfer movement from an action video to your character image. You can make your character dance, perform gestures, or act like the reference video in seconds.',
    CREATE_TITLE:
      languageData?.motion_control_help_create_title ||
      'How do I create a motion video?',
    CREATE_STEPS: [
      languageData?.motion_control_help_create_step_1 ||
      'Choose an Action Video to Mimic',
      languageData?.motion_control_help_create_step_2 ||
      'Upload a Character Image',
      languageData?.motion_control_help_create_step_3 || 'Click Generate'
    ],
    REFERENCE_VIDEO_TITLE:
      languageData?.motion_control_help_ref_video_title ||
      'What type of videos work best as reference?',
    REFERENCE_VIDEO_POINTS: [
      languageData?.motion_control_help_ref_video_point_1 ||
      'Use clear full-body videos',
      languageData?.motion_control_help_ref_video_point_2 ||
      'Ensure the subject is fully visible',
      languageData?.motion_control_help_ref_video_point_3 ||
      'Avoid heavy background crowding',
      languageData?.motion_control_help_ref_video_point_4 ||
      'Short videos (5–10 seconds) generate better results'
    ],
    CHARACTER_IMAGE_TITLE:
      languageData?.motion_control_help_char_image_title ||
      'What type of character image works best?',
    CHARACTER_IMAGE_POINTS: [
      languageData?.motion_control_help_char_image_point_1 ||
      'Full-body image preferred',
      languageData?.motion_control_help_char_image_point_2 || 'Clear posture',
      languageData?.motion_control_help_char_image_point_3 || 'Good lighting',
      languageData?.motion_control_help_char_image_point_4 ||
      'Avoid cropped arms or legs'
    ],
    UPLOAD_OWN_VIDEO_TITLE:
      languageData?.motion_control_help_upload_own_title ||
      'Can I upload my own action video?',
    UPLOAD_OWN_VIDEO_DESC:
      languageData?.motion_control_help_upload_own_desc ||
      'Yes. You can upload an original video to transfer its movement to your character. Make sure:',
    UPLOAD_OWN_VIDEO_POINTS: [
      languageData?.motion_control_help_upload_own_point_1 ||
      'The motion is visible',
      languageData?.motion_control_help_upload_own_point_2 ||
      'The video is stable',
      languageData?.motion_control_help_upload_own_point_3 ||
      'The subject is clearly framed'
    ],
    GENERATION_TIME_TITLE:
      languageData?.motion_control_help_gen_time_title ||
      'How long does generation take?',
    GENERATION_TIME_DESC:
      languageData?.motion_control_help_gen_time_desc ||
      'Motion generation usually takes a few seconds to a minute, depending on:',
    GENERATION_TIME_POINTS: [
      languageData?.motion_control_help_gen_time_point_1 || 'Video length',
      languageData?.motion_control_help_gen_time_point_2 || 'Motion complexity',
      languageData?.motion_control_help_gen_time_point_3 ||
      'Character image clarity'
    ],
    ORIGINAL_IMAGE_CHANGE_TITLE:
      languageData?.motion_control_help_image_change_title ||
      'Will my original image change?',
    ORIGINAL_IMAGE_CHANGE:
      languageData?.motion_control_help_image_change_desc ||
      'No. Your original image remains unchanged. Motion Control creates a new animated version.',
    TIPS_TITLE:
      languageData?.motion_control_help_tips_title || 'Tips for Best Results',
    TIPS: [
      languageData?.motion_control_help_tip_1 ||
      'Use full-body character images',
      languageData?.motion_control_help_tip_2 || 'Avoid extreme fast movements',
      languageData?.motion_control_help_tip_3 ||
      'Choose well-lit reference videos',
      languageData?.motion_control_help_tip_4 || 'Shorter clips work better'
    ],
    HELP_TITLE: languageData?.login_forgot_pwd_need_help || 'Need help?',
    HELP_POINTS: [
      languageData?.motion_control_help_point_1 ||
      'Contact the ErosUniverse support team.'
    ]
  }

  CONTACT_LABEL = {
    MOBILE_NUMBER: languageData?.mobile_number || 'Mobile Number',
    OPTIONAL: `(${languageData?.signup_optional || 'Optional'})`,
    ADD_VERIFY: languageData?.add_and_verify || 'Add & Verify',
    EMAIL: languageData?.login_email || 'Email',
    RECOMMENDED: languageData?.recommended || '(Recommended)',
    ADD_EMAIL_DESCRIPTION:
      languageData?.enter_email_to_link_account ||
      "Enter your email address to link it with your account. A verification code will be sent to the address to confirm it's yours."
  }

  PAGE_NAME = {
    ...PAGE_NAME,
    Suggestedforyou:
      languageData?.page_name_suggested_for_you || 'Suggestedforyou', // problem did not changed due to navigation
    PopularMovies: languageData?.page_name_popular_movies || 'PopularMovies',
    PopularCharacters:
      languageData?.page_name_popular_char || 'PopularCharacters',
    Home: languageData?.page_name_home || 'home',
    Create: languageData?.page_name_create || 'create',
    MyWallet: languageData?.page_name_my_wallet || 'My Wallet',
    EarnCoins: languageData?.earn_more_title || 'Earn More Rewards',
    Rewards: languageData?.page_name_rewards || 'Redeem Rewards',
    Transactions:
      languageData?.subscription_plan_web_transactions_title || 'Transactions'
  }

  THEME_COPY = {
    ...THEME_COPY,
    LABEL: languageData?.theme_copy_label || 'theme',
    TITLE: languageData?.theme_copy_title || 'Theme',
    DESCRIPTION:
      languageData?.theme_description ||
      'Choose how the app looks. You can switch between Light, Dark, or follow your device’s system theme.',
    ERROR: languageData?.theme_copy_error || 'Failed to update theme',
    PREFERENCES: languageData?.theme_copy_preference || 'preferences'
  }

  THEME_OPTIONS = [
    {
      key: 'system',
      label: languageData?.theme_option_default || 'System Default'
    },
    { key: 'light', label: languageData?.theme_option_light || 'Light' },
    { key: 'dark', label: languageData?.theme_option_dark || 'Dark' }
  ]

  IMAGE_ALT = {
    ...IMAGE_ALT,
    LoggedOut: languageData?.image_alt_logged_out || 'Logged out'
  }

  NO_ACTIVE_PLAN = 'No Active Plan'

  NOTIFICATION_DISABLE_MESSAGES = {
    ...NOTIFICATION_DISABLE_MESSAGES,
    TITLE: languageData?.notification_disable_title || 'Notifications Disabled',
    MESSAGE:
      languageData?.notification_disable_message ||
      'You have disabled notifications in your settings. To see notifications here, please enable them in Settings.',
    SETTINGS_LINK:
      languageData?.notification_disable_setting_link || 'Go to Settings'
  }

  VERIFY_SIGNUP_DATA = {
    ...VERIFY_SIGNUP_DATA,
    VERIFY_SIGNUP_LABEL:
      languageData?.signup_almost_there || "You're almost there!",
    VERIFY_SIGNUP_SUBLABEL:
      languageData?.verify_signup_sub_label ||
      "We've sent a One-Time Password (OTP) to your email address. Please enter it below to verify your email and complete the setup.",
    VERIFY_MOBILE_SIGNUP_SUBLABEL:
      languageData?.verify_mobile_signup_sub_label ||
      "We've sent a One-Time Password (OTP) to your mobile number. Please enter it below to verify your mobile number and complete the sign up.",
    MOBILE_FOOTER_LABEL:
      languageData?.verify_mobile_signup_footer_label ||
      "Mobile number verification is required to create, like, or comment. Feel free to keep browsing and enjoying the content in the meantime.",
    EMAIL_FOOTER_LABEL:
      languageData?.verify_signup_footer_label ||
      "Email verification is required to create, like, or comment. Feel free to keep browsing and enjoying the content in the meantime."
  }

  FOOTER_LINKS = {
    ...FOOTER_LINKS,
    footerMsg:
      languageData?.footer_link_msg || 'By continuing, you agree to our ',
    termsAndCondition: languageData?.terms_service || 'terms of service',
    privacyPolicy: languageData?.privacy_policy || 'privacy policy',
    cookiePolicy: languageData?.cookie_policy || 'cookie policy',
    refundPolicy: languageData?.refund_policy || 'Refund policy',
    footerRegisterMsg:languageData?.by_submitting_text || 'By submitting, I agree to the'
  }

  FAQ_CONSTANTS = {
    ...FAQ_CONSTANTS,
    TITLE: languageData?.faqs || 'FAQs',
    REPORT_ISSUE: languageData?.report_an_issue || 'Report an issue',
    LOADING_TEXT: languageData?.faq_constants_loading_text || 'Loading FAQs...'
  }

  PUBLISH_PRIVATE_MESSAGE = {
    ...PUBLISH_PRIVATE_MESSAGE,
    PUBLISH:
      languageData?.publish_private_message_publish ||
      'Published successfully!',
    PRIVATE:
      languageData?.publish_private_message_private ||
      'Made private successfully!',
    PUBLISH_ERROR:
      languageData?.create_publish_update_failed || 'Failed to Publish Image',
    PRIVATE_ERROR:
      languageData?.publish_private_message_private_error ||
      'Failed to make private'
  }

  MODAL_INFO = {
    ...MODAL_INFO,
    MODAL_TEXT:
      languageData?.modal_info_modal_text ||
      'Please check your email and password and try again.',
    PHONE_ERROR:
      languageData?.modal_info_phone_error ||
      'Please check your mobile number and password and try again.',
    EMAIL_ERROR:
      languageData?.modal_info_modal_text ||
      'Please check your email and password and try again.'
  }


  MULTIPLE_OUTPUT_LABELS={
    ERROR_MESSAGES:languageData?.error_messages ||"Please fill in the details to continue.",
    FILE_ERROR_MESSAGE:languageData?.file_error_message || "No file to download.",
    URL_ERROR_MESSAGE:languageData?.url_error_message||"URL parse error.",
    SUCCESS_MESSAGE:languageData?.file_download_success_message||"File downloaded successfully!",
    DOWNLOAD_FAIL:languageData?.file_download_fail||"Unable to download file. It may be blocked by CORS.",
    URL_NOT_FOUND:languageData?.url_not_found||"Output media url not found.",
    TITLE_PROCEED:languageData?.create_title_required ||"Enter title to proceed.",
    DISCLAIMER:languageData?.disclaimer||"Disclaimer: This image is AI-generated for creative use only. The tool owners do not claim rights over the original voices or likenesses used.",
    REGENERATE_ALL_TITLE:languageData?.regenerate_all_dialog_title||"Regenerate all outputs?",
    DISCARD_TITLE:languageData?.discard_all_dialog_title||"Discard all outputs?",
    REGENERATE_ALL_MESSAGE:languageData?.regenerate_all_dialog_message||"This will create new results for all outputs using your current settings. Each result will use 1 credit.",
    REGENERATE_ALL_CONFIRM:languageData?.regenerate_all_dialog_okay_button||"Regenerate All",
    DISCARD_MESSAGE:languageData?.discard_all_dialog_message||"This will permanently remove the creations you just generated",
    DISCARD_ALL:languageData?.discard_all_dialog_okay_button||"Discard All",
    TELL_US_MORE:languageData?.ai_tool_tell_us_more ||"Tell us more",
    TELL_US_MORE_DESCRIPTION:languageData?.ai_tool_feedback_details_prompt || "Kindly share more details that will help us improve the experience",
    FEED_BACK_PLACEHOLDER:languageData?.ai_tool_feedback_additional_details||"Feel free to add specific details (optional)",
    ADD_BG_MUSIC:languageData?.add_bg_music||"Add background music",
    GENERATION_FAILED:languageData?.generation_failed||"Generation Failed",
    CATEGORY_TITLE:languageData?.category_title||"Category Name",
    OUTPUTS:languageData?.outputs||"Outputs",
    APPLYING_MUSIC:languageData?.applying_music||"applying music..."
  }
  SETTINGS_LABELS = {
    ...SETTINGS_LABELS,
    NOTIFICATION: 'notification',
    NOTIFICATIONS: 'notifications',
    UPDATE_EMAIL: 'update email',
    UPDATE_PASSWORD: 'update password',
    THEME: 'theme',
    FAQ: "faqs",
    FEEDBACK_AND_SUPPORT: 'feedback and support',
    SUBMIT_FEEDBACK: 'submit feedback',
    REPORT_A_PROBLEM: 'report a problem',
    REPORT_PROBLEM: 'report problem',
    LOG_OUT: 'log out',
    LOGOUT: 'logout',
    DELETE_ACCOUNT: 'delete account',
    TERMS_OF_USE: 'terms of use',
    viewBalance: 'view balance',
    redeemReward: 'redeem rewards',
    transactions: 'transactions',
    BLOCKED_USERS: 'blocked users',
    SUBSCRIPTION_PLAN: 'subscription plans',
    SUBSCRIPTION_HISTORY: 'subscription history',
    MANAGE_PAYMENT_METHOD: 'manage payment methods',
    PRIVACY_POLICY: 'privacy policy',
    CONSENT: 'consent',
    CONSENT_AND_PERMISSIONS: 'consent & permissions',
    LANGUAGE: 'language',
    VERSION: 'version'
  }

  SETTINGS_SECTIONS = {
    ...SETTINGS_SECTIONS,
    CONTROLS: languageData?.settings_section_controls || 'controls'
  }

  FILTER_TEXT = {
    ...FILTER_TEXT,
    FILTER_DATA:
      languageData?.filter_text_filter_data ||
      'Quickly narrow down your transactions by type to find exactly what you need.',
    type: languageData?.filter_text_type || 'Type',
    SelectAll: languageData?.filter_text_select_all || 'Select All'
  }

  VoiceLanguage = [
    { value: 'english', label: languageData?.language_english || 'English' }
  ]

  INVITE_MESSAGES = {
    ...INVITE_MESSAGES,
    CREATED: languageData?.invite_message_created || 'created',
    DEVICE_NOT_INVITED:
      languageData?.invite_message_device_not_invited ||
      'device is not invited',
    INVALID_COUPON:
      languageData?.invite_message_invalid_coupon ||
      'coupon expired or consumed',
    NOT_EXISTED_COUPON:
      languageData?.invite_message_coupon_not_exist ||
      'coupon code does not exist',
    ALREADY_INVITED: 'device already invited'
  }

  TOAST_MSG = {
    ...TOAST_MSG,
    copied: languageData?.copied || 'Copied'
  }

  CARD_DETAILS = {
    ...CARD_DETAILS,
    nameOnCard:
      languageData?.card_details_name_on_card || 'Name on card is required'
  }

  PAYMENT_PAGE_INFO = {
    PAYMENT_WEB_HEADER:
      languageData?.payment_web_header || 'You are just one step away',
    PAYMENT_HEADER: languageData?.choose_payment || 'Choose payment method',
    PAYMENT_SUB_HEADER:
      languageData?.available_options ||
      'Following options are available in your country',
    PAYMENT_DISCLAMER:
      languageData?.auto_renew ||
      'Your subscription will be auto renewed after every billing period using the selected payment method.',
    PAYMENT_INFO:
      languageData?.payment_info ||
      'You will be charged a refundable amount of ₹1 to validate your card and ₹25 to validate your UPI. The ₹25 charge is a mandatory minimum transaction fee set by UPI, and the full amount will be refunded within 5-7 business days. Please fill in your card/UPI details. Your subscription price will be deducted only after the offer period ends.',
    PAY_BY_UPI: languageData?.pay_by_upi || 'Pay by UPI',
    PAY_BY_CARD: languageData?.pay_by_card || 'Pay by Card',
    PAY_BY_CARD_LABEL:
      languageData?.pay_by_card_label || 'Credit or Debit Card',
    PAY_BY_UPI_LABEL: 'UPI',
    LOADING_PAYMENT_DETAILS:
      languageData?.loading_payment_details || 'Loading payment details...',
    ENTER_PROMO_CODE: languageData?.enter_promo_code || 'Enter Promo Code',
  }

  SUCCESS_MESSAGE = {
    PAYMENT_SUCCESS: languageData?.success_payment || 'Payment successful!',
    CONTENT_SAVED:
      languageData?.success_content_saved || 'Content saved successfully!',
    CONTENT_REMOVED:
      languageData?.success_content_removed || 'Content removed from saves',
    SAVED_TO_DASHBOARD:
      languageData?.saved_to_my_dashboard || 'Saved to My Dashboard',
    UNFOLLOWED: languageData?.success_unfollowed || 'Unfollowed successfully',
    FOLLOWED: languageData?.success_followed || 'Followed successfully'
  }

  PASSWORD_VALIDATION = {
    MIN_LENGTH:
      languageData?.password_min_length ||
      'Password must be at least 8 characters.',
    MAX_LENGTH:
      languageData?.password_max_length ||
      'Password cannot exceed 64 characters.'
  }

  EROS_LABEL = languageData?.eros_label || 'EROS'

  WORKSPACE_RENAME = {
    TITLE: languageData?.workspace_rename_title || 'Rename Workspace',
    PLACEHOLDER:
      languageData?.workspace_rename_placeholder || 'Enter workspace name',
    DISCARD_CHANGES:
      languageData?.workspace_discard_title || 'Discard Workspace?',
    DISCARD_MESSAGE:
      languageData?.workspace_discard_message ||
      'Are you sure you want to discard this workspace? This action cannot be undone.'
  }

  ACCOUNT_CREATION_SUCCESS = {
    TITLE:
      languageData?.account_creation_success_title ||
      'Account Created Successfully',
    SUBTITLE:
      languageData?.account_creation_success_subtitle ||
      'You can set up your profile now for a more tailored experience.',
    BUTTON: languageData?.account_creation_success_button || 'Set Up Profile',
    Maybe_Later:
      languageData?.account_creation_success_maybe_later || 'Maybe Later'
  }

  SUPER_APP_FOOTER = [
    {
      title: languageData?.footer_eros_universe_title || 'Eros Universe',
      links: [
        {
          label: languageData?.footer_eros_innovation || 'Eros Innovation',
          href: 'https://erosinnovation.com/'
        },
        { label: languageData?.footer_about || 'About', href: '#' },
        { label: languageData?.footer_blog || 'Blog', href: '#' },
        { label: languageData?.footer_help || 'Help', href: '#' },
        {
          label: languageData?.footer_privacy || 'Privacy',
          href: '/privacy'
        },
        { label: languageData?.footer_terms || 'Terms', href: '/terms' },
        {
          label:
            languageData?.footer_privacy_preferences ||
            'Privacy Preferences',
          href: '#cookie-preferences'
        }
      ]
    },
    {
      title: languageData?.footer_products_title || 'Products',
      links: [
        { label: languageData?.footer_eros_play || 'Eros Play', href: '#' },
        {
          label: languageData?.footer_eros_create || 'Eros Create',
          href: '/home'
        },
        {
          label: languageData?.footer_eros_eternal || 'Eros Eternal',
          href: '/eternal'
        },
        {
          label: languageData?.footer_eros_wallet || 'Eros Wallet/Rewards',
          href: '#'
        },
        { label: languageData?.footer_eros_world || 'Eros World', href: '#' },
        { label: languageData?.footer_eros_os || 'Eros OS', href: '#' },
        {
          label: languageData?.footer_cal || 'Creative Arts Launchpad (CAL)',
          href: '#'
        }
      ]
    },
    {
      title: languageData?.footer_support_title || 'Support',
      links: [
        { label: languageData?.footer_help_center || 'Help Center', href: '#' },
        { label: languageData?.footer_contact_us || 'Contact Us', href: '#' },
        { label: languageData?.footer_tutorials || 'Tutorials', href: '#' }
      ]
    },
    {
      title: languageData?.footer_legal_title || 'Legal',
      links: [
        {
          label: languageData?.footer_privacy_policy || 'Privacy Policy',
          href: '/privacy'
        },
        {
          label: languageData?.footer_terms_service || 'Terms of Service',
          href: '/terms'
        }
      ]
    }
  ]

  STATUS = {
    COMPLETED: languageData?.voice_clone_status_completed || 'completed',
    FAILED: languageData?.voice_clone_status_failed || 'failed',
    PENDING: languageData?.status_pending || 'pending'
  }

  QUEUE_NOTIFICATION = {
    TITLE_QUEUING_IN_PROCESS:
      languageData?.queue_notification_widget_title_queuing_in_process ||
      'Queuing In process',

    TITLE_IN_QUEUING:
      languageData?.queue_notification_widget_title_queuing_in_process ||
      'Queuing In process',

    CLOSE_ALL:
      languageData?.queue_notification_widget_close_all || 'Close All',

    DISMISS:
      languageData?.dismiss_toast_aria || 'Dismiss',

    PROCESSING_FAILED:
      languageData?.queue_notification_widget_processing_failed ||
      'Processing Failed',

    PROCESSING_COMPLETE:
      languageData?.queue_notification_widget_processing_complete ||
      'Processing complete',

    VIEW_VIDEO:
      languageData?.queue_notification_widget_view_video || 'View video →',

    VIEW_AUDIO:
      languageData?.queue_notification_widget_view_audio || 'View audio →',

    VIEW_IMAGE:
      languageData?.queue_notification_widget_view_image || 'View image →',

    VIEW_ERROR:
      languageData?.queue_notification_widget_view_error || 'View error →',

    RETRY:
      languageData?.retry || 'Retry',

    FALLBACK_ERROR:
      languageData?.queue_notification_widget_fallback_error ||
      'Something went wrong. Check your connection.',

    JUST_NOW:
      languageData?.just_now || 'Just now',

    ALL_OUTPUTS_READY:
      languageData?.queue_notification_widget_all_outputs_ready || 'All % outputs ready',

    READY: languageData?.queue_notification_widget_ready || 'Ready'
  };

  HARDCODED_STRINGS = {
    ALREDY_HAVE_ACCOUNT: languageData?.already_have_account || 'Already have an account?',
    COMING_SOON: languageData?.superapp_home_coming_soon || "coming soon",
    AND: languageData?.and_text || 'and',
    CREATE_TITLE: languageData?.create_your_creative_playground_tagline || 'Your Creative Playground',
    CREATE_SUB_TITLE: languageData?.create_now_supercharged_by_ai_promo_text || 'Now supercharged by AI',
    TRANDIN_IN_CREATE: languageData?.trending_in_create || 'Trending in create',
    REALS_TITLE: languageData?.REALS_TITLE || 'Reels for you',
    TODAYS_HIGHLIGHTS: languageData?.todays_highlights || "Today's highlights",
    EXPLORE: languageData?.explore || 'Explore', // cant have this
    TRY_AGAIN_LATTER: 'try again later.',
    SELECT_A_DATE: languageData?.SELECT_A_DATE || 'Select a date',
    MIN_8_CHAR: languageData?.MIN_8_CHAR || 'Minimum 8 characters.',
    AT_LEAST_UPPERCASE: languageData?.AT_LEAST_UPPERCASE || 'At least one uppercase letter.',
    AT_LEAST_LOWERCASE: languageData?.AT_LEAST_LOWERCASE || 'At least one lowercase letter.',
    AT_LEAST_NUMBER: languageData?.AT_LEAST_NUMBER || 'At least one number.',
    AT_LEAST_SPECIAL_CHAR: languageData?.AT_LEAST_SPECIAL_CHAR || 'At least one special character.',
    COMPLETE_THE_OTP: languageData?.COMPLETE_THE_OTP || 'Please enter complete the OTP.',
    OTP_IS_EXPIRED: languageData?.OTP_IS_EXPIRED || 'OTP is expired.',
    OTP_VALID_FOR_ONLY: languageData?.OTP_VALID_FOR_ONLY || 'OTP is valid for only ',
    MINUTS: languageData?.MINUTS || 'minutes',

    INSTANT_FACE_SWAP: languageData?.INSTANT_FACE_SWAP || 'Instant Face Swap, endless fun',
    FACE_SWAP_DISCRIPTION: languageData?.FACE_SWAP_DISCRIPTION || 'Make realistic, funny face swaps in just a click with the magic of AI.',
    GENERATE: languageData?.GENERATE || 'Generate',
    EMAIL_DESCRIPTION: languageData?.add_you_email_bottom_sheet_description || 'You haven’t linked an email address yet. Add one to secure your account and recover it easily if needed',
    ADD_YOUR_EMAIL: languageData?.add_your_email || "Add Your Email",
    ADD_EMAIL: languageData?.add_email || "Add Email"
  }
  toolConfig = {
    [AI_TOOL_IDS.SCENE_SWAP]: {
      heading: languageData?.scene_swap || 'Scene Swap',
      title:
        languageData?.ai_tool_scene_swap_page_caption ||
        'New Vibe, New Background',
      desc:
        languageData?.ai_tool_scene_swap_page_caption_small ||
        'From simple to surreal, pick a background that fits the mood',
      showUploadBtn: true,
      showTrayData: true
    },

    [AI_TOOL_IDS.COLORIZE]: {
      heading: languageData?.colorize_help_create_mode_colorize || 'Colorize',
      title: languageData?.ai_tool_colorize_page_caption || 'Relive in Color',
      desc:
        languageData?.ai_tool_colorize_page_caption_small ||
        'Instantly add color with a touch of AI magic.',
      showUploadBtn: true,
      showTrayData: false
    },

    [AI_TOOL_IDS.FACE_SWAP]: {
      heading: languageData?.create_face_swap_screen || 'Face Swap',
      title: HARDCODED_STRINGS.INSTANT_FACE_SWAP,
      // languageData?.ai_tool_face_swap_page_caption ||
      // 'Instant face swaps, endless fun',
      desc: HARDCODED_STRINGS.FACE_SWAP_DISCRIPTION,
      // languageData?.ai_tool_face_swap_page_caption_small ||
      // 'Make realistic, funny face swaps in just a click with the magic of AI.',
      showUploadBtn: true,
      showTrayData: true
    }
  }
}

// -----------------------------------------------***********-----------------------------------------------------------
// -----------------------------------------------***********-----------------------------------------------------------
// -----------------------------------------------***********-----------------------------------------------------------
// -------------------- Place your constants in the function to make them support multilang ----------------------------
// -----------------------------------------------***********-----------------------------------------------------------
// -----------------------------------------------***********-----------------------------------------------------------
// -----------------------------------------------***********-----------------------------------------------------------



// Tailwind utility class constants used repeatedly across Search UI
const UI_CLASSES = {
  brandText: 'text-[#00B8F8]',
  brandBorder: 'border-[#00B8F8]',
  inputBg: 'bg-[#121212]',
  inputBorder: 'border-[#2A2A2A]'
}


/**Local Storage Variable */
const LOCAL_STORAGE = {
  THEME_PREF: 'app_theme_pref'
}

/** Player / DOM selectors */
const SELECTORS = {
  VIDEO_TAG: '.content-detail-player video',
  MAIN_VIDEO_CONTAINER: 'mainVideoContainer'
}


/**Extensions */
const EXTENSIONS = {
  MP4: '.mp4',
  MOV: '.quicktime',
  JPG: '.jpg',
  PNG: '.png',
  JPEG: '.jpeg'
}

// Settings Routes Map
export const SETTINGS_ROUTES = {
  [SETTINGS_LABELS.NOTIFICATION]: '/setting/notifications',
  [SETTINGS_LABELS.NOTIFICATIONS]: '/setting/notifications',
  [SETTINGS_LABELS.UPDATE_EMAIL]: '/setting/update-email',
  [SETTINGS_LABELS.UPDATE_PASSWORD]: '/setting/update-password',
  [SETTINGS_LABELS.THEME]: '/setting/theme',
  [SETTINGS_LABELS.FAQ]: '/faq',
  // [SETTINGS_LABELS.FEEDBACK_AND_SUPPORT]: '/feedback',
  // [SETTINGS_LABELS.SUBMIT_FEEDBACK]: '/feedback',
  [SETTINGS_LABELS.REPORT_A_PROBLEM]: '/report',
  [SETTINGS_LABELS.REPORT_PROBLEM]: '/report',
  [SETTINGS_LABELS.CONSENT]: '/setting/consent',
  [SETTINGS_LABELS.CONSENT_AND_PERMISSIONS]: '/setting/consent'
}

// External Links Map
export const SETTINGS_EXTERNAL_LINKS = {
  [SETTINGS_LABELS.TERMS_OF_USE]: '/terms',
  [SETTINGS_LABELS.PRIVACY_POLICY]: '/privacy'
}

// Action Items (items that trigger actions instead of navigation)
export const SETTINGS_ACTION_ITEMS = [
  SETTINGS_LABELS.LOG_OUT,
  SETTINGS_LABELS.LOGOUT,
  SETTINGS_LABELS.DELETE_ACCOUNT
]


const CONTENT_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio'
}


const NOTIFICATION_COUNT = 3
const PROFILE_BADGE = '99+'


const Icons = [
  'FaMore',
  'FafaceSwap',
  'FaColorize',
  'FaBackgroundChange',
  'FaTextToImage',
  'FaTextToVideo',
  'FaVoiceRemix',
  'FaVoiceClone',
  'FaActionGeneration',
  'FaImageToVideo',
  'FaMotionControl',
  'FaSongGeneration',
  'FaVideoDubbing'
]

/** Progress */
const COMPLETION_PROGRESS = 100.0

/** Time OUT values */
const TIMEOUT = {
  VIDEO_POLLING: 3000,
  IMAGE_POLLING: 800,
  BACKGROUND_POLLING: 1500,
  FETCH_DELAY: 500
}

/**Icons */
const ICONS = {
  CLOSE: 'x',
  ADD: '+'
}

const ADD_AUDIO_DATA = {
  FILTER_BY: 'Filter By',
  CHOOSE_GENRE: 'Choose Genre',
  CHOOSE_MOVIE: 'Choose Movie'
}

const QUEUE_NOTIFICATION_CONFIG = {
  TITLE_QUEUING_IN_PROCESS: 'Queuing In process',
  TITLE_IN_QUEUING: 'Queuing In process',
  CLOSE_ALL: 'Close All',
  DISMISS: 'Dismiss',
  PROCESSING_FAILED: 'Processing Failed',
  PROCESSING_COMPLETE: 'Processing complete',
  VIEW_VIDEO: 'View video →',
  VIEW_AUDIO: 'View audio →',
  VIEW_IMAGE: 'View image →',
  VIEW_ERROR: 'View error →',
  RETRY: 'Retry',
  FALLBACK_ERROR: 'Something went wrong. Check your connection.',
  JUST_NOW: 'Just now'
}

const COLORIZE_CONFIG = {
  TITLE: 'Colorize',
  TOOL_NAME: 'colorize',
  DISPLAY_NAME: 'Colorize',
  UPLOAD_IMAGE_ERROR: 'Please upload an image to colorize.',
  QUEUING_MESSAGE: 'Queuing in process',
  PROCESSING_TITLE: 'Colorizing image...',
  DEFAULT_MODE: 'colorize'
}

const FACE_SWAP_CONFIG = {
  TITLE: 'Face Swap',
  TOOL_NAME: 'face_swap',
  DISPLAY_NAME: 'Face Swap',
  UPLOAD_IMAGE_ERROR: 'Please select a template and upload your face.',
  QUEUING_MESSAGE: 'Queuing in process',
  PROCESSING_TITLE: 'Swapping faces...',
  FACE_DETECTION_FAILED: 'Face detection failed',
  NO_FACES_FOUND: 'No faces found in the image. Please upload a clear photo.',
  TARGET_FACES_DETECTED: 'Faces detected successfully.'
}

const SCENE_SWAP_CONFIG = {
  TITLE: 'Scene Swap',
  TOOL_NAME: 'background_change',
  DISPLAY_NAME: 'Scene Swap',
  UPLOAD_IMAGE_ERROR: 'Please upload an image to swap scene.',
  QUEUING_MESSAGE: 'Queuing in process',
  PROCESSING_TITLE: 'Swapping scene...',
  DETECTING_BACKGROUND: 'Detecting background...',
  BACKGROUND_DETECTED: 'Background detected successfully.'
}
DASHBORD_CONTENT={
  EROSID_DESCRIPTION: languageData?.eros_card_ready_message || 'Your Eros card is ready. Verify your details below and tap Save to securely store it in your digital wallet for quick access anytime.',
  SAVE_EROS_HEADER:languageData?.save_your_eros||'Save Your Eros',
  SAVE_EROS_CARD_HEADR:languageData?.save_your_eros_card || 'Save your Eros card',
  HOLDER_SINCE: languageData?.desc||'Holder since',
  EROS_ID_LABEL:languageData?.desc || 'Eros ID',
  MEMBER_SINCE:languageData?.member_since|| 'Member since',
  INFO_EROSID:languageData?.eros_id_never_changes ||'Your Eros ID never changes, even if everything else does. It is how anything you make stays tied to you.',
  SAVE_CARD:languageData?.save_card||"Save card",
  EDIT_COVER:languageData?.edit_cover || ' Edit cover',
  SUCCESS_COPY_EROS_ID:languageData?.desc || 'Succefully copied eros id',
  FAIL_COPY_EROS_ID:languageData?.desc ||'Unable to copy eros id',
  UPLOAD_AN_IMAGE:languageData?.upload_an_image || 'Upload an image',
  USE_THIS_AS_BANNER:languageData?.use_this_banner || 'Use this banner',
  EROS_ID_CARD: languageData?.eros_id_card|| 'Eros Id card',
  YOUR_EROS:languageData?.your_eros || 'Your Eros',
  BANNER:languageData?.banner || 'Banner',
  PRESETS:languageData?.presets || 'Presets'
}
export {
  ADD_AUDIO_DATA,
  TALKING_AVATAR,
  VOICE_CLONE,
  INVITE_STATUS_MESSAGES,
  INVITE_MESSAGES,
  RECAPTCHA_KEY,
  TAB_LABELS,
  TABS,
  CONTENT_TYPE,
  HEADER,
  ALT_SPLASH_LOGO,
  BUTTON_LABELS,
  PAGE_LABELS,
  COMMON_MESSAGES,
  PICK_FROM_LIST,
  USER_UPLOAD,
  KEYWORDS,
  COMPLETION_PROGRESS,
  STATUS,
  QUEUE_NOTIFICATION,
  TIMEOUT,
  ICONS,
  IMAGE_ALT,
  PAGE_NAME,
  SEARCH_TABS,
  SEARCH_TAB_LIST,
  SEARCH_COPY,
  UI_CLASSES,
  ERROR_MESSAGES,
  FOLLOW_DETAILS,
  EXTENSIONS,
  SELECTORS,
  FALLBACK_DATA,
  SPLASH_SESSION_KEY,
  NOTIFICATION_COUNT,
  PROFILE_BADGE,
  Icons,
  DELETE_ACCOUNT_TEXT,
  BLOCKED_USER_TEXT,
  THEME_COPY,
  THEME_OPTIONS,
  LOCAL_STORAGE,
  MY_WALLET_INFO,
  SUBSCRIPTION_PLAN_INFO,
  SUBSCRIPTION_PLAN_TABLE_INFO,
  SUBSCRIPTION_STATUS,
  PAYMENT_PAGE_INFO,
  PROFILE_PAGE,
  SIDE_POPUP,
  //   NOTIFICATION,
  NOTIFICATION_DISABLE_MESSAGES,
  PUBLISH_BAR,
  VERIFY_SIGNUP_DATA,
  REMIX_BOTTOMSHEET,
  VOICE_REMIX_TOOLTIP,
  QUEUE_NOTIFICATION_CONFIG,
  COLORIZE_CONFIG,
  FACE_SWAP_CONFIG,
  SCENE_SWAP_CONFIG,
  FOOTER_LINKS,
  PUBLISH_PRIVATE_MESSAGE,
  EDIT_PROFILE_PAGE,
  BACK_TO_SIGN_IN,
  REGISTER_PAGE_DATA,
  DASHBORD_CONTENT
  //   AIToolRoutes,
  // LOREM,
}

export const MINI_APP_IDS = {
  CREATE: 'create',
  WELLNESS: 'wellness',
  CONSOLE: 'console'
}

export const APP_ID_TO_SCOPE = {
  [MINI_APP_IDS.CREATE]: 'Eros Create',
  [MINI_APP_IDS.WELLNESS]: 'Eros Wellness',
  [MINI_APP_IDS.CONSOLE]: 'Eros Console'
}

export const MINI_APP_DOT_COLORS = {
  [MINI_APP_IDS.CREATE]: '#E05285',
  [MINI_APP_IDS.WELLNESS]: '#2ED3B7',
  [MINI_APP_IDS.CONSOLE]: '#00B8F8'
}

export const isScopeMatch = (itemScope, appId) => {
  if (!itemScope || !appId) return false
  const normalized = itemScope.toLowerCase().replace(/[\s_-]+/g, '')
  if (appId === MINI_APP_IDS.CREATE) {
    return (
      normalized === 'eroscreate' ||
      normalized === 'create' ||
      normalized === 'creator'
    )
  }
  if (appId === MINI_APP_IDS.WELLNESS) {
    return normalized === 'eroswellness' || normalized === 'wellness'
  }
  if (appId === MINI_APP_IDS.CONSOLE) {
    return normalized === 'erosconsole' || normalized === 'console'
  }
  return false
}

export const getAppScope = (appId, availableData) => {
  if (availableData?.results && Array.isArray(availableData.results)) {
    const matched = availableData.results.find((item) =>
      isScopeMatch(item.scope, appId)
    )
    if (matched?.scope) {
      return matched.scope
    }
  }
  return APP_ID_TO_SCOPE[appId] || 'Eros Create'
}
